/* eslint-disable */

export interface AnnenForsikringWebDTO extends ForsikringWebDTO {
    dekning: ForsikringDekningDTO;
    type: "AnnenForsikring";
}

export interface AttentionMessageSporsmalDTO extends SporsmalDTO {
    attentionMessageType: AttentionMessageType;
    iconType?: string;
    id: SporsmalId;
    linkItem?: LinkItemDTO;
    sporsmaltype: "AttentionMessage";
    tekst: string;
    tittel?: string;
}

export interface AttentionMessageSvarDTO extends SvarDTO {
    type: "AttentionMessage";
}

export interface AutoCloseable {
}

export interface AvtaleInfoWebDTO {
    kundeHasOtherAvtaler: boolean;
    privatAvtale: boolean;
}

export interface BesvarteSporsmalStateDTO {
    json: string;
    kundenummer?: string;
    skademeldingstype: Skademeldingstype;
}

export interface BilmerkeDTO {
    name: string;
    value: string;
}

export interface BlindveiSporsmalDTO extends SporsmalDTO {
    id: SporsmalId;
    ingress: string;
    sporsmaltype: "Blindvei";
    tittel: string;
}

export interface BodyPart {
    contentDisposition: ContentDisposition;
    entity: any;
    headers: any;
    mediaType: MediaType;
    messageBodyWorkers: MessageBodyWorkers;
    parameterizedHeaders: any;
    parent: MultiPart;
    providers: Providers;
}

export interface BygningObjektWebDTO {
    objektnummer: number;
    objekttype: BygningObjektType;
    visningsTekst: string;
}

export interface BygningforsikringWebDTO extends ForsikringWebDTO {
    dekning: ForsikringDekningDTO;
    objekter: BygningObjektWebDTO[];
    type: "Bygningforsikring";
}

export interface CardSporsmalDTO extends SporsmalDTO {
    cardType: CardType;
    id: SporsmalId;
    linkItem?: LinkItemDTO;
    richIconType?: string;
    sporsmaltype: "Card";
    text: string;
    tittel: string;
}

export interface CheckboxAlternativDTO {
    id: SvarId;
    tekst: string;
}

export interface CheckboxSporsmalDTO extends SporsmalDTO {
    alternativer: CheckboxAlternativDTO[];
    checkboxType?: CheckboxType;
    id: SporsmalId;
    ingress?: string;
    sporsmaltype: "Checkbox";
    tekst: string;
}

export interface CheckboxSvarDTO extends SvarDTO {
    type: "Checkbox";
    valgteAlternativer: SvarId[];
}

export interface Closeable extends AutoCloseable {
}

export interface ContentDisposition {
    creationDate: DateAsString;
    fileName: string;
    modificationDate: DateAsString;
    parameters: { [index: string]: string };
    readDate: DateAsString;
    size: number;
    type: string;
}

export interface DatoSvarDTO extends SvarDTO {
    svarTekst: DateAsString;
    type: "Dato";
}

export interface DatoTrigger {
    acceptDateBeforeOrAfter: AcceptDateBeforeOrAfter;
    dateToCompareWith: DateAsString;
}

export interface DatosporsmalDTO extends SporsmalDTO {
    allowFutureDate: boolean;
    id: SporsmalId;
    ingress: string;
    sporsmaltype: "Dato";
    tittel: string;
}

export interface ElsparkesykkelforsikringWebDTO extends ForsikringWebDTO {
    dekning: ForsikringDekningDTO;
    type: "Elsparkesykkelforsikring";
}

export interface EttersendingDTO {
    informasjon: SporsmalAndSvar;
    kundeEpost: SporsmalAndSvar;
    skadeEllerForsikringsnummer: SporsmalAndSvar;
    vedlegg: UploadedVedleggDTO;
}

export interface ExternalLinkDTO extends LinkDTO {
    url: string;
    urlType: "ExternalLink";
}

export interface FeilmeldingDTO {
    tekst: string;
    tittel: string;
}

export interface FilopplastingSporsmalDTO extends SporsmalDTO {
    dropFileText?: string;
    id: SporsmalId;
    ingress: string;
    sporsmaltype: "Filopplasting";
    tekst: string;
    valideringstype: Valideringstype;
    withDirectUpload: boolean;
}

export interface FormDataMultiPart extends MultiPart {
    fields: { [index: string]: any[] };
}

export interface ForsikringObjekterCheckboxSporsmalDTO extends SporsmalDTO {
    id: SporsmalId;
    ingress?: string;
    sporsmaltype: "ForsikringObjekterCheckbox";
    tekst: string;
}

export interface ForsikringObjekterCheckboxSvarDTO extends SvarDTO {
    type: "ForsikringObjekterCheckbox";
    valgteObjekter: ValgtForsikretObjektDTO[];
}

export interface ForsikringPeriodeWebDTO {
    from: DateAsString;
    to: DateAsString;
}

export interface ForsikringSvarDTO extends SvarDTO {
    forsikringsnumerFraAlternativ?: string;
    forsikringsnummerFantIkkeRiktig?: string;
    forsikringstekst?: string;
    svar: ForsikringDekningDTO;
    type: "Forsikring";
    undertekst?: string;
}

export interface ForsikringWebDTO {
    forsikringsnummer: string;
    forsikringstekst?: string;
    info?: string;
    periode?: ForsikringPeriodeWebDTO;
    produkt: Forsikringsprodukt;
    type: "Motorforsikring" | "Reiseforsikring" | "Bygningforsikring" | "Elsparkesykkelforsikring" | "AnnenForsikring";
    versjon: number;
    visningstekst: string;
}

export interface Forsikringsnummer extends Verditype {
    type: ForsikringsnummerType;
}

export interface ForsikringsnummerSporsmalDTO extends SporsmalDTO {
    id: SporsmalId;
    ingress?: string;
    sporsmaltype: "Forsikringsnummer";
    tekst: string;
}

export interface ForsikringsnummerSvarDTO extends SvarDTO {
    forsikringsnummer: string;
    type: "Forsikringsnummer";
}

export interface ForsikringsporsmalDTO extends SporsmalDTO {
    finnerIkkeRiktigForsikringAlternativTekst?: string;
    forsikringsprodukterPriority?: ForsikringsprodukterPriority;
    id: SporsmalId;
    info?: string;
    ingenForsikringHeader: string;
    ingenForsikringTekst: string;
    ingress?: string;
    sporsmaltype: "Forsikring";
    tekst: string;
}

export interface ForsikringsprodukterPriority {
    excludedForsikringsprodukterIfPrioritizedArePresent: Forsikringsprodukt[];
    prioritizedForsikringsprodukter: Forsikringsprodukt[];
}

export interface HarValue<T> {
    value: T;
}

export interface InformasjonSporsmalDTO extends SporsmalDTO {
    id: SporsmalId;
    ingress: string;
    sporsmaltype: "Informasjon";
    svgCard?: SvgCardType;
    tittel: string;
}

export interface InformasjonSvarDTO extends SvarDTO {
    type: "Informasjon";
}

export interface InternalLinkDTO extends LinkDTO {
    url: string;
    urlType: "InternalLink";
}

export interface KlageDTO {
    svar: SvarDTOUnion[];
    vedlegg: UploadedVedleggDTO;
}

export interface KlageResultWebDTO {
    message: string;
    status: KlageStatusWebDTO;
}

export interface KontaktInfoInvolvertSporsmalDTO extends SporsmalDTO {
    id: SporsmalId;
    ingress: string;
    sporsmaltype: "KontaktInfoInvolvert";
    tittel: string;
}

export interface KontaktInfoInvolvertSvarDTO extends SvarDTO {
    adresse?: string;
    fodselsdato?: string;
    mobilnummer?: string;
    navn: string;
    type: "KontaktInfoInvolvert";
}

export interface KontaktInfosporsmalFieldLabels {
    epost: string;
    fodselsnummer: string;
    fulltNavn: string;
    kontonummer: string;
    mobilnummer: string;
    organisasjonsnummer: string;
}

export interface KontaktinfosporsmalDTO extends SporsmalDTO {
    askForBankkontonummer: boolean;
    id: SporsmalId;
    kontaktInfosporsmalFieldLabels: KontaktInfosporsmalFieldLabels;
    sporsmaltype: "Kontaktinfo";
    tekst: string;
}

export interface KontaktinfosvarDTO extends SvarDTO {
    bankkontonummer: string;
    epost: string;
    identifikator: string;
    identifikatorType: IdentifikatorType;
    mobilnummer: string;
    navn: string;
    showFodselsnummer: boolean;
    type: "Kontaktinfo";
}

export interface KredittkortnummerSporsmalDTO extends SporsmalDTO {
    id: SporsmalId;
    ingress?: string;
    sporsmaltype: "Kredittkortnummer";
    tekst: string;
}

export interface KredittkortnummerSvarDTO extends SvarDTO {
    kredittkortnummer: string;
    type: "Kredittkortnummer";
}

export interface KundeWebDTO {
    epost: string;
    etternavn: string;
    fornavn: string;
    forsikringer: ForsikringWebDTOUnion[];
    kundenummer: string;
    mobilnummer: string;
    offentligId: string;
}

export interface Kundenummer extends Verditype {
}

export interface LinkDTO {
    urlType: "SitecoreLink" | "InternalLink" | "ExternalLink";
}

export interface LinkItemDTO {
    link: LinkDTOUnion;
    linkType: string;
    tekst: string;
}

export interface LogDTO {
    data: LogDataDTO;
    message: string;
}

export interface LogDataDTO {
    error: string;
    skadetype?: Skademeldingstype;
    userAgent: string;
    userId: string;
}

export interface MediaType {
    parameters: { [index: string]: string };
    subtype: string;
    type: string;
    wildcardSubtype: boolean;
    wildcardType: boolean;
}

export interface MeldSkadeResultWebDTO {
    kundeforholdType: KundeforholdType;
    skadeApnetOnInnmelder: boolean;
    skadenummer?: Skadenummer;
}

export interface MessageBodyWorkers {
}

export interface ModalSporsmallDTO extends SporsmalDTO {
    id: SporsmalId;
    modalType: ModalType;
    sporsmaltype: "Modal";
}

export interface ModalSvarDTO extends SvarDTO {
    type: "Modal";
}

export interface MotorforsikringWebDTO extends ForsikringWebDTO {
    dekning: ForsikringDekningDTO;
    kjoretoyType: string;
    registreringsar: number;
    type: "Motorforsikring";
}

export interface MultiPart extends BodyPart, Closeable {
    bodyParts: BodyPart[];
}

export interface OffentligId extends HarValue<string> {
    value: string;
}

export interface OppsummeringForsikringOpplysningerDTO {
    bonus?: SkademeldingBonusDTO;
    egenandel?: SkademeldingEgenandelDTO;
    kjorelengde?: SkademeldingKjorelengdeDTO;
}

export interface Postnummer extends HarValue<string> {
    value: string;
}

export interface PostnummerSporsmalDTO extends SporsmalDTO {
    id: SporsmalId;
    sporsmaltype: "Postnummer";
    tekst: string;
}

export interface PostnummmerSvarDTO extends SvarDTO {
    postnummer: string;
    poststed: string;
    type: "Postnummer";
}

export interface PoststedDTO {
    value: string;
}

export interface Providers {
}

export interface RadioAlternativDTO {
    feilmelding?: FeilmeldingDTO;
    id: SvarId;
    oppsummeringsInfo?: string;
    tekst: string;
    undertekst?: string;
}

export interface RadioSvarDTO extends SvarDTO {
    svarId: SvarId;
    type: "Radio";
}

export interface RadiosporsmalDTO extends SporsmalDTO {
    alternativer: RadioAlternativDTO[];
    id: SporsmalId;
    info?: string;
    ingress?: string;
    radioType?: RadioType;
    sporsmaltype: "Radio";
    tekst: string;
}

export interface ReiseforsikringWebDTO extends ForsikringWebDTO {
    dekning: ForsikringDekningDTO;
    type: "Reiseforsikring";
}

export interface SelectAlternativDTO {
    id: SvarId;
    tekst: string;
}

export interface SelectSporsmalDTO extends SporsmalDTO {
    alternativer: SelectAlternativDTO[];
    defaultOptionText: string;
    id: SporsmalId;
    ingress?: string;
    sporsmaltype: "Select";
    tekst: string;
}

export interface SelectSvarDTO extends SvarDTO {
    svarId: SvarId;
    type: "Select";
}

export interface SimpleKontaktinfosporsmalDTO extends SporsmalDTO {
    id: SporsmalId;
    ingress: string;
    sporsmaltype: "SimpleKontaktinfo";
    tittel: string;
}

export interface SimpleKontaktinfosvarDTO extends SvarDTO {
    fulltNavn: string;
    identifikator: string;
    mobilnummer: string;
    type: "SimpleKontaktinfo";
}

export interface SitecoreLinkDTO extends LinkDTO {
    configUrl: SitecoreConfigUrl;
    urlType: "SitecoreLink";
}

export interface SkadeWebDTO {
    produktnavn: string;
    skadedato?: DateAsString;
    skadenummer: Skadenummer;
    skadetypeDescription: string;
}

export interface SkadedatoAndForsikringSporsmalDTO extends SporsmalDTO {
    finnerIkkeRiktigForsikringAlternativTekst?: string;
    forsikringIngress?: string;
    forsikringTittel: string;
    forsikringsprodukterPriority?: ForsikringsprodukterPriority;
    id: SporsmalId;
    showFeilmelding: boolean;
    skadedatoIngress?: string;
    skadedatoTittel: string;
    sporsmaltype: "SkadedatoAndForsikring";
}

export interface SkadedatoAndForsikringSvarDTO extends SvarDTO {
    forsikringDekningSvar: ForsikringDekningDTO;
    forsikringsnummerFraAlternativ?: string;
    forsikringstekst?: string;
    skadedatoSvar: DateAsString;
    type: "SkadedatoAndForsikring";
}

export interface SkadelidtInfoSporsmalDTO extends SporsmalDTO {
    id: SporsmalId;
    infoTekstPrimary?: string;
    infoTextSecondary?: string;
    skadelidtInfoSporsmalFieldLabels: SkadelidtInfoSporsmalFieldLabels;
    sporsmaltype: "SkadelidtInfo";
    tittel: string;
}

export interface SkadelidtInfoSporsmalFieldLabels {
    fastlegeKontor: string;
    fodselsnummer: string;
    fulltNavn: string;
    hasBankIdOgMobil: string;
    hasBankIdOgMobilIngress: string;
    mobilnummer: string;
}

export interface SkadelidtInfoSvarDTO extends SvarDTO {
    fastlegeKontor: string;
    fodselsnummer: string;
    fulltNavn: string;
    hasBankIdOgMobil: boolean;
    mobilnummer: string;
    type: "SkadelidtInfo";
}

export interface SkademeldingBonusDTO {
    displayStatus: BonusDisplayStatusDTO;
    innhold: string;
    tittel: string;
}

export interface SkademeldingEgenandelDTO {
    displayStatus: EgenandelDisplayStatusDTO;
    innhold: string;
    tittel: string;
}

export interface SkademeldingKjorelengdeDTO {
    displayStatus: MaksKjorelengdeDisplayStatusDTO;
    innhold: string;
    tittel: string;
}

export interface Skadenummer extends Verditype {
    forsikringsnummer: Forsikringsnummer;
}

export interface SkadenummerSporsmalDTO extends SporsmalDTO {
    id: SporsmalId;
    ingress?: string;
    sporsmaltype: "Skadenummer";
    tekst: string;
}

export interface SkadenummerSvarDTO extends SvarDTO {
    skadenummer: string;
    type: "Skadenummer";
}

export interface SporsmalAndSvar {
    sporsmal: string;
    svar: string;
}

export interface SporsmalDTO {
    sporsmalKategori: SporsmalKategori;
    sporsmaltype: "Radio" | "Checkbox" | "Tekst" | "Dato" | "Kontaktinfo" | "KontaktInfoInvolvert" | "SimpleKontaktinfo" | "SkadelidtInfo" | "Utlegg" | "Tall" | "Informasjon" | "Forsikring" | "Verksted" | "Skadenummer" | "AttentionMessage" | "Card" | "Filopplasting" | "Postnummer" | "Blindvei" | "UtsattForgreining" | "SporsmalSide" | "SporsmalList" | "Select" | "SkadedatoAndForsikring" | "Forsikringsnummer" | "ForsikringObjekterCheckbox" | "Kredittkortnummer" | "Modal";
    type: SporsmalType;
}

export interface SporsmalListCollectionDTO {
    svar: SvarDTOUnion[];
}

export interface SporsmalListDTO extends SporsmalDTO {
    addCollectionButtonLabel: string;
    id: SporsmalId;
    ingress?: string;
    removeButtonLabel: string;
    sporsmalsflyt: SporsmalsflytDTO;
    sporsmaltype: "SporsmalList";
    subTittelFeltId: SporsmalId;
    tittel: string;
    tittelFeltId: SporsmalId;
}

export interface SporsmalListSvarDTO extends SvarDTO {
    svarCollection: SporsmalListCollectionDTO[];
    type: "SporsmalList";
}

export interface SporsmalSideDTO extends SporsmalDTO {
    id: SporsmalId;
    ingress?: string;
    showTitle: boolean;
    sporsmalsflyt: SporsmalsflytDTO;
    sporsmaltype: "SporsmalSide";
    svgCard?: SvgCardType;
    tittel: string;
}

export interface SporsmalsGruppeDTO {
    sporsmalList: SporsmalDTOUnion[];
    triggered: TriggeredByDTOUnion[];
}

export interface SporsmalsflytDTO {
    sporsmal: SporsmalDTOUnion[];
    triggered: SporsmalsGruppeDTO[];
}

export interface SporsmalsflytResultDTO {
    enableRoutingToFremtind: boolean;
    fremtindSkadeforsikringKonvertingStartDate: DateAsString;
    fremtindUrl?: string;
    sporsmalsflyt: SporsmalsflytDTO;
}

export interface SporsmalsflytSkademeldingDTO {
    oppsummeringForsikringOpplysninger?: OppsummeringForsikringOpplysningerDTO;
    skadetype: Skademeldingstype;
    svar: SvarDTOUnion[];
    vedlegg: UploadedVedleggDTO;
}

export interface SvarDTO {
    sporsmalId: SporsmalId;
    sporsmalType: SporsmalType;
    type: "Radio" | "Checkbox" | "Tekst" | "Dato" | "Kontaktinfo" | "KontaktInfoInvolvert" | "SimpleKontaktinfo" | "SkadelidtInfo" | "Utlegg" | "Tall" | "Informasjon" | "Forsikring" | "Verksted" | "SporsmalList" | "Skadenummer" | "AttentionMessage" | "Postnummer" | "Select" | "SkadedatoAndForsikring" | "Forsikringsnummer" | "ForsikringObjekterCheckbox" | "Kredittkortnummer" | "Modal";
}

export interface TallSvarDTO extends SvarDTO {
    svarTall: number;
    type: "Tall";
}

export interface TallsporsmalDTO extends SporsmalDTO {
    id: SporsmalId;
    ingress?: string;
    maleenhet: string;
    sporsmaltype: "Tall";
    tallValidation: TallValidationType;
    tekst: string;
}

export interface TekstSvarDTO extends SvarDTO {
    svarTekst: string;
    type: "Tekst";
}

export interface TekstsporsmalDTO extends SporsmalDTO {
    id: SporsmalId;
    ingress?: string;
    maxNumberOfCharacters?: number;
    placeholderText?: string;
    size: TextInputSize;
    sporsmaltype: "Tekst";
    tekst: string;
    valideringstype: Valideringstype;
}

export interface TriggeredByCheckboxDTO extends TriggeredByDTO {
    svarId: SvarId;
    triggertype: "TriggeredByCheckboxDTO";
}

export interface TriggeredByDTO {
    sporsmalId: SporsmalId;
    triggertype: "TriggeredByRadioDTO" | "TriggeredByCheckboxDTO" | "TriggeredBySelectDTO" | "TriggeredByTallDTO" | "TriggeredByForsikringDTO" | "TriggeredByDatoDTO" | "TriggeredByUtsattForgreiningDTO";
    type: TriggeredByType;
}

export interface TriggeredByDatoDTO extends TriggeredByDTO {
    datoTrigger: DatoTrigger;
    triggertype: "TriggeredByDatoDTO";
}

export interface TriggeredByForsikringDTO extends TriggeredByDTO {
    dekning: ForsikringDekningDTO;
    forsikringStartDate: ForsikringStartDateWebDTO;
    triggertype: "TriggeredByForsikringDTO";
}

export interface TriggeredByRadioDTO extends TriggeredByDTO {
    svarId: SvarId;
    triggertype: "TriggeredByRadioDTO";
}

export interface TriggeredBySelectDTO extends TriggeredByDTO {
    svarId: SvarId;
    triggertype: "TriggeredBySelectDTO";
}

export interface TriggeredByTallDTO extends TriggeredByDTO {
    belopLimit: number;
    operator: BelopOperator;
    triggertype: "TriggeredByTallDTO";
}

export interface TriggeredByUtsattForgreiningDTO extends TriggeredByDTO {
    triggers: TriggeredByDTOUnion[];
    triggertype: "TriggeredByUtsattForgreiningDTO";
}

export interface UploadedVedleggDTO {
    vedleggIds: VedleggId[];
}

export interface UtleggHeaderTekst {
    beskrivelse: string;
    dato: string;
    refusjon: string;
    utlegg: string;
}

export interface UtleggSporsmalDTO extends SporsmalDTO {
    headerTekst: UtleggHeaderTekst;
    id: SporsmalId;
    ingress: string;
    sporsmaltype: "Utlegg";
    tittel: string;
    utleggToggles: UtleggTogglesDTO;
    utleggType: UtleggType;
}

export interface UtleggTogglesDTO {
    includeAddNewUtleggslinjeButton: boolean;
    includeDato: boolean;
    includeRefusjon: boolean;
}

export interface UtleggslinjeDTO {
    beskrivelse: string;
    dagensPris: number;
    dato?: DateAsString;
    refundert: number;
    utgift: number;
    utleggType: UtleggType;
}

export interface UtleggsvarDTO extends SvarDTO {
    type: "Utlegg";
    utleggslinjer: UtleggslinjeDTO[];
}

export interface UtsattForgreiningSporsmalDTO extends SporsmalDTO {
    id: SporsmalId;
    sporsmaltype: "UtsattForgreining";
}

export interface ValgtForsikretObjektDTO {
    objektnavn: string;
    objektnummer: number;
}

export interface VedleggId {
    fileName: string;
    id: string;
}

export interface VedleggResultDTO {
    vedlegg: VedleggToUploadDTO[];
}

export interface VedleggToUploadDTO {
    fileSize: number;
    id: string;
    status: VedleggStatus;
    uploadId: string;
}

export interface Verditype {
    value?: string;
}

export interface VerkstedSporsmalDTO extends SporsmalDTO {
    bilmerker: BilmerkeDTO[];
    id: SporsmalId;
    sporsmaltype: "Verksted";
    tittel: string;
}

export interface VerkstedSvarDTO extends SvarDTO {
    bilmerke: BilmerkeDTO;
    postnummer: Postnummer;
    type: "Verksted";
    verksteder: VerkstedWebDTO[];
}

export interface VerkstedWebDTO {
    adresse: string;
    id: string;
    navn: string;
    postnummer: Postnummer;
    poststed: string;
    telefonnummer: string;
}

export type DateAsString = string;

export type ForsikringWebDTOUnion = MotorforsikringWebDTO | ReiseforsikringWebDTO | BygningforsikringWebDTO | ElsparkesykkelforsikringWebDTO | AnnenForsikringWebDTO;

export type LinkDTOUnion = SitecoreLinkDTO | InternalLinkDTO | ExternalLinkDTO;

export type SporsmalDTOUnion = RadiosporsmalDTO | CheckboxSporsmalDTO | TekstsporsmalDTO | DatosporsmalDTO | KontaktinfosporsmalDTO | KontaktInfoInvolvertSporsmalDTO | SimpleKontaktinfosporsmalDTO | SkadelidtInfoSporsmalDTO | UtleggSporsmalDTO | TallsporsmalDTO | InformasjonSporsmalDTO | ForsikringsporsmalDTO | VerkstedSporsmalDTO | SkadenummerSporsmalDTO | AttentionMessageSporsmalDTO | CardSporsmalDTO | FilopplastingSporsmalDTO | PostnummerSporsmalDTO | BlindveiSporsmalDTO | UtsattForgreiningSporsmalDTO | SporsmalSideDTO | SporsmalListDTO | SelectSporsmalDTO | SkadedatoAndForsikringSporsmalDTO | ForsikringsnummerSporsmalDTO | ForsikringObjekterCheckboxSporsmalDTO | KredittkortnummerSporsmalDTO | ModalSporsmallDTO;

export type SvarDTOUnion = RadioSvarDTO | CheckboxSvarDTO | TekstSvarDTO | DatoSvarDTO | KontaktinfosvarDTO | KontaktInfoInvolvertSvarDTO | SimpleKontaktinfosvarDTO | SkadelidtInfoSvarDTO | UtleggsvarDTO | TallSvarDTO | InformasjonSvarDTO | ForsikringSvarDTO | VerkstedSvarDTO | SporsmalListSvarDTO | SkadenummerSvarDTO | AttentionMessageSvarDTO | PostnummmerSvarDTO | SelectSvarDTO | SkadedatoAndForsikringSvarDTO | ForsikringsnummerSvarDTO | ForsikringObjekterCheckboxSvarDTO | KredittkortnummerSvarDTO | ModalSvarDTO;

export type TriggeredByDTOUnion = TriggeredByRadioDTO | TriggeredByCheckboxDTO | TriggeredBySelectDTO | TriggeredByTallDTO | TriggeredByForsikringDTO | TriggeredByDatoDTO | TriggeredByUtsattForgreiningDTO;

export enum AcceptDateBeforeOrAfter {
    Before = "Before",
    After = "After",
}

export enum AttentionMessageType {
    Error = "Error",
    Info = "Info",
    Success = "Success",
    Warning = "Warning",
    Default = "Default",
    Text = "Text",
    SubHeading = "SubHeading",
}

export enum BelopOperator {
    LessThan = "LessThan",
    GreaterThan = "GreaterThan",
}

export enum Bilmerke {
    AlfaRomeo = "AlfaRomeo",
    Audi = "Audi",
    BMW = "BMW",
    BYD = "BYD",
    Chevrolet = "Chevrolet",
    ChevroletUS = "ChevroletUS",
    Chrysler = "Chrysler",
    Citroen = "Citroen",
    Cupra = "Cupra",
    DS = "DS",
    Dacia = "Dacia",
    Daihatsu = "Daihatsu",
    Dodge = "Dodge",
    Fiat = "Fiat",
    Ford = "Ford",
    FordUS = "FordUS",
    Galloper = "Galloper",
    Honda = "Honda",
    Hongqi = "Hongqi",
    Hyundai = "Hyundai",
    Isuzu = "Isuzu",
    Iveco = "Iveco",
    Jaguar = "Jaguar",
    Jeep = "Jeep",
    Kia = "Kia",
    Lada = "Lada",
    LandRover = "LandRover",
    Lexus = "Lexus",
    MG = "MG",
    Maxus = "Maxus",
    Mazda = "Mazda",
    Mercedes = "Mercedes",
    MercedesBenz = "MercedesBenz",
    Mini = "Mini",
    Mitsubishi = "Mitsubishi",
    Nio = "Nio",
    Nissan = "Nissan",
    Opel = "Opel",
    Peugeot = "Peugeot",
    Polestar = "Polestar",
    Porsche = "Porsche",
    RangeRover = "RangeRover",
    Renault = "Renault",
    Rover = "Rover",
    Saab = "Saab",
    Seat = "Seat",
    SeatCupra = "SeatCupra",
    Seres = "Seres",
    Skoda = "Skoda",
    Smart = "Smart",
    Ssangyong = "Ssangyong",
    Subaru = "Subaru",
    Suzuki = "Suzuki",
    Tesla = "Tesla",
    Toyota = "Toyota",
    Volkswagen = "Volkswagen",
    Volvo = "Volvo",
    Voyah = "Voyah",
    Xpeng = "Xpeng",
    Annet = "Annet",
}

export enum BonusDisplayStatusDTO {
    Show = "Show",
    Hide = "Hide",
}

export enum BygningObjektType {
    Hovedbygg = "Hovedbygg",
    Garasje = "Garasje",
    Uthus = "Uthus",
    Anneks = "Anneks",
    Rorbu = "Rorbu",
    Sjobu = "Sjobu",
    Sidebygning = "Sidebygning",
    Lekestue = "Lekestue",
    Lysthus = "Lysthus",
    Stabbur = "Stabbur",
    Bryggerhus = "Bryggerhus",
    Bathus = "Bathus",
    Grillhytte = "Grillhytte",
    Drengestue = "Drengestue",
    Eldhus = "Eldhus",
    BoligEllerFritidsboligNedlagtBruk = "BoligEllerFritidsboligNedlagtBruk",
    HageanleggEllerBasseng = "HageanleggEllerBasseng",
    Koie = "Koie",
    Naust = "Naust",
    Pumpehus = "Pumpehus",
    ServiceEllerSanitarBygg = "ServiceEllerSanitarBygg",
    Sommerbygning = "Sommerbygning",
    Vaningshus = "Vaningshus",
    StolEllerSeter = "StolEllerSeter",
    Karbygning = "Karbygning",
    CampingEllerUtleiehytte = "CampingEllerUtleiehytte",
    Hytte = "Hytte",
    BryggeBrannForsterisiko = "BryggeBrannForsterisiko",
    Driftsbygning = "Driftsbygning",
    DriftsbygningHalltype = "DriftsbygningHalltype",
    Fjos = "Fjos",
    Forhus = "Forhus",
    Geitehus = "Geitehus",
    Grisehus = "Grisehus",
    Gardssag = "Gardssag",
    Gardssilo = "Gardssilo",
    Gardssmie = "Gardssmie",
    Gardsverksted = "Gardsverksted",
    Honsehus = "Honsehus",
    Lagerbygning = "Lagerbygning",
    Lave = "Lave",
    Melkebu = "Melkebu",
    Pelsdyrhus = "Pelsdyrhus",
    Potetkjeller = "Potetkjeller",
    Redskapshus = "Redskapshus",
    Ridehus = "Ridehus",
    Ridestall = "Ridestall",
    Sauefjos = "Sauefjos",
    Sommerfjos = "Sommerfjos",
    Stall = "Stall",
    TekniskBygning = "TekniskBygning",
    Utloe = "Utloe",
    Veksthus = "Veksthus",
    Vognskjul = "Vognskjul",
    BrakkePaHjul = "BrakkePaHjul",
    ByggUnderOppforing = "ByggUnderOppforing",
    NedlagtDriftsbygning = "NedlagtDriftsbygning",
    Annet = "Annet",
    Unspecified = "Unspecified",
}

export enum CardType {
    Info = "Info",
    NoticeCard = "NoticeCard",
}

export enum CheckboxType {
    Buttons = "Buttons",
    Panels = "Panels",
}

export enum EgenandelDisplayStatusDTO {
    Show = "Show",
    Hide = "Hide",
}

export enum ForsikringDekningDTO {
    KjoretoyAnsvar = "KjoretoyAnsvar",
    KjoretoyDelkasko = "KjoretoyDelkasko",
    KjoretoyKasko = "KjoretoyKasko",
    KjoretoyKaskoLeiebil = "KjoretoyKaskoLeiebil",
    KjoretoyKaskoPluss = "KjoretoyKaskoPluss",
    KjoretoyUkjent = "KjoretoyUkjent",
    BilKaskoLeiebil = "BilKaskoLeiebil",
    BilKaskoPluss = "BilKaskoPluss",
    LandbrukOgArbeidsmaskin = "LandbrukOgArbeidsmaskin",
    PrivatTraktor = "PrivatTraktor",
    ReisePluss = "ReisePluss",
    ReiseFamilie = "ReiseFamilie",
    ReiseFamilieAndPluss = "ReiseFamilieAndPluss",
    ReiseIngen = "ReiseIngen",
    SmaElektriskeKjoretoyAnsvar = "SmaElektriskeKjoretoyAnsvar",
    Bygning = "Bygning",
    BygningPluss = "BygningPluss",
    KunInnbo = "KunInnbo",
    Uforepensjon = "Uforepensjon",
    Uforekapital = "Uforekapital",
    UforekapitalMedForskuttering = "UforekapitalMedForskuttering",
    UforerenteMedKarens = "UforerenteMedKarens",
    DekningIkkeRelevant = "DekningIkkeRelevant",
    IngenValgt = "IngenValgt",
    FinnerIkkeRiktig = "FinnerIkkeRiktig",
}

export enum ForsikringStartDateWebDTO {
    BeforeJulyFirst2024 = "BeforeJulyFirst2024",
    BetweenJulyFirst2024ToJanuaryFirst2025 = "BetweenJulyFirst2024ToJanuaryFirst2025",
    AfterJanFirst2025 = "AfterJanFirst2025",
    NotApplicable = "NotApplicable",
}

export enum ForsikringsnummerType {
    Personforsikring = "Personforsikring",
    Skadeforsikring = "Skadeforsikring",
    Invalid = "Invalid",
}

export enum Forsikringsprodukt {
    BarneOgUngdomsForsikring1 = "BarneOgUngdomsForsikring1",
    BarneOgUngdomsForsikring = "BarneOgUngdomsForsikring",
    Dodsfallskapital = "Dodsfallskapital",
    Uforekapital = "Uforekapital",
    UforekapitalMedForskuttering = "UforekapitalMedForskuttering",
    Uforepensjon = "Uforepensjon",
    UforerenteMedKarens = "UforerenteMedKarens",
    Operasjonsforsikring = "Operasjonsforsikring",
    KritiskSykdom = "KritiskSykdom",
    BarneOgUngdomsForsikringKollektiv = "BarneOgUngdomsForsikringKollektiv",
    DodsfallskapitalKollektiv = "DodsfallskapitalKollektiv",
    UforekapitalKollektiv = "UforekapitalKollektiv",
    UforerenteKollektiv = "UforerenteKollektiv",
    KritiskSykdomKollektiv = "KritiskSykdomKollektiv",
    LandbrukBolighus = "LandbrukBolighus",
    LandbrukDriftsbygning = "LandbrukDriftsbygning",
    LandbrukLosoreAvlBesetn = "LandbrukLosoreAvlBesetn",
    DriftsbLosoreNedlagtBruk = "DriftsbLosoreNedlagtBruk",
    Landbruksmaskin = "Landbruksmaskin",
    LandbruksArbeidsmaskin = "LandbruksArbeidsmaskin",
    Hest = "Hest",
    LandbrukYrkesskade = "LandbrukYrkesskade",
    LandbrukGardsbil = "LandbrukGardsbil",
    Husdyr = "Husdyr",
    Fjorfe = "Fjorfe",
    HusdyrIndividuell = "HusdyrIndividuell",
    BondensUlykke = "BondensUlykke",
    Bilforsikring = "Bilforsikring",
    NyregistrertBil2009 = "NyregistrertBil2009",
    TilhengerEllerCampingvogn = "TilhengerEllerCampingvogn",
    Moped = "Moped",
    SmaElektriskeKjoretoy = "SmaElektriskeKjoretoy",
    Veterankjoretoy = "Veterankjoretoy",
    Motorsykkel = "Motorsykkel",
    MotorsykkelNy = "MotorsykkelNy",
    Snoscooter = "Snoscooter",
    Bobil = "Bobil",
    ATV = "ATV",
    Russebil = "Russebil",
    PrivatTraktor = "PrivatTraktor",
    Eiendeler = "Eiendeler",
    Bedrift = "Bedrift",
    Handverker = "Handverker",
    Naringsforsikring = "Naringsforsikring",
    Butikk = "Butikk",
    Kontor = "Kontor",
    BedriftHelseforsikring = "BedriftHelseforsikring",
    Personalforsikring = "Personalforsikring",
    HelseforsikringBedrift = "HelseforsikringBedrift",
    Yrkesskade = "Yrkesskade",
    InnehaversLiv = "InnehaversLiv",
    BoligTilUtleie = "BoligTilUtleie",
    Huseier = "Huseier",
    HuseierBedrift = "HuseierBedrift",
    Drosje = "Drosje",
    Naringsbil = "Naringsbil",
    Storbil = "Storbil",
    TilhengerTralle = "TilhengerTralle",
    Arbeidsmaskin = "Arbeidsmaskin",
    SmaElektriskeKjoretoyUtleie = "SmaElektriskeKjoretoyUtleie",
    Ansvar = "Ansvar",
    Miljoforsikring = "Miljoforsikring",
    Dataangrepsforsikring = "Dataangrepsforsikring",
    TransportEgenBil = "TransportEgenBil",
    TransportBedrift = "TransportBedrift",
    TransportEngangs = "TransportEngangs",
    Maskinforsikring = "Maskinforsikring",
    Bankdrift = "Bankdrift",
    YrkesskadeII = "YrkesskadeII",
    PersonalNavnebasert = "PersonalNavnebasert",
    PersonalSelvadmOrdn = "PersonalSelvadmOrdn",
    KollektivUlykke = "KollektivUlykke",
    ReiseBedrift = "ReiseBedrift",
    ReiseKorttid = "ReiseKorttid",
    Formueskade = "Formueskade",
    Boligforsikring = "Boligforsikring",
    Innboforsikring = "Innboforsikring",
    InnboforsikringObos = "InnboforsikringObos",
    Reiseforsikring = "Reiseforsikring",
    UtvidetReisetid = "UtvidetReisetid",
    Ulykke = "Ulykke",
    Helseforsikring = "Helseforsikring",
    Fritidsboligforsikring = "Fritidsboligforsikring",
    Verdigjenstand = "Verdigjenstand",
    Hundeforsikring = "Hundeforsikring",
    HundKatt = "HundKatt",
    Fritidsbat = "Fritidsbat",
    StudentIUtlandet = "StudentIUtlandet",
    EikaPluss = "EikaPluss",
    UNGINorge = "UNGINorge",
    UNGFamilie = "UNGFamilie",
    EikaKort = "EikaKort",
    Onlineforsikring = "Onlineforsikring",
    Inntektsforsikring = "Inntektsforsikring",
    Droneforsikring = "Droneforsikring",
    InnboInklPlussKollektiv = "InnboInklPlussKollektiv",
    InnboIUtlandetKollektiv = "InnboIUtlandetKollektiv",
    ReiseInklPlussKollektiv = "ReiseInklPlussKollektiv",
    FamilieulykkeInklFaginvalKollektiv = "FamilieulykkeInklFaginvalKollektiv",
    HelsePrivatKollektiv = "HelsePrivatKollektiv",
    StudentINorgeKollektiv = "StudentINorgeKollektiv",
    StudentUtlandKollektiv = "StudentUtlandKollektiv",
    UngINorgeKollektiv = "UngINorgeKollektiv",
    UngFamilieKollektiv = "UngFamilieKollektiv",
    Fortsettelse = "Fortsettelse",
    Lansforsakringar = "Lansforsakringar",
    Topdanmark = "Topdanmark",
    UgyldigForsikringsprodukt = "UgyldigForsikringsprodukt",
}

export enum IdentifikatorType {
    Fodselsnummer = "Fodselsnummer",
    Organisasjonsnummer = "Organisasjonsnummer",
}

export enum KlageStatusWebDTO {
    IkkeValidert = "IkkeValidert",
    FailedVedleggDoesNotExist = "FailedVedleggDoesNotExist",
    FailedEpostutsendingNotSuccessful = "FailedEpostutsendingNotSuccessful",
    FailedUnexpectedVedleggException = "FailedUnexpectedVedleggException",
    FailedUploadingVedlegg = "FailedUploadingVedlegg",
    Ok = "Ok",
}

export enum KundeforholdType {
    PMKunde = "PMKunde",
    BMKunde = "BMKunde",
    Unknown = "Unknown",
}

export enum MaksKjorelengdeDisplayStatusDTO {
    Show = "Show",
    Hide = "Hide",
}

export enum ModalType {
    Normaltap = "Normaltap",
}

export enum RadioType {
    Buttons = "Buttons",
    Panels = "Panels",
    Toggles = "Toggles",
}

export enum SitecoreConfigUrl {
    MinSide = "MinSide",
    VerkstedGlasskade = "VerkstedGlasskade",
}

export enum Skademeldingstype {
    Hund = "Hund",
    Katt = "Katt",
    Hest = "Hest",
    Dyr = "Dyr",
    Annet = "Annet",
    Naring = "Naring",
    NaringTyveriUnderslag = "NaringTyveriUnderslag",
    NaringBygningsglass = "NaringBygningsglass",
    Rettshjelp = "Rettshjelp",
    Landbruk = "Landbruk",
    LandbrukDriftsbygninger = "LandbrukDriftsbygninger",
    LandbrukLosore = "LandbrukLosore",
    LandbrukAvling = "LandbrukAvling",
    LandbrukProduksjonsdyr = "LandbrukProduksjonsdyr",
    LandbrukProduksjonsdyrStorfe = "LandbrukProduksjonsdyrStorfe",
    LandbrukProduksjonsdyrIndividuellOkse = "LandbrukProduksjonsdyrIndividuellOkse",
    LandbrukBrannvarslingsanlegg = "LandbrukBrannvarslingsanlegg",
    LandbrukMelkerobot = "LandbrukMelkerobot",
    Ansvar = "Ansvar",
    AnsvarPrivatPersonskade = "AnsvarPrivatPersonskade",
    AnsvarPrivatTingskade = "AnsvarPrivatTingskade",
    AnsvarLandbrukNaringFormueskade = "AnsvarLandbrukNaringFormueskade",
    AnsvarLandbrukNaringTingskade = "AnsvarLandbrukNaringTingskade",
    SmaElektriskeKjoretoy = "SmaElektriskeKjoretoy",
    VarrelaterteSkader = "VarrelaterteSkader",
    Feilfylling = "Feilfylling",
    MistetNokkel = "MistetNokkel",
    TyveriAvNokkel = "TyveriAvNokkel",
    Glasskade = "Glasskade",
    Veihjelp = "Veihjelp",
    MotorOgAndreMaskinSkader = "MotorOgAndreMaskinSkader",
    KjoretoyTyveriInnbrudd = "KjoretoyTyveriInnbrudd",
    KjoretoyTyveriStjaletOgFunnet = "KjoretoyTyveriStjaletOgFunnet",
    KjoretoyTyveriStjaletOgIkkeFunnet = "KjoretoyTyveriStjaletOgIkkeFunnet",
    TakrasPaParkertKjoretoy = "TakrasPaParkertKjoretoy",
    KollisjonBulkingEllerHarvarkPaParkertKjoretoy = "KollisjonBulkingEllerHarvarkPaParkertKjoretoy",
    KollisjonskadePaKjoretoyDyr = "KollisjonskadePaKjoretoyDyr",
    KollisjonskadePaKjoretoySteinIsEllerAnnetObjekt = "KollisjonskadePaKjoretoySteinIsEllerAnnetObjekt",
    KollisjonskadePaKjoretoyMykTrafikant = "KollisjonskadePaKjoretoyMykTrafikant",
    UtforkjoringEllerKollisjonMedAutovernEllerSkilt = "UtforkjoringEllerKollisjonMedAutovernEllerSkilt",
    UtforkjoringEllerKollisjonMedHusMurkant = "UtforkjoringEllerKollisjonMedHusMurkant",
    KollisjonMedAnnetKjoretoy = "KollisjonMedAnnetKjoretoy",
    BrannskadePaKjoretoy = "BrannskadePaKjoretoy",
    BatGrunnstottEllerSkjar = "BatGrunnstottEllerSkjar",
    BatHarSunket = "BatHarSunket",
    BatHarSlittSegFraFortoyning = "BatHarSlittSegFraFortoyning",
    BatHarTruffetFlytendeGjenstand = "BatHarTruffetFlytendeGjenstand",
    BatHarKollidertMedAnnenBat = "BatHarKollidertMedAnnenBat",
    BatHarKollidertMedBryggeEllerFastland = "BatHarKollidertMedBryggeEllerFastland",
    BatMaskinskader = "BatMaskinskader",
    BatInnbrudd = "BatInnbrudd",
    BatStjaletOgFunnet = "BatStjaletOgFunnet",
    BatStjaletOgIkkeFunnet = "BatStjaletOgIkkeFunnet",
    ReisegodsTyveri = "ReisegodsTyveri",
    Reiseavbestilling = "Reiseavbestilling",
    ForsinketBagasje = "ForsinketBagasje",
    ForsinketTransport = "ForsinketTransport",
    SkadetReisegods = "SkadetReisegods",
    ReiseSykdomSkadeEllerUlykkePaReisen = "ReiseSykdomSkadeEllerUlykkePaReisen",
    ReiseDodsfallEllerAlvorligSykdomPaReisen = "ReiseDodsfallEllerAlvorligSykdomPaReisen",
    MistetReisegods = "MistetReisegods",
    GjenglemtReisegods = "GjenglemtReisegods",
    PersonskadeUlykke = "PersonskadeUlykke",
    PersonskadeArbeidsuforhet = "PersonskadeArbeidsuforhet",
    PersonskadeDodsfall = "PersonskadeDodsfall",
    PersonskadeBarneOgUngdomsforsikring = "PersonskadeBarneOgUngdomsforsikring",
    PersonskadeKritiskSykdom = "PersonskadeKritiskSykdom",
    PersonskadeAnnet = "PersonskadeAnnet",
    BygningNaturskadeStorm = "BygningNaturskadeStorm",
    BygningNaturskadeFlom = "BygningNaturskadeFlom",
    BygningNaturskadeSkred = "BygningNaturskadeSkred",
    BygningNaturskadeAnnen = "BygningNaturskadeAnnen",
    BygningGlasskadeVinduDor = "BygningGlasskadeVinduDor",
    BygningGlasskadeSanitarporselenDusjvegg = "BygningGlasskadeSanitarporselenDusjvegg",
    BygningGlasskadeIPlatetoppKomfyr = "BygningGlasskadeIPlatetoppKomfyr",
    BygningGlasskadeAnnen = "BygningGlasskadeAnnen",
    BygningVannskadeLekkasjeInne = "BygningVannskadeLekkasjeInne",
    BygningVannskadeLekkasjeUtvendigRor = "BygningVannskadeLekkasjeUtvendigRor",
    BygningVannskadeTilbakeslag = "BygningVannskadeTilbakeslag",
    BygningVannskadeHustakYttervegg = "BygningVannskadeHustakYttervegg",
    BygningVannskadeKjeller = "BygningVannskadeKjeller",
    BygningVannskadeAnnet = "BygningVannskadeAnnet",
    BygningElektriskSkade = "BygningElektriskSkade",
    BygningBrannskadeEllerSot = "BygningBrannskadeEllerSot",
    BygningBrannskadeAnnen = "BygningBrannskadeAnnen",
    BygningInnbrudd = "BygningInnbrudd",
    BygningHarverk = "BygningHarverk",
    BygningAnnet = "BygningAnnet",
    InnboEiendelerMobilNettbrettPc = "InnboEiendelerMobilNettbrettPc",
    InnboEiendelerTvElektriskeArtikler = "InnboEiendelerTvElektriskeArtikler",
    InnboEiendelerSkadePaAndreEiendeler = "InnboEiendelerSkadePaAndreEiendeler",
    InnboEiendelerSykkeltyveri = "InnboEiendelerSykkeltyveri",
    InnboEiendelerTyveri = "InnboEiendelerTyveri",
    InnboEiendelerMatvarerFryserKjoleskap = "InnboEiendelerMatvarerFryserKjoleskap",
    RettshjelpTvistKjoretoy = "RettshjelpTvistKjoretoy",
    RettshjelpTvistBolig = "RettshjelpTvistBolig",
    RettshjelpTvistEntreprenorEllerHandverker = "RettshjelpTvistEntreprenorEllerHandverker",
    RettshjelpTvistNabo = "RettshjelpTvistNabo",
    RettshjelpTvistJordskifteEllerFesterett = "RettshjelpTvistJordskifteEllerFesterett",
    RettshjelpTvistOffentligForvaltningsvedtak = "RettshjelpTvistOffentligForvaltningsvedtak",
    RettshjelpTvistAnnenType = "RettshjelpTvistAnnenType",
}

export enum SporsmalId {
    Skadedato = "Skadedato",
    SkadedatoAndForsikring = "SkadedatoAndForsikring",
    SkadedatoAndForsikring_SporsmalSide = "SkadedatoAndForsikring_SporsmalSide",
    SoknadLandbruksdirektorat_SporsmalSide = "SoknadLandbruksdirektorat_SporsmalSide",
    SoknadLandbruksdirektorat = "SoknadLandbruksdirektorat",
    SvarPaSoknad = "SvarPaSoknad",
    SvarPaSoknad_AttentionMessage = "SvarPaSoknad_AttentionMessage",
    SvarPaSoknad_AttentionMessage_Nei = "SvarPaSoknad_AttentionMessage_Nei",
    DekketGjennomFamiliemedlemArbeidsgiverEllerOrganisasjon = "DekketGjennomFamiliemedlemArbeidsgiverEllerOrganisasjon",
    FamiliemedlemArbeidsgiverEllerOrganisasjon_Navn = "FamiliemedlemArbeidsgiverEllerOrganisasjon_Navn",
    Familiemedlem = "Familiemedlem",
    Familiemedlem_AttentionMessage = "Familiemedlem_AttentionMessage",
    Familiemedlem_Blindvei = "Familiemedlem_Blindvei",
    Familiemedlem_Forsikringsnummer = "Familiemedlem_Forsikringsnummer",
    Familiemedlem_Forsikringsnummer_AttentionMessage = "Familiemedlem_Forsikringsnummer_AttentionMessage",
    ArbeidsgiverEllerOrganisasjon_Forsikringsnummer = "ArbeidsgiverEllerOrganisasjon_Forsikringsnummer",
    ArbeidsgiverEllerOrganisasjon_Finn_Forsikringsnummer_Tips = "ArbeidsgiverEllerOrganisasjon_Finn_Forsikringsnummer_Tips",
    IngenAvDelene_AttentionMessage = "IngenAvDelene_AttentionMessage",
    IngenAvDelene_Blindvei = "IngenAvDelene_Blindvei",
    Skadearsak = "Skadearsak",
    Reiseavbestilling_Sykdom_Hvem = "Reiseavbestilling_Sykdom_Hvem",
    Reiseavbestilling_Dodsfall_Hvem = "Reiseavbestilling_Dodsfall_Hvem",
    Skadetidspunkt = "Skadetidspunkt",
    ForsikringSporsmal = "ForsikringSporsmal",
    Forsikring_Side = "Forsikring_Side",
    TidligereSoktErstatning = "TidligereSoktErstatning",
    HvaHarSkjedd = "HvaHarSkjedd",
    Kontaktinfo = "Kontaktinfo",
    Kontonummer = "Kontonummer",
    BedriftEllerPrivat = "BedriftEllerPrivat",
    Forsikringsnummer = "Forsikringsnummer",
    Informasjon = "Informasjon",
    HvorSkjeddeSkaden = "HvorSkjeddeSkaden",
    LastOppDokumentasjonGenerell = "LastOppDokumentasjonGenerell",
    LastOppDokumentasjonReiseavbestilling = "LastOppDokumentasjonReiseavbestilling",
    UtleggTabell = "UtleggTabell",
    BelopAsUtlegg = "BelopAsUtlegg",
    ForsinkelseITimer = "ForsinkelseITimer",
    AntallPersonerDetSokesErstatningFor = "AntallPersonerDetSokesErstatningFor",
    HvemSokesDetErstatningFor = "HvemSokesDetErstatningFor",
    RegressFlereForsikringerSomDekkerUtgifter = "RegressFlereForsikringerSomDekkerUtgifter",
    Reparasjonstype = "Reparasjonstype",
    MistetNokkelAntallGangerMeldt = "MistetNokkelAntallGangerMeldt",
    MistetNokkelUtlegg_Side = "MistetNokkelUtlegg_Side",
    MistetNokkelAlleredeBetaltForNokkel = "MistetNokkelAlleredeBetaltForNokkel",
    StartetBilEtterFeilfylling = "StartetBilEtterFeilfylling",
    FeilfyllingUtsattBelopForReparasjon = "FeilfyllingUtsattBelopForReparasjon",
    RegressSelskapetsNavn = "RegressSelskapetsNavn",
    HvordanOppstodSkaden = "HvordanOppstodSkaden",
    HvaHarBlittSkadet = "HvaHarBlittSkadet",
    AnmeldtTilPolitiet_Sporsmalside = "AnmeldtTilPolitiet_Sporsmalside",
    Forsikringsnummer_SporsmalSide = "Forsikringsnummer_SporsmalSide",
    Forsikringsnummer_SporsmalSide_Utsatt = "Forsikringsnummer_SporsmalSide_Utsatt",
    Dokumentasjon_Side = "Dokumentasjon_Side",
    Adresse = "Adresse",
    Postnummer = "Postnummer",
    Gardsnummer = "Gardsnummer",
    Bruksnummer = "Bruksnummer",
    Kredittkortnummer = "Kredittkortnummer",
    BilQ01 = "BilQ01",
    BilQ02 = "BilQ02",
    BilQ04 = "BilQ04",
    VeihjelpQ03 = "VeihjelpQ03",
    VeihjelpQ04 = "VeihjelpQ04",
    VeihjelpQ05 = "VeihjelpQ05",
    VeihjelpQ06 = "VeihjelpQ06",
    InformasjonOmSituasjon_Side = "InformasjonOmSituasjon_Side",
    HvaBeskriverDinSitasjon = "HvaBeskriverDinSitasjon",
    Glasskade_FinnVerksted_Info = "Glasskade_FinnVerksted_Info",
    Glasskade_FinnVerksted_Blindvei = "Glasskade_FinnVerksted_Blindvei",
    Glasskade_TrengerIkkeMeldeSkade_Info = "Glasskade_TrengerIkkeMeldeSkade_Info",
    Glasskade_TrengerIkkeMeldeSkade_Blindvei = "Glasskade_TrengerIkkeMeldeSkade_Blindvei",
    Glasskade_HarDuBetaltVerksted = "Glasskade_HarDuBetaltVerksted",
    Veihjelp_Info = "Veihjelp_Info",
    Veihjelp_AttentionMessage = "Veihjelp_AttentionMessage",
    Veihjelp_Blindvei = "Veihjelp_Blindvei",
    Veihjelp_TrengerIkkeMeldeSkade_Info = "Veihjelp_TrengerIkkeMeldeSkade_Info",
    Veihjelp_TrengerIkkeMeldeSkade_Blindvei = "Veihjelp_TrengerIkkeMeldeSkade_Blindvei",
    Veihjelp_HarDuBetaltForVeihjelp = "Veihjelp_HarDuBetaltForVeihjelp",
    KjoretoyTyveri_ErDetSkaderIForbindelseMedInnbrudd = "KjoretoyTyveri_ErDetSkaderIForbindelseMedInnbrudd",
    KjoretoyTyveri_VarEiendeleneSkjultIHanskeEllerBagasjerom = "KjoretoyTyveri_VarEiendeleneSkjultIHanskeEllerBagasjerom",
    KjoretoyTyveri_VarKjoretoyLast = "KjoretoyTyveri_VarKjoretoyLast",
    KjoretoyTyveri_BleEiendelerStjalet = "KjoretoyTyveri_BleEiendelerStjalet",
    KjoretoyTyveri_EiendelerStjalet_SporsmalSide = "KjoretoyTyveri_EiendelerStjalet_SporsmalSide",
    KjoretoyTyveri_DokumentasjonPaStjaletEiendel = "KjoretoyTyveri_DokumentasjonPaStjaletEiendel",
    KjoretoyTyveri_InformasjonOmStjalneEiendeler_SporsmalList = "KjoretoyTyveri_InformasjonOmStjalneEiendeler_SporsmalList",
    KjoretoyTyveri_StjaletEiendel_Hva = "KjoretoyTyveri_StjaletEiendel_Hva",
    KjoretoyTyveri_StjaletEiendel_Kostnad = "KjoretoyTyveri_StjaletEiendel_Kostnad",
    KjoretoyTyveri_Utsatt_ReparasjonOgLeiebilSporsmalOmBilenBleSkadet = "KjoretoyTyveri_Utsatt_ReparasjonOgLeiebilSporsmalOmBilenBleSkadet",
    EiendomQ01 = "EiendomQ01",
    HvaForhindrerDegIaReise = "HvaForhindrerDegIaReise",
    SizeOfReisefolgeDodsfall = "SizeOfReisefolgeDodsfall",
    ForsinketBagasje_HvaSlagsReiseVarDet = "ForsinketBagasje_HvaSlagsReiseVarDet",
    ForsinketBagasje_InfoOm_SporsmalSide = "ForsinketBagasje_InfoOm_SporsmalSide",
    ForsinketBagasje_DineUtgifter_SporsmalSide = "ForsinketBagasje_DineUtgifter_SporsmalSide",
    ForsinketBagasje_PIRRapport_SporsmalSide = "ForsinketBagasje_PIRRapport_SporsmalSide",
    Reiseskade_RegressVedAndreForsikringer_SporsmalSide = "Reiseskade_RegressVedAndreForsikringer_SporsmalSide",
    Reiseskade_Regress_Alternativene_Som_Gjelder = "Reiseskade_Regress_Alternativene_Som_Gjelder",
    Reiseskade_Regress_Alternativene_Som_Gjelder_Forsikret_Gjennom_Et_Annet_Utsatt = "Reiseskade_Regress_Alternativene_Som_Gjelder_Forsikret_Gjennom_Et_Annet_Utsatt",
    Reiseskade_Regress_Alternativene_Som_Gjelder_Betalt_Med_Kreditkort_Utsatt = "Reiseskade_Regress_Alternativene_Som_Gjelder_Betalt_Med_Kreditkort_Utsatt",
    Reiseskade_Regress_Jeg_Er_Ogsa_Forsikret_Gjennom_Et_Annet_SubTitle = "Reiseskade_Regress_Jeg_Er_Ogsa_Forsikret_Gjennom_Et_Annet_SubTitle",
    Reiseskade_Regress_Jeg_Er_Ogsa_Forsikret_Gjennom_Et_Annet_Navn = "Reiseskade_Regress_Jeg_Er_Ogsa_Forsikret_Gjennom_Et_Annet_Navn",
    Reiseskade_Regress_Jeg_Er_Ogsa_Forsikret_Gjennom_Et_Annet_Forsikringselskap = "Reiseskade_Regress_Jeg_Er_Ogsa_Forsikret_Gjennom_Et_Annet_Forsikringselskap",
    Reiseskade_Regress_Kredittkortinformasjon_SubHeading = "Reiseskade_Regress_Kredittkortinformasjon_SubHeading",
    Reiseskade_Regress_Kredittkortinformasjon_Halvparten_Betalt_JaNei = "Reiseskade_Regress_Kredittkortinformasjon_Halvparten_Betalt_JaNei",
    Reiseskade_Regress_Hva_Slags_Reise = "Reiseskade_Regress_Hva_Slags_Reise",
    Reiseskade_Regress_Hvem_Eier_Kortet = "Reiseskade_Regress_Hvem_Eier_Kortet",
    Reiseskade_Regress_Fullt_Navn_Eier_Av_Kortet = "Reiseskade_Regress_Fullt_Navn_Eier_Av_Kortet",
    Reiseskade_Regress_Fodselsdato_Eier_Av_Kortet = "Reiseskade_Regress_Fodselsdato_Eier_Av_Kortet",
    Reiseskade_Regress_Kredittkort_Utgifter = "Reiseskade_Regress_Kredittkort_Utgifter",
    Reiseskade_Regress_Kredittkort_Utgifter_Hvem_Betalte_Du_Til = "Reiseskade_Regress_Kredittkort_Utgifter_Hvem_Betalte_Du_Til",
    Reiseskade_Regress_Kredittkort_Utgifter_Hvilken_Sum_Betalt = "Reiseskade_Regress_Kredittkort_Utgifter_Hvilken_Sum_Betalt",
    Reiseskade_Regress_Kredittkort_Utgifter_Dato_Belopet_Betalt = "Reiseskade_Regress_Kredittkort_Utgifter_Dato_Belopet_Betalt",
    Reiseskade_Regress_Hvem_Ble_Betalt_For = "Reiseskade_Regress_Hvem_Ble_Betalt_For",
    Reiseskade_Regress_NavnOgFodselsdatoer = "Reiseskade_Regress_NavnOgFodselsdatoer",
    ForsinketBagasje_DatoBagasjeForsinket = "ForsinketBagasje_DatoBagasjeForsinket",
    ForsinketBagasje_HvorVarDuPaVeiDaBagasjenBleForsinket = "ForsinketBagasje_HvorVarDuPaVeiDaBagasjenBleForsinket",
    ForsinketBagasje_ViDekkerIkkeForsinkeBagasjeHarKommetDegHjem_Utsatt = "ForsinketBagasje_ViDekkerIkkeForsinkeBagasjeHarKommetDegHjem_Utsatt",
    ForsinketBagasje_ViDekkerIkkeForsinkeBagasjeHarKommetDegHjem = "ForsinketBagasje_ViDekkerIkkeForsinkeBagasjeHarKommetDegHjem",
    ForsinketBagasje_VarBagasjenForsinketMerEnnFirTimer = "ForsinketBagasje_VarBagasjenForsinketMerEnnFirTimer",
    ForsinketBagasje_HvemFikkSinBagasjeForsinket = "ForsinketBagasje_HvemFikkSinBagasjeForsinket",
    ForsinketBagasje_DekkerKunForsinketBagasjeForDegOgMedforsikrede_Utsatt = "ForsinketBagasje_DekkerKunForsinketBagasjeForDegOgMedforsikrede_Utsatt",
    ForsinketBagasje_DekkerKunForsinketBagasjeForDegOgMedforsikrede = "ForsinketBagasje_DekkerKunForsinketBagasjeForDegOgMedforsikrede",
    ForsinketBagasje_HvorMangePersonerDekketAvForsikringenFikkBagasjeForsinket_Utsatt = "ForsinketBagasje_HvorMangePersonerDekketAvForsikringenFikkBagasjeForsinket_Utsatt",
    ForsinketBagasje_HvaKjopteDu = "ForsinketBagasje_HvaKjopteDu",
    ForsinketBagasje_KjopteDuDetteMensDuVarPaReise = "ForsinketBagasje_KjopteDuDetteMensDuVarPaReise",
    ForsinketBagasje_HarDuKvitteringerEllerDokumentasjon = "ForsinketBagasje_HarDuKvitteringerEllerDokumentasjon",
    ForsinketBagasje_PIRDokumentasjon = "ForsinketBagasje_PIRDokumentasjon",
    ForsinketTransport_Side_Reiseopplysninger = "ForsinketTransport_Side_Reiseopplysninger",
    ForsinketTransport_DatoForsinketPaReise = "ForsinketTransport_DatoForsinketPaReise",
    ForsinketTransport_TidspunktRelativtTilAvreise = "ForsinketTransport_TidspunktRelativtTilAvreise",
    ForsinketTransport_ForAvreiseInfo = "ForsinketTransport_ForAvreiseInfo",
    ForsinketTransport_ForAvreiseBlindvei = "ForsinketTransport_ForAvreiseBlindvei",
    ForsinketTransport_Hendelse = "ForsinketTransport_Hendelse",
    ForsinketTransport_Transportmiddel = "ForsinketTransport_Transportmiddel",
    ForsinketTransport_Arsak_ForsinketPaVeiTilFlyplassEllerAnnet = "ForsinketTransport_Arsak_ForsinketPaVeiTilFlyplassEllerAnnet",
    ForsinketTransport_Arsak_InnstiltFlyEllerForsinketMellomToFlyavganger = "ForsinketTransport_Arsak_InnstiltFlyEllerForsinketMellomToFlyavganger",
    ForsinketTransport_DokumentasjonPaArsak_ForsinketPaVeiTilFlyplassEllerAnnet = "ForsinketTransport_DokumentasjonPaArsak_ForsinketPaVeiTilFlyplassEllerAnnet",
    ForsinketTransport_DokumentasjonPaArsak_InnstiltFlyEllerForsinketMellomToFlyavganger = "ForsinketTransport_DokumentasjonPaArsak_InnstiltFlyEllerForsinketMellomToFlyavganger",
    ForsinketTransport_DokumentasjonFraLegePaArsak = "ForsinketTransport_DokumentasjonFraLegePaArsak",
    ForsinketTransport_DetaljertForklaringOmArsak = "ForsinketTransport_DetaljertForklaringOmArsak",
    ForsinketTransport_Side_Utgifter = "ForsinketTransport_Side_Utgifter",
    ForsinketTransport_ErstatningReisefolge = "ForsinketTransport_ErstatningReisefolge",
    ForsinketTransport_PengerTilbakeEllerNyeBilletter = "ForsinketTransport_PengerTilbakeEllerNyeBilletter",
    ForsinketTransport_TotalprisNyeBilletter = "ForsinketTransport_TotalprisNyeBilletter",
    ForsinketTransport_HarBetaltEkstraForOvernatting = "ForsinketTransport_HarBetaltEkstraForOvernatting",
    ForsinketTransport_TotalprisForOvernatting = "ForsinketTransport_TotalprisForOvernatting",
    ForsinketTransport_AndreUtgifter = "ForsinketTransport_AndreUtgifter",
    ForsinketTransport_TotalprisAndreUtgifter = "ForsinketTransport_TotalprisAndreUtgifter",
    ForsinketTransport_UtsattForgreining_DokumentasjonPaUtgifter = "ForsinketTransport_UtsattForgreining_DokumentasjonPaUtgifter",
    ForsinketTransport_DokumentasjonPaUtgifter = "ForsinketTransport_DokumentasjonPaUtgifter",
    Ansvar_Side_InformasjonOmHendelse = "Ansvar_Side_InformasjonOmHendelse",
    Ansvar_HvemErSkadet = "Ansvar_HvemErSkadet",
    Ansvar_HvemErAnsvarlig = "Ansvar_HvemErAnsvarlig",
    Ansvar_DetaljertBeskrivelse = "Ansvar_DetaljertBeskrivelse",
    Ansvar_OppgiInfoOmParter_Info = "Ansvar_OppgiInfoOmParter_Info",
    Ansvar_OppgiInfoOmParter_SporsmalList = "Ansvar_OppgiInfoOmParter_SporsmalList",
    Ansvar_PrivatEllerBedrift = "Ansvar_PrivatEllerBedrift",
    Ansvar_BedriftNavn = "Ansvar_BedriftNavn",
    Ansvar_PrivatNavn = "Ansvar_PrivatNavn",
    Ansvar_Organisasjonsnummer = "Ansvar_Organisasjonsnummer",
    Ansvar_Fodselsnummer = "Ansvar_Fodselsnummer",
    Ansvar_BedriftRolle = "Ansvar_BedriftRolle",
    Ansvar_KontraktsforholdBedrift = "Ansvar_KontraktsforholdBedrift",
    Ansvar_KontraktsforholdPerson = "Ansvar_KontraktsforholdPerson",
    Ansvar_InfoOmAnsvar = "Ansvar_InfoOmAnsvar",
    Ansvar_MottattKrav = "Ansvar_MottattKrav",
    Ansvar_BelopKrav = "Ansvar_BelopKrav",
    Ansvar_BestridtKrav = "Ansvar_BestridtKrav",
    Ansvar_Kontaktperson = "Ansvar_Kontaktperson",
    Ansvar_OppgiKontaktperson_Din = "Ansvar_OppgiKontaktperson_Din",
    Ansvar_OppgiKontaktperson_Annen = "Ansvar_OppgiKontaktperson_Annen",
    Ansvar_FodselsnummerEllerOrgNr = "Ansvar_FodselsnummerEllerOrgNr",
    AnsvarQ02 = "AnsvarQ02",
    AnsvarQ03 = "AnsvarQ03",
    AnsvarQ04 = "AnsvarQ04",
    AnsvarQ05 = "AnsvarQ05",
    AnsvarQ06 = "AnsvarQ06",
    AnsvarQ07 = "AnsvarQ07",
    RettshjelpQ01 = "RettshjelpQ01",
    RettshjelpQ02 = "RettshjelpQ02",
    RettshjelpQ03 = "RettshjelpQ03",
    RettshjelpQ05 = "RettshjelpQ05",
    RettshjelpQ06 = "RettshjelpQ06",
    RettshjelpQ07 = "RettshjelpQ07",
    RettshjelpQ08 = "RettshjelpQ08",
    RettshjelpQ09 = "RettshjelpQ09",
    KlageQ01 = "KlageQ01",
    KlageQ02 = "KlageQ02",
    KlageQ03 = "KlageQ03",
    KlageQ04 = "KlageQ04",
    PersonQ01 = "PersonQ01",
    PersonQ02 = "PersonQ02",
    GlassQ06 = "GlassQ06",
    GlassQ07 = "GlassQ07",
    TyveriInnbruddRanInfo = "TyveriInnbruddRanInfo",
    TyveriInnbruddRanReisegodsHvorBleReisegodsetStjalet = "TyveriInnbruddRanReisegodsHvorBleReisegodsetStjalet",
    TyveriInnbruddRanUtenforHjemmet = "TyveriInnbruddRanUtenforHjemmet",
    TyveriInnbruddRanQ03 = "TyveriInnbruddRanQ03",
    TyveriInnbruddRanQ04 = "TyveriInnbruddRanQ04",
    TyveriInnbruddRanHaddeDuTilsyn = "TyveriInnbruddRanHaddeDuTilsyn",
    TyveriInnbruddRanMistetReisegods = "TyveriInnbruddRanMistetReisegods",
    TyveriInnbruddRanQ07 = "TyveriInnbruddRanQ07",
    TyveriInnbruddRanQ08 = "TyveriInnbruddRanQ08",
    TyveriInnbruddRanQ09 = "TyveriInnbruddRanQ09",
    TyveriInnbruddRanQ11 = "TyveriInnbruddRanQ11",
    NaringTyveri_HvaSkjedde_SporsmalSide = "NaringTyveri_HvaSkjedde_SporsmalSide",
    NaringTyveri_HvaSkjedde_Ansatt = "NaringTyveri_HvaSkjedde_Ansatt",
    NaringTyveri_HvaSkjedde_Ansatt_Ja = "NaringTyveri_HvaSkjedde_Ansatt_Ja",
    NaringTyveri_HvaSkjedde_Ansatt_Nei = "NaringTyveri_HvaSkjedde_Ansatt_Nei",
    NaringTyveri_HvorSkjedde_SporsmalSide = "NaringTyveri_HvorSkjedde_SporsmalSide",
    NaringTyveri_Politianmeldt_SporsmalSide = "NaringTyveri_Politianmeldt_SporsmalSide",
    NaringTyveri_Politianmeldt_JaNei = "NaringTyveri_Politianmeldt_JaNei",
    NaringTyveri_PolitiAnmeldtNummer = "NaringTyveri_PolitiAnmeldtNummer",
    NaringTyveri_Politianmeldt_Info = "NaringTyveri_Politianmeldt_Info",
    NaringTyveri_StjaletTing_SporsmalSide = "NaringTyveri_StjaletTing_SporsmalSide",
    NaringTyveri_StjaletTing_JaNei = "NaringTyveri_StjaletTing_JaNei",
    NaringTyveri_StjaletTing_Verdi = "NaringTyveri_StjaletTing_Verdi",
    NaringTyveri_StjaletTing_Info = "NaringTyveri_StjaletTing_Info",
    NaringTyveri_StjaletEiendel_SporsmalList = "NaringTyveri_StjaletEiendel_SporsmalList",
    NaringTyveri_StjaletEiendel_Hva = "NaringTyveri_StjaletEiendel_Hva",
    NaringTyveri_StjaletEiendel_Verdi = "NaringTyveri_StjaletEiendel_Verdi",
    NaringTyveri_StjaletEiendel_Alder = "NaringTyveri_StjaletEiendel_Alder",
    PersonUlykkeAnnenSkadetPerson_Side = "PersonUlykkeAnnenSkadetPerson_Side",
    PersonUlykkeAnnenSkadetPersonNavn = "PersonUlykkeAnnenSkadetPersonNavn",
    PersonUlykkeAnnenSkadetPersonTelefonnummer = "PersonUlykkeAnnenSkadetPersonTelefonnummer",
    PersonUlykkeRedegjorForTidligereSkade = "PersonUlykkeRedegjorForTidligereSkade",
    PersonUlykkeBeskrivelseAvBehandling = "PersonUlykkeBeskrivelseAvBehandling",
    PersonUlykkeHvorSkjeddeUlykken = "PersonUlykkeHvorSkjeddeUlykken",
    PersonUlykkeHvaSkjedde = "PersonUlykkeHvaSkjedde",
    PersonUlykkeHvilkeKroppsdelerSkadet = "PersonUlykkeHvilkeKroppsdelerSkadet",
    PersonUlykkeForsteTimeGrunnetSkade = "PersonUlykkeForsteTimeGrunnetSkade",
    PersonUlykkeLegeNavn = "PersonUlykkeLegeNavn",
    PersonUlykkeSkadeFortsattTilBehandling = "PersonUlykkeSkadeFortsattTilBehandling",
    PersonUlykkeAndreInstitusjonerKonsultert = "PersonUlykkeAndreInstitusjonerKonsultert",
    PersonUlykkeNavnPaInsitusjonOgTidsperiodeForTidligereBehandling = "PersonUlykkeNavnPaInsitusjonOgTidsperiodeForTidligereBehandling",
    PersonUlykkeBehandlingOgMedisineringBeskrivelse = "PersonUlykkeBehandlingOgMedisineringBeskrivelse",
    PersonUlykkeSkadeSammenheng = "PersonUlykkeSkadeSammenheng",
    PersonUlykkeSkadeVedTrafikkuhell = "PersonUlykkeSkadeVedTrafikkuhell",
    PersonUlykkeSkadeVedYrkesutovelse = "PersonUlykkeSkadeVedYrkesutovelse",
    PersonUlykkeTrafikkUhellEierOgRegistreringsnummerPaBil = "PersonUlykkeTrafikkUhellEierOgRegistreringsnummerPaBil",
    PersonUlykkeYrkesutovelseArbeidsgiversNavn = "PersonUlykkeYrkesutovelseArbeidsgiversNavn",
    PersonUlykkeSkadeMeldtTilNav = "PersonUlykkeSkadeMeldtTilNav",
    PersonUlykkeSkadetPavirketAvRusmidler = "PersonUlykkeSkadetPavirketAvRusmidler",
    PersonUlykkeRusmidlerBeskrivelse = "PersonUlykkeRusmidlerBeskrivelse",
    PersonUlykkeSkadeMeldtTilPolitiet = "PersonUlykkeSkadeMeldtTilPolitiet",
    PersonUlykkeNavnPaPolitistasjonSkadeErMeldit = "PersonUlykkeNavnPaPolitistasjonSkadeErMeldit",
    PersonUlykkeSkadetKroppsdelTidligereSkadet = "PersonUlykkeSkadetKroppsdelTidligereSkadet",
    PersonEierFordiForsikringsnummerIkkeFunnet = "PersonEierFordiForsikringsnummerIkkeFunnet",
    Personskade_BeskrivelseForsteSymptomer = "Personskade_BeskrivelseForsteSymptomer",
    Personskade_ForsteLegebesokBehandlingEllerKonsultasjon = "Personskade_ForsteLegebesokBehandlingEllerKonsultasjon",
    Personskade_NavnOgKontaktinfoTilBehandler = "Personskade_NavnOgKontaktinfoTilBehandler",
    Personskade_ErAndreLegerSykehusEllerInstitusjonerKonsultert = "Personskade_ErAndreLegerSykehusEllerInstitusjonerKonsultert",
    Personskade_NavnPaAndreLegerSykehusEllerInstitusjoner = "Personskade_NavnPaAndreLegerSykehusEllerInstitusjoner",
    PersonskadeArbeidsuforhet_UforekapitalMedForskuttering_Utsatt = "PersonskadeArbeidsuforhet_UforekapitalMedForskuttering_Utsatt",
    PersonskadeArbeidsuforhet_UforekapitalMedForskuttering_Info = "PersonskadeArbeidsuforhet_UforekapitalMedForskuttering_Info",
    PersonskadeArbeidsuforhet_UforekapitalMedForskuttering_Blindvei = "PersonskadeArbeidsuforhet_UforekapitalMedForskuttering_Blindvei",
    PersonskadeArbeidsuforhet_Uforekapital_Utsatt = "PersonskadeArbeidsuforhet_Uforekapital_Utsatt",
    PersonskadeArbeidsuforhet_Uforekapital_Info = "PersonskadeArbeidsuforhet_Uforekapital_Info",
    PersonskadeArbeidsuforhet_Uforekapital_Blindvei = "PersonskadeArbeidsuforhet_Uforekapital_Blindvei",
    PersonskadeArbeidsuforhet_Uforekapital_ErDuErklartVarigUfor_Utsatt = "PersonskadeArbeidsuforhet_Uforekapital_ErDuErklartVarigUfor_Utsatt",
    PersonskadeArbeidsuforhet_Uforekapital_IkkeVarigUfor_Utsatt = "PersonskadeArbeidsuforhet_Uforekapital_IkkeVarigUfor_Utsatt",
    PersonskadeArbeidsuforhet_Uforekapital_IkkeVarigUfor_Info = "PersonskadeArbeidsuforhet_Uforekapital_IkkeVarigUfor_Info",
    PersonskadeArbeidsuforhet_Uforekapital_IkkeVarigUfor_Blindvei = "PersonskadeArbeidsuforhet_Uforekapital_IkkeVarigUfor_Blindvei",
    PersonskadeArbeidsuforhet_ArbeidsuforIMerEnn2ArOgErklartVarigUfor = "PersonskadeArbeidsuforhet_ArbeidsuforIMerEnn2ArOgErklartVarigUfor",
    PersonskadeArbeidsuforhet_Diagnose = "PersonskadeArbeidsuforhet_Diagnose",
    PersonskadeArbeidsuforhet_LignendeSymptomer = "PersonskadeArbeidsuforhet_LignendeSymptomer",
    PersonskadeArbeidsuforhet_LignendeSymptomerBeskrivelse = "PersonskadeArbeidsuforhet_LignendeSymptomerBeskrivelse",
    PersonskadeArbeidsuforhet_StillingsbeskrivelseOgArbeidsoppgaver = "PersonskadeArbeidsuforhet_StillingsbeskrivelseOgArbeidsoppgaver",
    PersonskadeArbeidsuforhet_ArligInntekt = "PersonskadeArbeidsuforhet_ArligInntekt",
    PersonskadeArbeidsuforhet_InntektFraAnnenArbeidsgiver = "PersonskadeArbeidsuforhet_InntektFraAnnenArbeidsgiver",
    PersonskadeArbeidsuforhet_InntektFraAnnenArbeidsgiverPeriodeOgInntektskilde = "PersonskadeArbeidsuforhet_InntektFraAnnenArbeidsgiverPeriodeOgInntektskilde",
    PersonskadeArbeidsuforhet_GenerellArbeidsevne = "PersonskadeArbeidsuforhet_GenerellArbeidsevne",
    PersonskadeArbeidsuforhet_KanDuJobbe = "PersonskadeArbeidsuforhet_KanDuJobbe",
    PersonskadeArbeidsuforhet_IHvilkenGradKanDuJobbe = "PersonskadeArbeidsuforhet_IHvilkenGradKanDuJobbe",
    PersonskadeArbeidsuforhet_PlanOgForventninger = "PersonskadeArbeidsuforhet_PlanOgForventninger",
    PersonskadeArbeidsuforhet_SoktErstatningIAnnetSelskap = "PersonskadeArbeidsuforhet_SoktErstatningIAnnetSelskap",
    PersonskadeArbeidsuforhet_SelskapetsNavn = "PersonskadeArbeidsuforhet_SelskapetsNavn",
    PersonskadeArbeidsuforhet_YtelserFraNav = "PersonskadeArbeidsuforhet_YtelserFraNav",
    PersonskadeArbeidsuforhet_YtelserFraNavStatus = "PersonskadeArbeidsuforhet_YtelserFraNavStatus",
    PersonskadeArbeidsuforhet_YtelserFraNavInnvilgetDato = "PersonskadeArbeidsuforhet_YtelserFraNavInnvilgetDato",
    PersonskadeArbeidsuforhet_Fastlegekontor = "PersonskadeArbeidsuforhet_Fastlegekontor",
    PersonskadeArbeidsuforhet_Signering = "PersonskadeArbeidsuforhet_Signering",
    PersonskadeDodsfallInformasjonOmDenAvdode = "PersonskadeDodsfallInformasjonOmDenAvdode",
    PersonskadeDodsfallIHvilketLandSkjeddeDodsfallet = "PersonskadeDodsfallIHvilketLandSkjeddeDodsfallet",
    PersonskadeDodsfallHvordanDodePersonen = "PersonskadeDodsfallHvordanDodePersonen",
    PersonskadeDodsfallDiagnoseForDodsfall = "PersonskadeDodsfallDiagnoseForDodsfall",
    PersonskadeDodsfallBeskrivHvaSomSkjedde = "PersonskadeDodsfallBeskrivHvaSomSkjedde",
    PersonskadeDodsfallRelasjonTilAvdode = "PersonskadeDodsfallRelasjonTilAvdode",
    PersonskadeDodsfallRelasjonTilAvdodeAnnet = "PersonskadeDodsfallRelasjonTilAvdodeAnnet",
    PersonskadeDodsfallKontaktinformasjonPaVegneAv = "PersonskadeDodsfallKontaktinformasjonPaVegneAv",
    PersonskadeDodsfallHvilkenSkifterettBehandlerDodsfallet = "PersonskadeDodsfallHvilkenSkifterettBehandlerDodsfallet",
    PersonskadeDodsfallTestamente = "PersonskadeDodsfallTestamente",
    PersonskadeKritiskSykdom_DiagnoseVelger = "PersonskadeKritiskSykdom_DiagnoseVelger",
    PersonskadeKritiskSykdom_Diagnose = "PersonskadeKritiskSykdom_Diagnose",
    PersonskadeKritiskSykdom_SykdomEllerUlykke = "PersonskadeKritiskSykdom_SykdomEllerUlykke",
    PersonskadeKritiskSykdom_SammenhengForUlykken = "PersonskadeKritiskSykdom_SammenhengForUlykken",
    PersonskadeKritiskSykdom_SymptomerDato = "PersonskadeKritiskSykdom_SymptomerDato",
    PersonskadeKritiskSykdom_Fastlegekontor = "PersonskadeKritiskSykdom_Fastlegekontor",
    PersonskadeKritiskSykdom_Signering = "PersonskadeKritiskSykdom_Signering",
    Personforsikring_InformasjonOmBarnet = "Personforsikring_InformasjonOmBarnet",
    PersonBarneOgUngdomsforsikring_UlykkeBehandlingOgMedisineringBeskrivelse = "PersonBarneOgUngdomsforsikring_UlykkeBehandlingOgMedisineringBeskrivelse",
    PersonBarneOgUngdomsforsikring_UlykkeSkadeFortsattTilBehandling = "PersonBarneOgUngdomsforsikring_UlykkeSkadeFortsattTilBehandling",
    PersonBarneOgUngdomsforsikring_HendelseSkadeSykdom = "PersonBarneOgUngdomsforsikring_HendelseSkadeSykdom",
    PersonBarneOgUngdomsforsikring_SykdomDiagnose = "PersonBarneOgUngdomsforsikring_SykdomDiagnose",
    PersonBarneOgUngdomsforsikring_SykdomSymptomer = "PersonBarneOgUngdomsforsikring_SykdomSymptomer",
    PersonBarneOgUngdomsforsikring_SykdomLignendeTidligere = "PersonBarneOgUngdomsforsikring_SykdomLignendeTidligere",
    PersonBarneOgUngdomsforsikring_SykdomTidligereBehandletDato = "PersonBarneOgUngdomsforsikring_SykdomTidligereBehandletDato",
    PersonBarneOgUngdomsforsikring_SykdomTidligereBehandletLege = "PersonBarneOgUngdomsforsikring_SykdomTidligereBehandletLege",
    PersonBarneOgUngdomsforsikring_UlykkeSted = "PersonBarneOgUngdomsforsikring_UlykkeSted",
    PersonBarneOgUngdomsforsikring_UlykkeSammenheng = "PersonBarneOgUngdomsforsikring_UlykkeSammenheng",
    PersonBarneOgUngdomsforsikring_UlykkeVedTrafikkuhellUtsattForgreining = "PersonBarneOgUngdomsforsikring_UlykkeVedTrafikkuhellUtsattForgreining",
    PersonBarneOgUngdomsforsikring_UlykkeVedTrafikkuhell = "PersonBarneOgUngdomsforsikring_UlykkeVedTrafikkuhell",
    PersonBarneOgUngdomsforsikring_UlykkeTrafikkUhellEierOgRegistreringsnummerPaBil = "PersonBarneOgUngdomsforsikring_UlykkeTrafikkUhellEierOgRegistreringsnummerPaBil",
    PersonBarneOgUngdomsforsikring_UlykkeVedYrkesutovelse = "PersonBarneOgUngdomsforsikring_UlykkeVedYrkesutovelse",
    PersonBarneOgUngdomsforsikring_UlykkeYrkesutovelseArbeidsgiversNavn = "PersonBarneOgUngdomsforsikring_UlykkeYrkesutovelseArbeidsgiversNavn",
    PersonBarneOgUngdomsforsikring_UlykkeSkadeMeldtTilNav = "PersonBarneOgUngdomsforsikring_UlykkeSkadeMeldtTilNav",
    PersonBarneOgUngdomsforsikring_UlykkeHvaSkjedde = "PersonBarneOgUngdomsforsikring_UlykkeHvaSkjedde",
    PersonBarneOgUngdomsforsikring_UlykkeTannskade = "PersonBarneOgUngdomsforsikring_UlykkeTannskade",
    PersonBarneOgUngdomsforsikring_UlykkeHvilkeKroppsdelerSkadet = "PersonBarneOgUngdomsforsikring_UlykkeHvilkeKroppsdelerSkadet",
    PersonBarneOgUngdomsforsikring_UlykkeSkadetKroppsdelTidligereSkadet = "PersonBarneOgUngdomsforsikring_UlykkeSkadetKroppsdelTidligereSkadet",
    PersonBarneOgUngdomsforsikring_UlykkeRedegjorForTidligereSkade = "PersonBarneOgUngdomsforsikring_UlykkeRedegjorForTidligereSkade",
    PersonBarneOgUngdomsforsikring_UlykkeSkadetPavirketAvRusmidler = "PersonBarneOgUngdomsforsikring_UlykkeSkadetPavirketAvRusmidler",
    PersonBarneOgUngdomsforsikring_UlykkeRusmidlerBeskrivelse = "PersonBarneOgUngdomsforsikring_UlykkeRusmidlerBeskrivelse",
    PersonBarneOgUngdomsforsikring_UlykkeSkadeMeldtTilPolitiet = "PersonBarneOgUngdomsforsikring_UlykkeSkadeMeldtTilPolitiet",
    PersonBarneOgUngdomsforsikring_UlykkeNavnPaPolitistasjonSkadeErMeldt = "PersonBarneOgUngdomsforsikring_UlykkeNavnPaPolitistasjonSkadeErMeldt",
    PersonBarneOgUngdomsforsikring_FlereForsikringerSomDekkerUtgifter = "PersonBarneOgUngdomsforsikring_FlereForsikringerSomDekkerUtgifter",
    PersonBarneOgUngdomsforsikring_SelskapetsNavn = "PersonBarneOgUngdomsforsikring_SelskapetsNavn",
    PersonBarneOgUngdomsforsikring_TidligereSoktErstatning = "PersonBarneOgUngdomsforsikring_TidligereSoktErstatning",
    PersonBarneOgUngdomsforsikring_SoktEllerUtbetaltStonadFraFolketrygden = "PersonBarneOgUngdomsforsikring_SoktEllerUtbetaltStonadFraFolketrygden",
    PersonBarneOgUngdomsforsikring_StonadOgResultatAvSoknad = "PersonBarneOgUngdomsforsikring_StonadOgResultatAvSoknad",
    PersonBarneOgUngdomsforsikring_InnlagtPaaSykehusEllerInstitusjon = "PersonBarneOgUngdomsforsikring_InnlagtPaaSykehusEllerInstitusjon",
    ForsikringsEier = "ForsikringsEier",
    PersonBarneOgUngdomsforsikring_InnlagtPaaSykehusTidOgSted = "PersonBarneOgUngdomsforsikring_InnlagtPaaSykehusTidOgSted",
    KollisjonskadePaKjoretoy_VarDetPersonskade = "KollisjonskadePaKjoretoy_VarDetPersonskade",
    KollisjonskadePaKjoretoy_Skadearsak = "KollisjonskadePaKjoretoy_Skadearsak",
    KollisjonskadePaKjoretoy_ErGarasjeHusMurkantSkadet = "KollisjonskadePaKjoretoy_ErGarasjeHusMurkantSkadet",
    KollisjonskadePaKjoretoy_TrafikkskiltEllerAutovernOdelagt = "KollisjonskadePaKjoretoy_TrafikkskiltEllerAutovernOdelagt",
    KollisjonskadePaKjoretoy_FlereKjoretoyInvolvert = "KollisjonskadePaKjoretoy_FlereKjoretoyInvolvert",
    KollisjonskadePaKjoretoy_VarForerPavirketAvRus = "KollisjonskadePaKjoretoy_VarForerPavirketAvRus",
    KollisjonskadePaKjoretoy_KlokkeslettForSkade = "KollisjonskadePaKjoretoy_KlokkeslettForSkade",
    KollisjonskadePaKjoretoy_HastighetPaKjoretoy = "KollisjonskadePaKjoretoy_HastighetPaKjoretoy",
    KollisjonskadePaKjoretoy_FartsgrensePaSted = "KollisjonskadePaKjoretoy_FartsgrensePaSted",
    KollisjonskadePaKjoretoy_HvordanVarVaret = "KollisjonskadePaKjoretoy_HvordanVarVaret",
    KollisjonskadePaKjoretoy_DekkType = "KollisjonskadePaKjoretoy_DekkType",
    KollisjonskadePaKjoretoy_HvorSkjeddeSkaden = "KollisjonskadePaKjoretoy_HvorSkjeddeSkaden",
    KollisjonskadePaKjoretoy_HvilketDyr = "KollisjonskadePaKjoretoy_HvilketDyr",
    KollisjonskadePaKjoretoy_BeskrivHvaSomSkjedde = "KollisjonskadePaKjoretoy_BeskrivHvaSomSkjedde",
    KollisjonskadePaKjoretoy_KjoretoyIkkeForsikringstaker = "KollisjonskadePaKjoretoy_KjoretoyIkkeForsikringstaker",
    KollisjonskadePaKjoretoy_Side_HvilkenNarHvor = "KollisjonskadePaKjoretoy_Side_HvilkenNarHvor",
    KollisjonskadePaKjoretoy_Side_DetaljerOmUlykkesforholdene = "KollisjonskadePaKjoretoy_Side_DetaljerOmUlykkesforholdene",
    KollisjonskadePaKjoretoy_Side_Sjafor = "KollisjonskadePaKjoretoy_Side_Sjafor",
    KollisjonskadePaKjoretoy_Side_Personskade = "KollisjonskadePaKjoretoy_Side_Personskade",
    KollisjonskadePaKjoretoy_Side_AndreSkader = "KollisjonskadePaKjoretoy_Side_AndreSkader",
    KollisjonskadePaKjoretoy_Side_PolitiOgSkademelding = "KollisjonskadePaKjoretoy_Side_PolitiOgSkademelding",
    KollisjonskadePaKjoretoy_Side_ReparasjonAvSkade = "KollisjonskadePaKjoretoy_Side_ReparasjonAvSkade",
    KollisjonskadePaKjoretoy_Side_ReparasjonAvSkade_Utsatt = "KollisjonskadePaKjoretoy_Side_ReparasjonAvSkade_Utsatt",
    KollisjonskadePaKjoretoy_Rus = "KollisjonskadePaKjoretoy_Rus",
    Kjoretoy_Side_Hendelse = "Kjoretoy_Side_Hendelse",
    Kjoretoy_Utsatt_AndreInvolverteKjoretoy = "Kjoretoy_Utsatt_AndreInvolverteKjoretoy",
    KjoretoyAnmeldtTilPolitiet = "KjoretoyAnmeldtTilPolitiet",
    KjoretoyLeiebilSporsmalDekningKaskoLeiebil = "KjoretoyLeiebilSporsmalDekningKaskoLeiebil",
    KjoretoyLeiebilSporsmalDekningKaskoLeiebil_BeforeJulyFirst = "KjoretoyLeiebilSporsmalDekningKaskoLeiebil_BeforeJulyFirst",
    KjoretoyLeiebilSporsmalDekningKaskoLeiebil_AfterJanuaryFirst2025 = "KjoretoyLeiebilSporsmalDekningKaskoLeiebil_AfterJanuaryFirst2025",
    KjoretoyLeiebilSporsmalDekningKaskoLeiebil_JaNei = "KjoretoyLeiebilSporsmalDekningKaskoLeiebil_JaNei",
    KjoretoyLeiebilSporsmalDekningKaskoLeiebil_JaNei_JulyFirst2024_To_JanuaryFirst2025 = "KjoretoyLeiebilSporsmalDekningKaskoLeiebil_JaNei_JulyFirst2024_To_JanuaryFirst2025",
    KjoretoyLeiebilSporsmalDekningKaskoLeiebil_JaNei_BeforeJulyFirst = "KjoretoyLeiebilSporsmalDekningKaskoLeiebil_JaNei_BeforeJulyFirst",
    KjoretoyLeiebilSporsmalDekningKaskoLeiebil_JaNei_AfterJanuaryFirst2025 = "KjoretoyLeiebilSporsmalDekningKaskoLeiebil_JaNei_AfterJanuaryFirst2025",
    KjoretoyLeiebilSporsmalDekningKaskoBilPluss_BeforeJulyFirst = "KjoretoyLeiebilSporsmalDekningKaskoBilPluss_BeforeJulyFirst",
    KjoretoyLeiebilSporsmalDekningKaskoBilPluss_AfterJanuaryFirst2025 = "KjoretoyLeiebilSporsmalDekningKaskoBilPluss_AfterJanuaryFirst2025",
    KjoretoyLeiebilSporsmalDekningKaskoBilPluss = "KjoretoyLeiebilSporsmalDekningKaskoBilPluss",
    KjoretoyLeiebilSporsmalDekningKaskoBilPluss_JaNei = "KjoretoyLeiebilSporsmalDekningKaskoBilPluss_JaNei",
    KjoretoyLeiebilSporsmalDekningKaskoBilPluss_JaNei_BeforeJulyFirst = "KjoretoyLeiebilSporsmalDekningKaskoBilPluss_JaNei_BeforeJulyFirst",
    KjoretoyLeiebilSporsmalDekningKaskoBilPluss_JaNei_JulyFirst2024_To_JanuaryFirst2025 = "KjoretoyLeiebilSporsmalDekningKaskoBilPluss_JaNei_JulyFirst2024_To_JanuaryFirst2025",
    KjoretoyLeiebilSporsmalDekningKaskoBilPluss_JaNei_AfterJanuaryFirst2025 = "KjoretoyLeiebilSporsmalDekningKaskoBilPluss_JaNei_AfterJanuaryFirst2025",
    KjoretoyRegistreringsnummer = "KjoretoyRegistreringsnummer",
    HarDuVartIKontaktMedVerksted = "HarDuVartIKontaktMedVerksted",
    KjoretoyVerksted = "KjoretoyVerksted",
    KjoretoyNavnPaBilverksted = "KjoretoyNavnPaBilverksted",
    Kjoretoy_Utsatt_Leiebil_KaskoLeiebil_BeforeJulyFirst = "Kjoretoy_Utsatt_Leiebil_KaskoLeiebil_BeforeJulyFirst",
    Kjoretoy_Utsatt_Leiebil_KaskoLeiebil_AfterJanuaryFirst2025 = "Kjoretoy_Utsatt_Leiebil_KaskoLeiebil_AfterJanuaryFirst2025",
    Kjoretoy_Utsatt_Leiebil_KaskoLeiebil_BetweenJulyFirst2024_To_JanuaryFirst2025 = "Kjoretoy_Utsatt_Leiebil_KaskoLeiebil_BetweenJulyFirst2024_To_JanuaryFirst2025",
    Kjoretoy_Utsatt_Leiebil_BilPluss_BeforeJulyFirst = "Kjoretoy_Utsatt_Leiebil_BilPluss_BeforeJulyFirst",
    Kjoretoy_Utsatt_Leiebil_BilPluss_AfterJanuaryFirst2025 = "Kjoretoy_Utsatt_Leiebil_BilPluss_AfterJanuaryFirst2025",
    Kjoretoy_Utsatt_Leiebil_BilPluss_BetweenJulyFirst2024_To_JanuaryFirst2025 = "Kjoretoy_Utsatt_Leiebil_BilPluss_BetweenJulyFirst2024_To_JanuaryFirst2025",
    Kjoretoy_InformasjonOmHendelsen_Sporsmalside = "Kjoretoy_InformasjonOmHendelsen_Sporsmalside",
    Kjoretoy_VarKjoretoyetEuGodkjent = "Kjoretoy_VarKjoretoyetEuGodkjent",
    Kollisjon_HvemErAnsvarligForKollisjonen = "Kollisjon_HvemErAnsvarligForKollisjonen",
    KollisjonskadePaKjoretoy_HvaKolliderteDuMed = "KollisjonskadePaKjoretoy_HvaKolliderteDuMed",
    KollisjonskadePaKjoretoy_ErParteneEnigeOmHvemSomErAnsvarlig = "KollisjonskadePaKjoretoy_ErParteneEnigeOmHvemSomErAnsvarlig",
    KollisjonskadePaKjoretoy_HvaAnnetKolliderteDuMedDetalj = "KollisjonskadePaKjoretoy_HvaAnnetKolliderteDuMedDetalj",
    KollisjonskadePaKjoretoy_SjaforIDittKjoretoy = "KollisjonskadePaKjoretoy_SjaforIDittKjoretoy",
    KollisjonskadePaKjoretoy_Utsatt_SjaforIDittKjoretoy = "KollisjonskadePaKjoretoy_Utsatt_SjaforIDittKjoretoy",
    KollisjonskadePaKjoretoy_Personskade = "KollisjonskadePaKjoretoy_Personskade",
    Kollisjon_SkademeldingFyltUtMedMotpart = "Kollisjon_SkademeldingFyltUtMedMotpart",
    Kollisjon_SkademeldingFyltUtMedMotpart_Info = "Kollisjon_SkademeldingFyltUtMedMotpart_Info",
    Kollisjon_SituasjonSomForarsaketKollisjon = "Kollisjon_SituasjonSomForarsaketKollisjon",
    Kollisjon_SituasjonSomForarsaketKollisjon_ForarsaketAvAnnenPart = "Kollisjon_SituasjonSomForarsaketKollisjon_ForarsaketAvAnnenPart",
    Kollisjon_SituasjonSomForarsaketKollisjon_JegErAnsvarlig = "Kollisjon_SituasjonSomForarsaketKollisjon_JegErAnsvarlig",
    Kollisjon_BleKjoretoyetDittSkadet_IkkeLandbruk = "Kollisjon_BleKjoretoyetDittSkadet_IkkeLandbruk",
    Kollisjon_BleKjoretoyetDittSkadet_Landbruk = "Kollisjon_BleKjoretoyetDittSkadet_Landbruk",
    Kollisjon_Side_AndreInvolverteKjoretoy = "Kollisjon_Side_AndreInvolverteKjoretoy",
    Kollisjon_AndreInvolverteKjoretoyRegNummer = "Kollisjon_AndreInvolverteKjoretoyRegNummer",
    KollisjonBulkingEllerHarverkPaParkertKjoretoy_ArsakForsikringstaker = "KollisjonBulkingEllerHarverkPaParkertKjoretoy_ArsakForsikringstaker",
    KollisjonBulkingEllerHarverkPaParkertKjoretoy_ArsakMotpart = "KollisjonBulkingEllerHarverkPaParkertKjoretoy_ArsakMotpart",
    KollisjonBulkingEllerHarverkPaParkertKjoretoy_ArsakUenige = "KollisjonBulkingEllerHarverkPaParkertKjoretoy_ArsakUenige",
    Kjoretoy_BeskrivSkade = "Kjoretoy_BeskrivSkade",
    Kjoretoy_UreparertSkade = "Kjoretoy_UreparertSkade",
    BrannskadePaKjoretoy_Side_HvilkenNarHvor = "BrannskadePaKjoretoy_Side_HvilkenNarHvor",
    BrannskadePaKjoretoy_Hendelse = "BrannskadePaKjoretoy_Hendelse",
    BrannskadePaKjoretoy_Utbrent = "BrannskadePaKjoretoy_Utbrent",
    BrannskadePaKjoretoy_Side_SkaderPaAndresEiendom = "BrannskadePaKjoretoy_Side_SkaderPaAndresEiendom",
    BrannskadePaKjoretoy_SkaderPaAndresEiendom = "BrannskadePaKjoretoy_SkaderPaAndresEiendom",
    Bat_InformasjonOmHendelsen_Sporsmalside = "Bat_InformasjonOmHendelsen_Sporsmalside",
    Bat_SkadebegrensningOgTilsyn_Sporsmalside = "Bat_SkadebegrensningOgTilsyn_Sporsmalside",
    Bat_HvilkenSituasjonSkjeddeKollisjonen_JegErAnsvarlig = "Bat_HvilkenSituasjonSkjeddeKollisjonen_JegErAnsvarlig",
    Bat_HvilkenSituasjonSkjeddeKollisjonen_AndrePatenAnsvarlig = "Bat_HvilkenSituasjonSkjeddeKollisjonen_AndrePatenAnsvarlig",
    Bat_HvilkenSituasjonSkjeddeKollisjonen_UsikreUenigeVetIkkeHvemErAnsvarlig = "Bat_HvilkenSituasjonSkjeddeKollisjonen_UsikreUenigeVetIkkeHvemErAnsvarlig",
    Bat_OtherParty_SporsmalSide = "Bat_OtherParty_SporsmalSide",
    Bat_BrukteDuNavigasjonsutstyrDaSkadenSkjedde = "Bat_BrukteDuNavigasjonsutstyrDaSkadenSkjedde",
    Bat_HvorSkjeddeSkaden = "Bat_HvorSkjeddeSkaden",
    Bat_HvordanOppstodSkaden = "Bat_HvordanOppstodSkaden",
    Bat_HvaHarBlittSkadetCheckbox = "Bat_HvaHarBlittSkadetCheckbox",
    Bat_HvaAnnetHarBlittSkadet = "Bat_HvaAnnetHarBlittSkadet",
    Bat_HvaAnnetHarBlittSkadet_Utsatt = "Bat_HvaAnnetHarBlittSkadet_Utsatt",
    Bat_Side_Forer = "Bat_Side_Forer",
    Bat_ForerAvBat = "Bat_ForerAvBat",
    Bat_ForerInfoNarIkkeForsikringstaker = "Bat_ForerInfoNarIkkeForsikringstaker",
    Bat_Utsatt_BatforerbevisOgRus = "Bat_Utsatt_BatforerbevisOgRus",
    Bat_VarForerPavirketAvRus = "Bat_VarForerPavirketAvRus",
    Bat_HarPersonBatforerBevis = "Bat_HarPersonBatforerBevis",
    Kontaktinfo_Og_Forsikring = "Kontaktinfo_Og_Forsikring",
    Bat_HvorLiggerBatenNa = "Bat_HvorLiggerBatenNa",
    Bat_UtenbordsmotorStjalet = "Bat_UtenbordsmotorStjalet",
    Bat_SkaderPaBatenEtterInnbruddet = "Bat_SkaderPaBatenEtterInnbruddet",
    Bat_HvilkenTypeUtenbordsmotor = "Bat_HvilkenTypeUtenbordsmotor",
    Bat_HvilkeSkaderEtterInnbrudd = "Bat_HvilkeSkaderEtterInnbrudd",
    Bat_PolitiOgSkademelding_SporsmalSide = "Bat_PolitiOgSkademelding_SporsmalSide",
    Bat_InnbruddMeldtTilPoliti = "Bat_InnbruddMeldtTilPoliti",
    Bat_HvorBleBatenStjalet = "Bat_HvorBleBatenStjalet",
    Bat_SkadetSporsmalSide = "Bat_SkadetSporsmalSide",
    Bat_FikkDuHjelpFraRedningsselskapet = "Bat_FikkDuHjelpFraRedningsselskapet",
    Bat_HvaHarDuGjortForBegrenseSkadene = "Bat_HvaHarDuGjortForBegrenseSkadene",
    Bat_HvorKanTakstmannSeBatskaden = "Bat_HvorKanTakstmannSeBatskaden",
    Bat__Personskade = "Bat__Personskade",
    Bat__VarDetPersonskade = "Bat__VarDetPersonskade",
    Bat_HaddePersonenRedningsvest = "Bat_HaddePersonenRedningsvest",
    Bat_BleBryggenSkadetUnderKollisjonen = "Bat_BleBryggenSkadetUnderKollisjonen",
    Bat_EierAvBryggen_AttentionMessage = "Bat_EierAvBryggen_AttentionMessage",
    Bat_OtherParty_Navn = "Bat_OtherParty_Navn",
    Bat_OtherParty_Mobil = "Bat_OtherParty_Mobil",
    Bat_HvordanVarBatenFortoyd = "Bat_HvordanVarBatenFortoyd",
    Bat_HvordanVarVindstyrken = "Bat_HvordanVarVindstyrken",
    Bat_HvorLengeSidenSaTilBatenDin = "Bat_HvorLengeSidenSaTilBatenDin",
    Bat_ErBatenHevetEllerLiggerDenFortsattUnderVann = "Bat_ErBatenHevetEllerLiggerDenFortsattUnderVann",
    Bat_PersonerOmbordBaten_Sporsmalside = "Bat_PersonerOmbordBaten_Sporsmalside",
    Bat_VarDetPersonerOmbordBatenDaBatenSank = "Bat_VarDetPersonerOmbordBatenDaBatenSank",
    Bat_SunketElleDelvisSunket_Personskade_Utsatt = "Bat_SunketElleDelvisSunket_Personskade_Utsatt",
    Bat_StjaletEiendeler_Sporsmalside = "Bat_StjaletEiendeler_Sporsmalside",
    Bat_VarDetEiendelerSomBleStjalet = "Bat_VarDetEiendelerSomBleStjalet",
    Bat_VarEiendeleneInnelastEllerFastmontert = "Bat_VarEiendeleneInnelastEllerFastmontert",
    Bat_OppgiHvilkeEiendelerDuOnskerErstattet_SporsmalList = "Bat_OppgiHvilkeEiendelerDuOnskerErstattet_SporsmalList",
    Bat_HvaOnskerDuErstatningFor = "Bat_HvaOnskerDuErstatningFor",
    Bat_HvaKosterEiendelen = "Bat_HvaKosterEiendelen",
    Bat_HarDuKvitteringerEiendelenDuOnskerErstattet = "Bat_HarDuKvitteringerEiendelenDuOnskerErstattet",
    Kollisjon_PersonSkade_PersonList = "Kollisjon_PersonSkade_PersonList",
    Kollisjon_PersonSkade_PersonList_Person = "Kollisjon_PersonSkade_PersonList_Person",
    Kollisjon_PersonSkade_PersonList_Person_Rolle = "Kollisjon_PersonSkade_PersonList_Person_Rolle",
    Kollisjon_PersonSkade_PersonList_Person_Rolle_utsatt = "Kollisjon_PersonSkade_PersonList_Person_Rolle_utsatt",
    Kollisjon_PersonSkade_PersonList_Person_KontaktInformasjon = "Kollisjon_PersonSkade_PersonList_Person_KontaktInformasjon",
    Kollisjon_PersonSkade_PersonList_Person_Var_Sikret_under_ulykken = "Kollisjon_PersonSkade_PersonList_Person_Var_Sikret_under_ulykken",
    Kollisjon_PersonSkade_PersonList_Hvordan_Person_Var_Sikret_under_ulykken_utsatt = "Kollisjon_PersonSkade_PersonList_Hvordan_Person_Var_Sikret_under_ulykken_utsatt",
    Kollisjon_PersonSkade_PersonList_Hvordan_Person_Var_Sikret_under_ulykken = "Kollisjon_PersonSkade_PersonList_Hvordan_Person_Var_Sikret_under_ulykken",
    Kollisjon_PersonSkade_PersonList_Person_Var_Sikret_med_hjelm = "Kollisjon_PersonSkade_PersonList_Person_Var_Sikret_med_hjelm",
    Kollisjon_PersonSkade_PersonList_Person_Var_Sikret_med_hjelm_utsatt = "Kollisjon_PersonSkade_PersonList_Person_Var_Sikret_med_hjelm_utsatt",
    Kollisjon_PersonSkade_PersonList_Person_Medisinsk_Behandling = "Kollisjon_PersonSkade_PersonList_Person_Medisinsk_Behandling",
    AnnetKjoretoyRegistreringsnummer = "AnnetKjoretoyRegistreringsnummer",
    AnnetKjoretoy_BleKjoretoySkadet = "AnnetKjoretoy_BleKjoretoySkadet",
    Kollisjon_ReparasjonAvSkader = "Kollisjon_ReparasjonAvSkader",
    KontaktinfoSporsmalSide = "KontaktinfoSporsmalSide",
    Skadenummer = "Skadenummer",
    Reise_DatoForPlanlagtUtreise = "Reise_DatoForPlanlagtUtreise",
    Reise_DatoForPlanlagtHjemreise = "Reise_DatoForPlanlagtHjemreise",
    Reise_Reisemal = "Reise_Reisemal",
    Reise_Flyselskap = "Reise_Flyselskap",
    ReiseAvbestilling_RelasjonTilSykEllerAvdod_AndreIFamilie = "ReiseAvbestilling_RelasjonTilSykEllerAvdod_AndreIFamilie",
    ReiseAvbestilling_RelasjonTilSykEllerAvdod_Andre = "ReiseAvbestilling_RelasjonTilSykEllerAvdod_Andre",
    ReiseAvbestilling_HvemBleBetaltFor = "ReiseAvbestilling_HvemBleBetaltFor",
    ReiseAvbestilling_Sykdom_DokumentasjonFraLegeOmSykdommen = "ReiseAvbestilling_Sykdom_DokumentasjonFraLegeOmSykdommen",
    ReiseAvbestilling_Sykdom_HvorMangeReiserSammen_Andre = "ReiseAvbestilling_Sykdom_HvorMangeReiserSammen_Andre",
    ReiseAvbestilling_Sykdom_HvorMangeReiserSammen_NoenIReisefolget = "ReiseAvbestilling_Sykdom_HvorMangeReiserSammen_NoenIReisefolget",
    ReiseAvbestilling_Sykdom_SporsmalSide_SykPerson = "ReiseAvbestilling_Sykdom_SporsmalSide_SykPerson",
    ReiseAvbestilling_SporsmalSide_Reiseutgifter = "ReiseAvbestilling_SporsmalSide_Reiseutgifter",
    ReiseAvbestilling_ErDetFlybilletterDuHarKjopt = "ReiseAvbestilling_ErDetFlybilletterDuHarKjopt",
    ReiseAvbestilling_Reiseutgifter_DokumentasjonReiseAvbestilt = "ReiseAvbestilling_Reiseutgifter_DokumentasjonReiseAvbestilt",
    ReiseAvbestilling_IkkeRefundertFraReiseoperator_UtsattInformasjon = "ReiseAvbestilling_IkkeRefundertFraReiseoperator_UtsattInformasjon",
    ReiseAvbestilling_IkkeRefundertFraReiseoperator_Informasjon = "ReiseAvbestilling_IkkeRefundertFraReiseoperator_Informasjon",
    ReiseAvbestilling_Reiseutgifter_RefundertKostnaderFraReiseoperator = "ReiseAvbestilling_Reiseutgifter_RefundertKostnaderFraReiseoperator",
    ReiseAvbestilling_DatoForAvbestilling = "ReiseAvbestilling_DatoForAvbestilling",
    ReiseAvbestilling_Reiseutgifter_Land = "ReiseAvbestilling_Reiseutgifter_Land",
    ReiseAvbestilling_Reiseutgifter_BillettPris = "ReiseAvbestilling_Reiseutgifter_BillettPris",
    ReiseAvbestilling_Reiseutgifter_BillettRefundert_UtsattForgreining = "ReiseAvbestilling_Reiseutgifter_BillettRefundert_UtsattForgreining",
    ReiseAvbestilling_Reiseutgifter_BillettRefundert = "ReiseAvbestilling_Reiseutgifter_BillettRefundert",
    ReiseAvbestilling_SporsmalSide_AndreReiseutgifter = "ReiseAvbestilling_SporsmalSide_AndreReiseutgifter",
    ReiseAvbestilling_AndreReiseutgifter_UtgifterIForbindelseMedOpphold = "ReiseAvbestilling_AndreReiseutgifter_UtgifterIForbindelseMedOpphold",
    ReiseAvbestilling_AndreReiseutgifter_AndreUtgifterOnskeOmDekning = "ReiseAvbestilling_AndreReiseutgifter_AndreUtgifterOnskeOmDekning",
    ReiseAvbestilling_AndreReiseutgifter_DatoBetalteOppholdet = "ReiseAvbestilling_AndreReiseutgifter_DatoBetalteOppholdet",
    ReiseAvbestilling_AndreReiseutgifter_ReiseUtgiftSporsmalList = "ReiseAvbestilling_AndreReiseutgifter_ReiseUtgiftSporsmalList",
    ReiseAvbestilling_AndreReiseutgifter_PrisForOppholdet = "ReiseAvbestilling_AndreReiseutgifter_PrisForOppholdet",
    ReiseAvbestilling_AndreReiseutgifter_HvaBetalteDuFor = "ReiseAvbestilling_AndreReiseutgifter_HvaBetalteDuFor",
    ReiseAvbestilling_AndreReiseutgifter_DatoBetalte = "ReiseAvbestilling_AndreReiseutgifter_DatoBetalte",
    ReiseAvbestilling_AndreReiseutgifter_Pris = "ReiseAvbestilling_AndreReiseutgifter_Pris",
    ReiseAvbestilling_DokumentasjonAndreReiseutgifter_Utsatt = "ReiseAvbestilling_DokumentasjonAndreReiseutgifter_Utsatt",
    ReiseAvbestilling_DokumentasjonAndreReiseutgifter = "ReiseAvbestilling_DokumentasjonAndreReiseutgifter",
    ReiseMistetReisegods_InformasjonOmHendelsen_Side = "ReiseMistetReisegods_InformasjonOmHendelsen_Side",
    ReiseMistetReisegods_DatoMistetReisegods = "ReiseMistetReisegods_DatoMistetReisegods",
    ReiseMistetReisegods_Mistet_VedKantringGrunnstotingEllerKollisjon = "ReiseMistetReisegods_Mistet_VedKantringGrunnstotingEllerKollisjon",
    ReiseMistetReisegods_VarEiendelenInnsjekket = "ReiseMistetReisegods_VarEiendelenInnsjekket",
    ReiseMistetReisegods_OmEiendelen_Side = "ReiseMistetReisegods_OmEiendelen_Side",
    ReiseMistetReisegods_InformasjonOmEiendel_HarDuKjoptEiendelBrukt = "ReiseMistetReisegods_InformasjonOmEiendel_HarDuKjoptEiendelBrukt",
    ReiseMistetReisegods_DokumentasjonPaKjop = "ReiseMistetReisegods_DokumentasjonPaKjop",
    ReiseMistetReisegods_HvorSkjeddeSkaden = "ReiseMistetReisegods_HvorSkjeddeSkaden",
    ReiseSykdomSkadeEllerUlykke_InformasjonOmHendelsen_Side = "ReiseSykdomSkadeEllerUlykke_InformasjonOmHendelsen_Side",
    ReiseSykdomSkadeEllerUlykke_OmReisenOgUtgifter_Side = "ReiseSykdomSkadeEllerUlykke_OmReisenOgUtgifter_Side",
    ReiseSykdomSkadeEllerUlykke_AndreUtgifter_Side = "ReiseSykdomSkadeEllerUlykke_AndreUtgifter_Side",
    ReiseSykdomSkadeEllerUlykke_AndreUtgifter_Side_Utsatt = "ReiseSykdomSkadeEllerUlykke_AndreUtgifter_Side_Utsatt",
    ReiseSykdomSkadeEllerUlykke_HvemBleUtsattForSykdom = "ReiseSykdomSkadeEllerUlykke_HvemBleUtsattForSykdom",
    ReiseSykdomSkadeEllerUlykke_AntallPersoner = "ReiseSykdomSkadeEllerUlykke_AntallPersoner",
    ReiseSykdomSkadeEllerUlykke_HvordanOppstodSykdomEllerSkade = "ReiseSykdomSkadeEllerUlykke_HvordanOppstodSykdomEllerSkade",
    ReiseSykdomSkadeEllerUlykke_BleLegeOppsokt = "ReiseSykdomSkadeEllerUlykke_BleLegeOppsokt",
    ReiseSykdomSkadeEllerUlykke_DatoStartSykdomEllerSkade = "ReiseSykdomSkadeEllerUlykke_DatoStartSykdomEllerSkade",
    ReiseSykdomSkadeEllerUlykke_HvilkenDatoBleLegeOppsokt = "ReiseSykdomSkadeEllerUlykke_HvilkenDatoBleLegeOppsokt",
    ReiseSykdomSkadeEllerUlykke_ArsakTilAtLegeIkkeBleOppsokt = "ReiseSykdomSkadeEllerUlykke_ArsakTilAtLegeIkkeBleOppsokt",
    ReiseSykdomSkadeEllerUlykke_TapteFeriedager = "ReiseSykdomSkadeEllerUlykke_TapteFeriedager",
    ReiseSykdomSkadeEllerUlykke_TapteFeriedager_Utsatt = "ReiseSykdomSkadeEllerUlykke_TapteFeriedager_Utsatt",
    ReiseSykdomSkadeEllerUlykke_HvaBetalteDu = "ReiseSykdomSkadeEllerUlykke_HvaBetalteDu",
    ReiseSykdomSkadeEllerUlykke_HarDuBetaltForAndre = "ReiseSykdomSkadeEllerUlykke_HarDuBetaltForAndre",
    ReiseSykdomSkadeEllerUlykke_OppgiPeriodeSengeleie = "ReiseSykdomSkadeEllerUlykke_OppgiPeriodeSengeleie",
    ReiseSykdomSkadeEllerUlykke_SengeleieFra = "ReiseSykdomSkadeEllerUlykke_SengeleieFra",
    ReiseSykdomSkadeEllerUlykke_SengeleieTil = "ReiseSykdomSkadeEllerUlykke_SengeleieTil",
    ReiseSykdomSkadeEllerUlykke_DokumentasjonFraLege = "ReiseSykdomSkadeEllerUlykke_DokumentasjonFraLege",
    ReiseSykdomSkadeEllerUlykke_ArsakSengeleieUtenDokumentasjon = "ReiseSykdomSkadeEllerUlykke_ArsakSengeleieUtenDokumentasjon",
    ReiseSykdomSkadeEllerUlykke_ArsakSengeleieUtenDokumentasjon_Utsatt = "ReiseSykdomSkadeEllerUlykke_ArsakSengeleieUtenDokumentasjon_Utsatt",
    ReiseSykdomSkadeEllerUlykke_OppgiPlanlagteReisedatoer = "ReiseSykdomSkadeEllerUlykke_OppgiPlanlagteReisedatoer",
    ReiseSykdomSkadeEllerUlykke_NarDroDuHjemFraReisen = "ReiseSykdomSkadeEllerUlykke_NarDroDuHjemFraReisen",
    ReiseSykdomSkadeEllerUlykke_Behandlingsutgifter = "ReiseSykdomSkadeEllerUlykke_Behandlingsutgifter",
    ReiseSykdomSkadeEllerUlykke_Medisinutgifter = "ReiseSykdomSkadeEllerUlykke_Medisinutgifter",
    ReiseSykdomSkadeEllerUlykke_Transportutgifter = "ReiseSykdomSkadeEllerUlykke_Transportutgifter",
    ReiseSykdomSkadeEllerUlykke_DokumentasjonUtgifter = "ReiseSykdomSkadeEllerUlykke_DokumentasjonUtgifter",
    ReiseSykdomSkadeEllerUlykke_FikkDuGodkjentHjemreise = "ReiseSykdomSkadeEllerUlykke_FikkDuGodkjentHjemreise",
    ReiseSykdomSkadeEllerUlykke_HvaVarArsakTilAvbrytelseEllerForelengelseAvReise = "ReiseSykdomSkadeEllerUlykke_HvaVarArsakTilAvbrytelseEllerForelengelseAvReise",
    ReiseSykdomSkadeEllerUlykke_HvaVarArsakTilAvbrytelseEllerForelengelseAvReise_Utsatt = "ReiseSykdomSkadeEllerUlykke_HvaVarArsakTilAvbrytelseEllerForelengelseAvReise_Utsatt",
    ReiseSykdomSkadeEllerUlykke_HvilkenTypeBehandling = "ReiseSykdomSkadeEllerUlykke_HvilkenTypeBehandling",
    ReiseSykdomSkadeEllerUlykke_NarBetalteDuForBehandling = "ReiseSykdomSkadeEllerUlykke_NarBetalteDuForBehandling",
    ReiseSykdomSkadeEllerUlykke_PrisForBehandling = "ReiseSykdomSkadeEllerUlykke_PrisForBehandling",
    ReiseSykdomSkadeEllerUlykke_NarBetalteDuForMedisin = "ReiseSykdomSkadeEllerUlykke_NarBetalteDuForMedisin",
    ReiseSykdomSkadeEllerUlykke_PrisForMedisin = "ReiseSykdomSkadeEllerUlykke_PrisForMedisin",
    ReiseSykdomSkadeEllerUlykke_HvilkenTypeTransportmiddel = "ReiseSykdomSkadeEllerUlykke_HvilkenTypeTransportmiddel",
    ReiseSykdomSkadeEllerUlykke_NarBetalteDuForTransport = "ReiseSykdomSkadeEllerUlykke_NarBetalteDuForTransport",
    ReiseSykdomSkadeEllerUlykke_PrisForTransport = "ReiseSykdomSkadeEllerUlykke_PrisForTransport",
    ReiseSykdomSkadeEllerUlykke_PrisForOmbookingEllerNyeBilletter = "ReiseSykdomSkadeEllerUlykke_PrisForOmbookingEllerNyeBilletter",
    ReiseSykdomSkadeEllerUlykke_HarDuAndreUtgifter = "ReiseSykdomSkadeEllerUlykke_HarDuAndreUtgifter",
    ReiseSykdomSkadeEllerUlykke_LeggTilAndreReiseutgifter = "ReiseSykdomSkadeEllerUlykke_LeggTilAndreReiseutgifter",
    ReiseSykdomSkadeEllerUlykke_AnnenReiseutgift = "ReiseSykdomSkadeEllerUlykke_AnnenReiseutgift",
    ReiseSykdomSkadeEllerUlykke_DatoAnnenReiseutgiftBetalt = "ReiseSykdomSkadeEllerUlykke_DatoAnnenReiseutgiftBetalt",
    ReiseSykdomSkadeEllerUlykke_PrisPaAnnenReiseutgift = "ReiseSykdomSkadeEllerUlykke_PrisPaAnnenReiseutgift",
    ReiseSykdomSkadeEllerUlykke_DokumentasjonAndreUtgifter = "ReiseSykdomSkadeEllerUlykke_DokumentasjonAndreUtgifter",
    ReiseDodsfallEllerAlvorligSykdom_InformasjonOmHendelsen_Side = "ReiseDodsfallEllerAlvorligSykdom_InformasjonOmHendelsen_Side",
    ReiseDodsfallEllerAlvorligSykdom_DetaljertForklaring = "ReiseDodsfallEllerAlvorligSykdom_DetaljertForklaring",
    ReiseDodsfallEllerAlvorligSykdom_HvilkenRelasjon = "ReiseDodsfallEllerAlvorligSykdom_HvilkenRelasjon",
    ReiseDodsfallEllerAlvorligSykdom_HvemMatteAvbryteReisen = "ReiseDodsfallEllerAlvorligSykdom_HvemMatteAvbryteReisen",
    ReiseDodsfallEllerAlvorligSykdom_HvorMangePersoner = "ReiseDodsfallEllerAlvorligSykdom_HvorMangePersoner",
    ReiseDodsfallEllerAlvorligSykdom_OppgiPlanlagtReiseperiode = "ReiseDodsfallEllerAlvorligSykdom_OppgiPlanlagtReiseperiode",
    ReiseDodsfallEllerAlvorligSykdom_PrisForReiseOgOpphold = "ReiseDodsfallEllerAlvorligSykdom_PrisForReiseOgOpphold",
    ReiseDodsfallEllerAlvorligSykdom_DatoAbrytningAvReise = "ReiseDodsfallEllerAlvorligSykdom_DatoAbrytningAvReise",
    ReiseDodsfallEllerAlvorligSykdom_FikkDuGodkjentHjemreise = "ReiseDodsfallEllerAlvorligSykdom_FikkDuGodkjentHjemreise",
    ReiseDodsfallEllerAlvorligSykdom_LeggTilAndreReiseutgifter = "ReiseDodsfallEllerAlvorligSykdom_LeggTilAndreReiseutgifter",
    ReiseDodsfallEllerAlvorligSykdom_AnnenReiseutgift = "ReiseDodsfallEllerAlvorligSykdom_AnnenReiseutgift",
    ReiseDodsfallEllerAlvorligSykdom_DatoAnnenReiseutgiftBetalt = "ReiseDodsfallEllerAlvorligSykdom_DatoAnnenReiseutgiftBetalt",
    ReiseDodsfallEllerAlvorligSykdom_PrisPaAnnenReiseutgift = "ReiseDodsfallEllerAlvorligSykdom_PrisPaAnnenReiseutgift",
    ReiseDodsfallEllerAlvorligSykdom_DokumentasjonReiseutgifter = "ReiseDodsfallEllerAlvorligSykdom_DokumentasjonReiseutgifter",
    ReiseGjenglemtReisegods_InformasjonOmHendelsen_Side = "ReiseGjenglemtReisegods_InformasjonOmHendelsen_Side",
    ReiseSkadetReisegods_DatoReisegodsGjenglemt = "ReiseSkadetReisegods_DatoReisegodsGjenglemt",
    ReiseGjenglemtReisegods_OmReisegodset_Side = "ReiseGjenglemtReisegods_OmReisegodset_Side",
    ReiseEiendel_DetaljertForklaringPaHvaSomSkjedde = "ReiseEiendel_DetaljertForklaringPaHvaSomSkjedde",
    ReiseEiendel_InformasjonOmEiendelen_SporsmalList = "ReiseEiendel_InformasjonOmEiendelen_SporsmalList",
    ReiseEiendel_InformasjonOmEiendel_AppleProdukt = "ReiseEiendel_InformasjonOmEiendel_AppleProdukt",
    ReiseEiendel_InformasjonOmEiendel_Type = "ReiseEiendel_InformasjonOmEiendel_Type",
    ReiseEiendel_InformasjonOmEiendel_MerkeOgModell = "ReiseEiendel_InformasjonOmEiendel_MerkeOgModell",
    ReiseEiendel_InformasjonOmEiendel_NarBetalteDuForEiendelen = "ReiseEiendel_InformasjonOmEiendel_NarBetalteDuForEiendelen",
    ReiseEiendel_InformasjonOmEiendel_Pris = "ReiseEiendel_InformasjonOmEiendel_Pris",
    ReiseSkadetReisegods_InformasjonOmHendelsen = "ReiseSkadetReisegods_InformasjonOmHendelsen",
    ReiseSkadetReisegods_DatoReisegodsSkadet = "ReiseSkadetReisegods_DatoReisegodsSkadet",
    ReiseSkadetReisegods_HvorSkjeddeSkaden = "ReiseSkadetReisegods_HvorSkjeddeSkaden",
    ReiseSkadetReisegods_VarReisegodsInnsjekketBagasjeSkadet = "ReiseSkadetReisegods_VarReisegodsInnsjekketBagasjeSkadet",
    ReiseSkadetReisegods_VarReisegodsInnsjekketBagasjeSkadet_Ja_AttentionMessage = "ReiseSkadetReisegods_VarReisegodsInnsjekketBagasjeSkadet_Ja_AttentionMessage",
    ReiseSkadetReisegods_HarFremdelesReisegodset = "ReiseSkadetReisegods_HarFremdelesReisegodset",
    ReiseSkadetReisegods_SporsmalSideInformasjonOmReisegodsetList = "ReiseSkadetReisegods_SporsmalSideInformasjonOmReisegodsetList",
    ReiseSkadetReisegods_Skadet_VedKantringGrunnstotingEllerKollisjon = "ReiseSkadetReisegods_Skadet_VedKantringGrunnstotingEllerKollisjon",
    ReiseSkadetReisegods_HarDuFattPrisPaReparasjon = "ReiseSkadetReisegods_HarDuFattPrisPaReparasjon",
    Reiseavbestilling_AnnenArsak_InformasjonOmHendelsen_HvaSkjedde = "Reiseavbestilling_AnnenArsak_InformasjonOmHendelsen_HvaSkjedde",
    Reiseavbestilling_AnnenArsak_InformasjonOmHendelsen = "Reiseavbestilling_AnnenArsak_InformasjonOmHendelsen",
    PersonskadeUlykke_HvemHarBlittSkadet = "PersonskadeUlykke_HvemHarBlittSkadet",
    Personforsikring_InformasjonOmEktefellePartner = "Personforsikring_InformasjonOmEktefellePartner",
    Elsparkesykkel_InformasjonOmHendelsen_SporsmalSide = "Elsparkesykkel_InformasjonOmHendelsen_SporsmalSide",
    Elsparkesykkel_HvemErAnsvarlig = "Elsparkesykkel_HvemErAnsvarlig",
    Elsparkesykkel_SkadetElsparkesykkel_sporsmalSide = "Elsparkesykkel_SkadetElsparkesykkel_sporsmalSide",
    Elsparkesykkel_BleElsparkesykkelenSkadet = "Elsparkesykkel_BleElsparkesykkelenSkadet",
    Elsparkesykkel_Serienummer = "Elsparkesykkel_Serienummer",
    Elsparkesykkel_ForerAvElsparkesykkelen_SporsmalSider = "Elsparkesykkel_ForerAvElsparkesykkelen_SporsmalSider",
    Elsparkesykkel_HvemVarForer = "Elsparkesykkel_HvemVarForer",
    Elsparkesykkel_VarForerenPavirketAvRusmidler = "Elsparkesykkel_VarForerenPavirketAvRusmidler",
    Elsparkesykkel_AnnenForer_KontaktInfo = "Elsparkesykkel_AnnenForer_KontaktInfo",
    Elsparkesykkel_Personskade_SporsmalSide = "Elsparkesykkel_Personskade_SporsmalSide",
    Elsparkesykkel_PersonSkade_PersonList = "Elsparkesykkel_PersonSkade_PersonList",
    Elsparkesykkel_PersonSkade_PersonList_Person_Rolle = "Elsparkesykkel_PersonSkade_PersonList_Person_Rolle",
    Elsparkesykkel_PersonSkade_PersonList_Person_KontaktInformasjon = "Elsparkesykkel_PersonSkade_PersonList_Person_KontaktInformasjon",
    Elsparkesykkel_VarPersonenSikretMedHjelm = "Elsparkesykkel_VarPersonenSikretMedHjelm",
    Bygning_Glasskade_InformasjonOmSkaden_Sporsmalside = "Bygning_Glasskade_InformasjonOmSkaden_Sporsmalside",
    Bygning_Glasskade_HvaHarSkjeddMedGlasset = "Bygning_Glasskade_HvaHarSkjeddMedGlasset",
    Bygning_Glasskade_HvordanKnusteGlasset = "Bygning_Glasskade_HvordanKnusteGlasset",
    Bygning_Glasskade_OppgiHvordanKnusteGlasset = "Bygning_Glasskade_OppgiHvordanKnusteGlasset",
    Bygning_Glasskade_ErSkadenUtbedretEllerReparasjonskostnadInnhentet = "Bygning_Glasskade_ErSkadenUtbedretEllerReparasjonskostnadInnhentet",
    Bygning_Glasskade_GrunnAnnetTrengerMerForklaring_UtsattForgreining = "Bygning_Glasskade_GrunnAnnetTrengerMerForklaring_UtsattForgreining",
    Bygning_Glasskade_GrunnHarverkEllerInnbrudd_Politi_UtsattForgreining = "Bygning_Glasskade_GrunnHarverkEllerInnbrudd_Politi_UtsattForgreining",
    Bygning_Glasskade_IkkeAnmeldtTilPolitiet_WarningMessage = "Bygning_Glasskade_IkkeAnmeldtTilPolitiet_WarningMessage",
    Bygning_Glasskade_AnmeldtTilPolitiet_WarningMessage = "Bygning_Glasskade_AnmeldtTilPolitiet_WarningMessage",
    Bygning_Glasskade_AndreSkader_SporsmalSide = "Bygning_Glasskade_AndreSkader_SporsmalSide",
    Bygning_Glasskade_AndreSkaderPaBygningen = "Bygning_Glasskade_AndreSkaderPaBygningen",
    Bygning_AnmeldtTilPolitiet = "Bygning_AnmeldtTilPolitiet",
    Bygning_Informasjon_SporsmalSide = "Bygning_Informasjon_SporsmalSide",
    Bygning_HvaErSkadet = "Bygning_HvaErSkadet",
    Bygning_Naturskade_Naturhendelse = "Bygning_Naturskade_Naturhendelse",
    Bygning_HarDuEiendelerSkadet = "Bygning_HarDuEiendelerSkadet",
    Bygning_BeskrivelseHvaHarSkjedd = "Bygning_BeskrivelseHvaHarSkjedd",
    Bygning_ForsikringsnummerOgSkadested_SporsmalSide = "Bygning_ForsikringsnummerOgSkadested_SporsmalSide",
    Bygning_AdressenTilSkadested_AttentionMessage_FeilAdresse = "Bygning_AdressenTilSkadested_AttentionMessage_FeilAdresse",
    Bygning_AdressenTilSkadested_AttentionMessage_IngenForsikring = "Bygning_AdressenTilSkadested_AttentionMessage_IngenForsikring",
    Bygning_AdressenTilSkadested_Adresse_FeilAdresse = "Bygning_AdressenTilSkadested_Adresse_FeilAdresse",
    Bygning_AdressenTilSkadested_Adresse_IngenForsikring = "Bygning_AdressenTilSkadested_Adresse_IngenForsikring",
    Bygning_AdressenTilSkadested_Postnummer_FeilAdresse = "Bygning_AdressenTilSkadested_Postnummer_FeilAdresse",
    Bygning_AdressenTilSkadested_Postnummer_IngenForsikring = "Bygning_AdressenTilSkadested_Postnummer_IngenForsikring",
    Bygning_Vannskade_Utvendig_Ror_HvorKommerLekkasjeFra = "Bygning_Vannskade_Utvendig_Ror_HvorKommerLekkasjeFra",
    Bygning_Vannskade_HarFagpersonHjulpet = "Bygning_Vannskade_HarFagpersonHjulpet",
    Bygning_FagpersonJaInformasjon_Utsatt = "Bygning_FagpersonJaInformasjon_Utsatt",
    Bygning_Vannskade_FagpersonJaInformasjon = "Bygning_Vannskade_FagpersonJaInformasjon",
    Bygning_FagpersonNeiInformasjon_Utsatt = "Bygning_FagpersonNeiInformasjon_Utsatt",
    Bygning_Vannskade_FagpersonNeiInformasjon = "Bygning_Vannskade_FagpersonNeiInformasjon",
    Bygning_Vannskade_HvilketRomSkadenSkjedd = "Bygning_Vannskade_HvilketRomSkadenSkjedd",
    Bygning_Vannskade_ErRommetInnredet_Utsatt = "Bygning_Vannskade_ErRommetInnredet_Utsatt",
    Bygning_Vannskade_ErRommetInnredet = "Bygning_Vannskade_ErRommetInnredet",
    Bygning_Harverk_HarNoenEiendelerHarBlittSkadet = "Bygning_Harverk_HarNoenEiendelerHarBlittSkadet",
    Bygning_Harverk_OppgiHvilkeEiendelerSomBleSkadet = "Bygning_Harverk_OppgiHvilkeEiendelerSomBleSkadet",
    Bygning_ErSkadenUtbedret = "Bygning_ErSkadenUtbedret",
    Bygning_SkadenErUtbedret = "Bygning_SkadenErUtbedret",
    Bygning_SkadenErIkkeUtbedret = "Bygning_SkadenErIkkeUtbedret",
    Bygning_ElektriskSkade_FrittstaendeProdukt = "Bygning_ElektriskSkade_FrittstaendeProdukt",
    Bygning_ElektriskSkade_FastmontertProdukt = "Bygning_ElektriskSkade_FastmontertProdukt",
    Bygning_ElektriskSkade_ElektriskAnlegg = "Bygning_ElektriskSkade_ElektriskAnlegg",
    Bygning_ElektriskSkade_Stromleverandor_SporsmalSide = "Bygning_ElektriskSkade_Stromleverandor_SporsmalSide",
    Bygning_ElektriskSkade_StromleverandorFeilmelding = "Bygning_ElektriskSkade_StromleverandorFeilmelding",
    Bygning_ElektriskSkade_Strom = "Bygning_ElektriskSkade_Strom",
    Bygning_BrannskaderOgSot_Hendelse = "Bygning_BrannskaderOgSot_Hendelse",
    Bygning_BrannskaderOgSot_HvorIBolig = "Bygning_BrannskaderOgSot_HvorIBolig",
    Bygning_Innbrudd_HvilkeBygningsskaderHarOppstatt = "Bygning_Innbrudd_HvilkeBygningsskaderHarOppstatt",
    Bygning_Innbrudd_VinduerLukketDorerLast = "Bygning_Innbrudd_VinduerLukketDorerLast",
    Bygning_Innbrudd_NoenEiendelerSomHarBlittstjalet = "Bygning_Innbrudd_NoenEiendelerSomHarBlittstjalet",
    Bygning_Innbrudd_OppgiHvilkeEiendelerSomBleStjalet = "Bygning_Innbrudd_OppgiHvilkeEiendelerSomBleStjalet",
    Bygning_LekkasjerOgVannskader_InformasjonOmSkaden_SporsmalSide = "Bygning_LekkasjerOgVannskader_InformasjonOmSkaden_SporsmalSide",
    Bygning_LekkasjerOgVannskader_HvilketRomOppdagetDuVannlekkasjen = "Bygning_LekkasjerOgVannskader_HvilketRomOppdagetDuVannlekkasjen",
    Bygning_LekkasjerOgVannskader_ErRommetInnredet = "Bygning_LekkasjerOgVannskader_ErRommetInnredet",
    Bygning_LekkasjerOgVannskader_HvorKommerVannetFra = "Bygning_LekkasjerOgVannskader_HvorKommerVannetFra",
    Bygning_LekkasjerOgVannskader_SkyldesVannlekkasjenFrost = "Bygning_LekkasjerOgVannskader_SkyldesVannlekkasjenFrost",
    Bygning_LekkasjerOgVannskader_SkadedeEiendeler = "Bygning_LekkasjerOgVannskader_SkadedeEiendeler",
    Bygning_LekkasjerOgVannskader_HvorkommerVannetInn = "Bygning_LekkasjerOgVannskader_HvorkommerVannetInn",
    Bygning_LekkasjerOgVannskader_VannskadeInneIBygningen = "Bygning_LekkasjerOgVannskader_VannskadeInneIBygningen",
    Bygning_LekkasjerOgVannskader_Kjeller_Innredet = "Bygning_LekkasjerOgVannskader_Kjeller_Innredet",
    Bygning_LekkasjerOgVannskader_Kjeller_HvaBeskriverVannskadenBest = "Bygning_LekkasjerOgVannskader_Kjeller_HvaBeskriverVannskadenBest",
    InnboEiendeler_TidspunktKjopt = "InnboEiendeler_TidspunktKjopt",
    InnboEiendeler_InformasjonOmSkaden_Sporsmalside = "InnboEiendeler_InformasjonOmSkaden_Sporsmalside",
    InnboEiendeler_HvaSkjeddeMedFryseren = "InnboEiendeler_HvaSkjeddeMedFryseren",
    InnboEiendeler_HvaErSkadet = "InnboEiendeler_HvaErSkadet",
    InnboEiendeler_OmFryseren = "InnboEiendeler_OmFryseren",
    InnboEiendeler_OmFryseren_HvilkenTypeSkadeHarSkjedd = "InnboEiendeler_OmFryseren_HvilkenTypeSkadeHarSkjedd",
    InnboEiendeler_OmFryseren_HvilkenTypeFryserErSkadet = "InnboEiendeler_OmFryseren_HvilkenTypeFryserErSkadet",
    InnboEiendeler_OmFryseren_BleFryserenKjoptNy = "InnboEiendeler_OmFryseren_BleFryserenKjoptNy",
    InnboEiendeler_OmFryseren_HvorGammelErFryseren = "InnboEiendeler_OmFryseren_HvorGammelErFryseren",
    InnboEiendeler_OmFryseren_HvorGammelErFryseren_AntallAr = "InnboEiendeler_OmFryseren_HvorGammelErFryseren_AntallAr",
    InnboEiendeler_OmFryseren_ProdusentOgModellnummer = "InnboEiendeler_OmFryseren_ProdusentOgModellnummer",
    InnboEiendeler_OmFryseren_HvorMangeLiterErFryseren = "InnboEiendeler_OmFryseren_HvorMangeLiterErFryseren",
    InnboEiendeler_OmFryseren_HvorMyeKostetFryseren = "InnboEiendeler_OmFryseren_HvorMyeKostetFryseren",
    InnboEiendeler_OmFryseren_Dokumentasjon = "InnboEiendeler_OmFryseren_Dokumentasjon",
    InnboEiendeler_OmMatvarer = "InnboEiendeler_OmMatvarer",
    InnboEiendeler_OmMatvarer_VilDuListeOppMatvarer = "InnboEiendeler_OmMatvarer_VilDuListeOppMatvarer",
    InnboEiendeler_AttentionMessage_BeregneSkade = "InnboEiendeler_AttentionMessage_BeregneSkade",
    InnboEiendeler_OmMatvarer_AntallLiterFryser = "InnboEiendeler_OmMatvarer_AntallLiterFryser",
    InnboEiendeler_OmMatvarer_HvorMangeLiterMatvarerIFryseren = "InnboEiendeler_OmMatvarer_HvorMangeLiterMatvarerIFryseren",
    InnboEiendeler_OmMatvarer_EgenListe = "InnboEiendeler_OmMatvarer_EgenListe",
    InnboEiendeler_OmMatvarer_MatvareKategori = "InnboEiendeler_OmMatvarer_MatvareKategori",
    InnboEiendeler_OmMatvarer_MatvareAntallKg = "InnboEiendeler_OmMatvarer_MatvareAntallKg",
    InnboEiendeler_OmMatvarer_MatvareCaTotalpris = "InnboEiendeler_OmMatvarer_MatvareCaTotalpris",
    InnboEiendeler_OmMatvarer_Dokumentasjon = "InnboEiendeler_OmMatvarer_Dokumentasjon",
    InnboEiendeler_OmMatvarer_Utsatt = "InnboEiendeler_OmMatvarer_Utsatt",
    InnboEiendeler_OmFryser_Utsatt = "InnboEiendeler_OmFryser_Utsatt",
    InnboEiendeler_OmMatvarerOgFryser_Utsatt = "InnboEiendeler_OmMatvarerOgFryser_Utsatt",
    InnboEiendeler_HvorSkjeddeSkadenRadio = "InnboEiendeler_HvorSkjeddeSkadenRadio",
    InnboEiendeler_HvorSkjeddeSkadenTekst = "InnboEiendeler_HvorSkjeddeSkadenTekst",
    InnboEiendeler_TvElektriskeProdukterAndre_Informasjon_SporsmalSide = "InnboEiendeler_TvElektriskeProdukterAndre_Informasjon_SporsmalSide",
    InnboEiendeler_HvordanBleProduktetSkadet = "InnboEiendeler_HvordanBleProduktetSkadet",
    InnboEiendeler_TvElektriskeProdukter_OmProduktet_SporsmalSide = "InnboEiendeler_TvElektriskeProdukter_OmProduktet_SporsmalSide",
    InnboEiendeler_TvElektriskeProdukter_LeggTilInformasjonOmProduktet_SporsmalList = "InnboEiendeler_TvElektriskeProdukter_LeggTilInformasjonOmProduktet_SporsmalList",
    InnboEiendeler_TvElektriskeProdukter_TypeElektriskProduktSkadet = "InnboEiendeler_TvElektriskeProdukter_TypeElektriskProduktSkadet",
    InnboEiendeler_TvElektriskeProdukter_ProdusentOgModellnummer = "InnboEiendeler_TvElektriskeProdukter_ProdusentOgModellnummer",
    InnboEiendeler_TvElektriskeProdukter_GarantienTilButikkEllerProdusent = "InnboEiendeler_TvElektriskeProdukter_GarantienTilButikkEllerProdusent",
    InnboEiendeler_TvElektriskeProdukter_KvitteringerEllerDokumentasjon = "InnboEiendeler_TvElektriskeProdukter_KvitteringerEllerDokumentasjon",
    InnboEiendeler_InformasjonOmSkadeSporsmalSide = "InnboEiendeler_InformasjonOmSkadeSporsmalSide",
    InnboEiendeler_HvorSkjeddeSkaden = "InnboEiendeler_HvorSkjeddeSkaden",
    InnboEiendeler_HvordanBleEiendelenSkadet = "InnboEiendeler_HvordanBleEiendelenSkadet",
    InnboEiendeler_HarDuTattVarePaSkadeteProduktet = "InnboEiendeler_HarDuTattVarePaSkadeteProduktet",
    InnboEiendeler_DetaljertBeskrivelseAvHvaSkjedd = "InnboEiendeler_DetaljertBeskrivelseAvHvaSkjedd",
    InnboEiendeler_InformasjonOmProduktSporsmalSide = "InnboEiendeler_InformasjonOmProduktSporsmalSide",
    InnboEiendeler_ProduktSkadet = "InnboEiendeler_ProduktSkadet",
    InnboEiendeler_EiendelSkadet = "InnboEiendeler_EiendelSkadet",
    InnboEiendeler_ProduktMerkeOgModell = "InnboEiendeler_ProduktMerkeOgModell",
    InnboEiendeler_KjoptProduktBrukt = "InnboEiendeler_KjoptProduktBrukt",
    InnboEiendeler_HarDuFattPrisPaReparasjon = "InnboEiendeler_HarDuFattPrisPaReparasjon",
    InnboEiendeler_DuMaTaKontaktMedProdusentenInformasjon = "InnboEiendeler_DuMaTaKontaktMedProdusentenInformasjon",
    InnboEiendeler_FirmaKontaktetForReparasjonAvProduktet = "InnboEiendeler_FirmaKontaktetForReparasjonAvProduktet",
    InnboEiendeler_PrisForReparasjon = "InnboEiendeler_PrisForReparasjon",
    InnboEiendeler_HarDuKvitteringerEllerDokumentasjonPaProduktet = "InnboEiendeler_HarDuKvitteringerEllerDokumentasjonPaProduktet",
    InnboEiendeler_Dekning = "InnboEiendeler_Dekning",
    InnboEiendeler_InformasjonOmHendelsen_Sporsmalside = "InnboEiendeler_InformasjonOmHendelsen_Sporsmalside",
    InnboEiendeler_HvorSkjeddeTyveriet = "InnboEiendeler_HvorSkjeddeTyveriet",
    InnboEiendeler_Tyveri_AndreSkaderPaBygningen = "InnboEiendeler_Tyveri_AndreSkaderPaBygningen",
    InnboEiendeler_Tyveri_VarAlleVinduerOgDorerLukket = "InnboEiendeler_Tyveri_VarAlleVinduerOgDorerLukket",
    InnboEiendeler_Tyveri_HaddeDuAktivAlarm = "InnboEiendeler_Tyveri_HaddeDuAktivAlarm",
    InnboEiendeler_HvorBleEiendelenStjalet = "InnboEiendeler_HvorBleEiendelenStjalet",
    InnboEiendeler_OmEiendelen_SporsmalSide = "InnboEiendeler_OmEiendelen_SporsmalSide",
    InnboEiendeler_HvorMangeEiendelerBleStjalet = "InnboEiendeler_HvorMangeEiendelerBleStjalet",
    InnboEiendeler_Tyveri_OppgiHvaSomHarBlittStjalet = "InnboEiendeler_Tyveri_OppgiHvaSomHarBlittStjalet",
    InnboEiendeler_DokumentasjonPaStjaletEiendel = "InnboEiendeler_DokumentasjonPaStjaletEiendel",
    InnboEiendeler_SporsmalList_MoreThan5Eiendeler = "InnboEiendeler_SporsmalList_MoreThan5Eiendeler",
    InnboEiendeler_Tyveri_HvaSlagsEiendelErStjalet = "InnboEiendeler_Tyveri_HvaSlagsEiendelErStjalet",
    InnboEiendeler_Tyveri_KjopteDuEiendelenBrukt = "InnboEiendeler_Tyveri_KjopteDuEiendelenBrukt",
    InnboEiendeler_HvorMyeKostetEiendelen = "InnboEiendeler_HvorMyeKostetEiendelen",
    InnboEiendeler_HvorGammelErEiendelen = "InnboEiendeler_HvorGammelErEiendelen",
    InnboEiendeler_AttentionMessage_PolitianmeldelseTaVare = "InnboEiendeler_AttentionMessage_PolitianmeldelseTaVare",
    InnboEiendeler_AttentionMessage_PolitianmeldelseMaMeldes = "InnboEiendeler_AttentionMessage_PolitianmeldelseMaMeldes",
    InnboEiendeler_HvordanBleProduktSkadet = "InnboEiendeler_HvordanBleProduktSkadet",
    InnboEiendeler_HvorMyeBetalteDuForEiendel = "InnboEiendeler_HvorMyeBetalteDuForEiendel",
    InnboEiendeler_AnnetSykkeltilbehor_SporsmalSide = "InnboEiendeler_AnnetSykkeltilbehor_SporsmalSide",
    InnboEiendeler_AnnetSykkeltilbehor = "InnboEiendeler_AnnetSykkeltilbehor",
    InnboEiendeler_AnnetSykkeltilbehor_SporsmalList = "InnboEiendeler_AnnetSykkeltilbehor_SporsmalList",
    InnboEiendeler_HvaSomBleStjaletEllerSkadet = "InnboEiendeler_HvaSomBleStjaletEllerSkadet",
    InnboEiendeler_InformasjonOmHendelsenSporsmalSide = "InnboEiendeler_InformasjonOmHendelsenSporsmalSide",
    InnboEiendeler_VarSykkelLast = "InnboEiendeler_VarSykkelLast",
    InnboEiendeler_HvorStoSykkelen = "InnboEiendeler_HvorStoSykkelen",
    InnboEiendeler_OppgiHvorSykkelenBleStjalet = "InnboEiendeler_OppgiHvorSykkelenBleStjalet",
    InnboEiendeler_OmSykkelen_SporsmalSide = "InnboEiendeler_OmSykkelen_SporsmalSide",
    InnboEiendeler_BleFlereSyklerStjalet = "InnboEiendeler_BleFlereSyklerStjalet",
    InnboEiendeler_SykkelMerkeOgModell = "InnboEiendeler_SykkelMerkeOgModell",
    InnboEiendeler_ErSykkelenRegistrertFgGodkjentSykkelregister = "InnboEiendeler_ErSykkelenRegistrertFgGodkjentSykkelregister",
    InnboEiendeler_SykkelInformasjonSporsmalList = "InnboEiendeler_SykkelInformasjonSporsmalList",
    InnboEiendeler_AnmeldtTilPolitiet = "InnboEiendeler_AnmeldtTilPolitiet",
    InnboEiendeler_TaVarePaAnmeldelsen = "InnboEiendeler_TaVarePaAnmeldelsen",
    InnboEiendeler_DuMaMeldeTyverietTilPolitiet = "InnboEiendeler_DuMaMeldeTyverietTilPolitiet",
    Bygning_Fagperson_Telefonnummer = "Bygning_Fagperson_Telefonnummer",
    Bygning_Glasskade_MaHeleVinduetEllerDorenByttes = "Bygning_Glasskade_MaHeleVinduetEllerDorenByttes",
    Bygning_Glasskade_OppgiPrisPaUtbedringAvSkaden = "Bygning_Glasskade_OppgiPrisPaUtbedringAvSkaden",
    Bygning_Glasskade_Dokumentasjon = "Bygning_Glasskade_Dokumentasjon",
    Bygning_Glasskade_ErSkadenUtbedret_UtsattForgreining = "Bygning_Glasskade_ErSkadenUtbedret_UtsattForgreining",
    InnboEiendeler_HvaSkjeddeMedMatvarene = "InnboEiendeler_HvaSkjeddeMedMatvarene",
    Bygning_Vannskade_FagpersonFirma = "Bygning_Vannskade_FagpersonFirma",
    Dyr_Behandlingsutgifter_SporsmalSide = "Dyr_Behandlingsutgifter_SporsmalSide",
    Dyr_Behandlingsutgifter_HvilkenSykdomGjelderDet = "Dyr_Behandlingsutgifter_HvilkenSykdomGjelderDet",
    Dyr_Behandlingsutgifter_HarDyretFattBehandlingForDetteTidligere = "Dyr_Behandlingsutgifter_HarDyretFattBehandlingForDetteTidligere",
    Dyr_Behandlingsutgifter_NarVarForsteVeterinarbesok = "Dyr_Behandlingsutgifter_NarVarForsteVeterinarbesok",
    Dyr_Behandlingsutgifter_HarSkadenBlittMeldtTilForsikringsselskapTidligere = "Dyr_Behandlingsutgifter_HarSkadenBlittMeldtTilForsikringsselskapTidligere",
    Dyr_Behandlingsutgifter_HvilketForsikringsselskapErSkadenMeldtTil = "Dyr_Behandlingsutgifter_HvilketForsikringsselskapErSkadenMeldtTil",
    Dyr_Behandlingsutgifter_JournalOgFakturaOpplasting_SporsmalSide = "Dyr_Behandlingsutgifter_JournalOgFakturaOpplasting_SporsmalSide",
    Rettshjelp_Kjoretoy_InformasjonOmTvist = "Rettshjelp_Kjoretoy_InformasjonOmTvist",
    Rettshjelp_Bolig_InformasjonOmTvist = "Rettshjelp_Bolig_InformasjonOmTvist",
    Rettshjelp_Tvist_HvemMelderDuSkadenSom = "Rettshjelp_Tvist_HvemMelderDuSkadenSom",
    Rettshjelp_Tvist_HvemErDinMotpartITvist = "Rettshjelp_Tvist_HvemErDinMotpartITvist",
    Rettshjelp_Tvist_ErAdvokatEngasjert = "Rettshjelp_Tvist_ErAdvokatEngasjert",
    Rettshjelp_Tvist_HarDuMeldtSkadenTidligere = "Rettshjelp_Tvist_HarDuMeldtSkadenTidligere",
    Rettshjelp_Tvist_GiDetaljertBeskrivelseAvHvaSomHarSkjedd = "Rettshjelp_Tvist_GiDetaljertBeskrivelseAvHvaSomHarSkjedd",
    Rettshjelp_Tvist_HarDuFremsattKrav = "Rettshjelp_Tvist_HarDuFremsattKrav",
    Rettshjelp_Tvist_HvilketAdvokatFirmaErEngasjert = "Rettshjelp_Tvist_HvilketAdvokatFirmaErEngasjert",
    Rettshjelp_Tvist_NarBleAdvokatEngasjert = "Rettshjelp_Tvist_NarBleAdvokatEngasjert",
    Rettshjelp_Tvist_NarBleKravFremsatt = "Rettshjelp_Tvist_NarBleKravFremsatt",
    Rettshjelp_Tvist_VetDuHvaDenOkonomiskInteressenEr = "Rettshjelp_Tvist_VetDuHvaDenOkonomiskInteressenEr",
    Rettshjelp_Tvist_HarKravetBlittHeltEllerDelvisBestridt = "Rettshjelp_Tvist_HarKravetBlittHeltEllerDelvisBestridt",
    Rettshjelp_Tvist_OkonomiskInteresse = "Rettshjelp_Tvist_OkonomiskInteresse",
    Rettshjelp_Tvist_DatoForBestridelse = "Rettshjelp_Tvist_DatoForBestridelse",
    Rettshjelp_Fodselsnummer = "Rettshjelp_Fodselsnummer",
    Rettshjelp_Registreringsnummer = "Rettshjelp_Registreringsnummer",
    Rettshjelp_Fodselsnummer_Klient = "Rettshjelp_Fodselsnummer_Klient",
    Rettshjelp_Adresse = "Rettshjelp_Adresse",
    Rettshjelp_HarDuSignertOppdragbeskrivelse_Forsikringstaker_UtsattForgreining = "Rettshjelp_HarDuSignertOppdragbeskrivelse_Forsikringstaker_UtsattForgreining",
    Rettshjelp_MelderSomForsikringstaker_HvemErMotpart_UtsattForgreining = "Rettshjelp_MelderSomForsikringstaker_HvemErMotpart_UtsattForgreining",
    Rettshjelp_MelderSomAdvokat_HvemErMotpart_UtsattForgreining = "Rettshjelp_MelderSomAdvokat_HvemErMotpart_UtsattForgreining",
    Rettshjelp_Tvist_HvemErDinKlientsMotpartITvist = "Rettshjelp_Tvist_HvemErDinKlientsMotpartITvist",
    Rettshjelp_AdvokatMelderSkade_InfoOmEngasjertAdvokat = "Rettshjelp_AdvokatMelderSkade_InfoOmEngasjertAdvokat",
    Rettshjelp_MelderSomAdvokat_NarBleAdvokatEngasjert = "Rettshjelp_MelderSomAdvokat_NarBleAdvokatEngasjert",
    Rettshjelp_MelderSomAdvokat_HvilketAdvokatFirmaErEngasjert = "Rettshjelp_MelderSomAdvokat_HvilketAdvokatFirmaErEngasjert",
    Bygning_VelgSkadedeForsikringsobjekter_CheckboxSporsmal = "Bygning_VelgSkadedeForsikringsobjekter_CheckboxSporsmal",
    Bygning_Forsikring_ErRiktigAdresseRegistrert = "Bygning_Forsikring_ErRiktigAdresseRegistrert",
    Landbruk_Normaltap_Modal = "Landbruk_Normaltap_Modal",
    Landbruk_ProduksjonsdyrDokumentasjon_Info = "Landbruk_ProduksjonsdyrDokumentasjon_Info",
    Landbruk_InformasjonOmDyr_List = "Landbruk_InformasjonOmDyr_List",
    Landbruk_Dyr_TypeDyr = "Landbruk_Dyr_TypeDyr",
    Landbruk_Dyr_Drektig = "Landbruk_Dyr_Drektig",
    Landbruk_Dyr_Kalvingsdato = "Landbruk_Dyr_Kalvingsdato",
    Landbruk_Dyr_IdNummer = "Landbruk_Dyr_IdNummer",
    Landbruk_Dyr_Fodselsdato = "Landbruk_Dyr_Fodselsdato",
    Landbruk_Dyr_Dodsarsak = "Landbruk_Dyr_Dodsarsak",
    Landbruk_Dyr_DodAvlivningsdato = "Landbruk_Dyr_DodAvlivningsdato",
    Landbruk_Dyr_Slakteverdi = "Landbruk_Dyr_Slakteverdi",
    Landbruk_Losore_Alder = "Landbruk_Losore_Alder",
    Landbruk_Losore_HarDokumentasjonFraReparator = "Landbruk_Losore_HarDokumentasjonFraReparator",
    Landbruk_Losore_DokumentasjonNei = "Landbruk_Losore_DokumentasjonNei",
    NaringBygningsglass_Skadearsak_Sporsmalside = "NaringBygningsglass_Skadearsak_Sporsmalside",
    NaringBygningsglass_SkadedatoOgForsikring_Sporsmalside = "NaringBygningsglass_SkadedatoOgForsikring_Sporsmalside",
    NaringBygningsglass_InfoOmSkade_Sporsmalside = "NaringBygningsglass_InfoOmSkade_Sporsmalside",
    NaringBygningsglass_HvaGjelderDet = "NaringBygningsglass_HvaGjelderDet",
    NaringBygningsglass_HvorStor = "NaringBygningsglass_HvorStor",
}

export enum SporsmalKategori {
    InformasjonOmHendelsen = "InformasjonOmHendelsen",
    InformasjonOmSkaden = "InformasjonOmSkaden",
    Dokumentopplastning = "Dokumentopplastning",
    Personskade = "Personskade",
    Politianmeldelse = "Politianmeldelse",
    AndreSkader = "AndreSkader",
    StjalneEiendeler = "StjalneEiendeler",
    Skadenummer = "Skadenummer",
    Forsikring = "Forsikring",
    Forsikringsnummer = "Forsikringsnummer",
    Kontaktinformasjon = "Kontaktinformasjon",
    Sjafor = "Sjafor",
    HastighetOgFore = "HastighetOgFore",
    StjaletKjoretoy = "StjaletKjoretoy",
    SkadetKjoretoy = "SkadetKjoretoy",
    AndreInvolverteKjoretoy = "AndreInvolverteKjoretoy",
    HvilketKjoretoyVarInvolvertIHendelsen = "HvilketKjoretoyVarInvolvertIHendelsen",
    EgetKjoretoy = "EgetKjoretoy",
    Kjoretoy = "Kjoretoy",
    Verksted = "Verksted",
    ReparasjonAvSkadene = "ReparasjonAvSkadene",
    Leiebil = "Leiebil",
    SkadetElsparkesykkel = "SkadetElsparkesykkel",
    ForerAvElsparkesykkel = "ForerAvElsparkesykkel",
    SkadetBat = "SkadetBat",
    PersonerOmbordIBaten = "PersonerOmbordIBaten",
    SkadebegrensningOgTilsyn = "SkadebegrensningOgTilsyn",
    AndreInvolverteBater = "AndreInvolverteBater",
    ForerAvBaten = "ForerAvBaten",
    PolitiOgDokumentasjon = "PolitiOgDokumentasjon",
    OmBehandlingen = "OmBehandlingen",
    ForsikringOgSkadested = "ForsikringOgSkadested",
    Skadested = "Skadested",
    Stromleverandor = "Stromleverandor",
    OmEiendelen = "OmEiendelen",
    OmProduktet = "OmProduktet",
    OmMatvarene = "OmMatvarene",
    OmFryseren = "OmFryseren",
    OmSykkelen = "OmSykkelen",
    AnnetSykkeltilbehor = "AnnetSykkeltilbehor",
    Utlegg = "Utlegg",
    Billettutgifter = "Billettutgifter",
    OmReisenOgUtgifter = "OmReisenOgUtgifter",
    AndreUtgifter = "AndreUtgifter",
    DineUtgifter = "DineUtgifter",
    PIRRapport = "PIRRapport",
    OmReisegodset = "OmReisegodset",
    OpplysningerOmReisen = "OpplysningerOmReisen",
    Dodsfall = "Dodsfall",
    SykPerson = "SykPerson",
    InformasjonOmForsinketBagasje = "InformasjonOmForsinketBagasje",
    AndreForsikringer = "AndreForsikringer",
    Ansvar = "Ansvar",
    InformasjonOmTvist = "InformasjonOmTvist",
    InformasjonOmBarnet = "InformasjonOmBarnet",
    InformasjonOmEktefellePartner = "InformasjonOmEktefellePartner",
    Ettersending = "Ettersending",
    Klage = "Klage",
    KategoriSporsmalSide = "KategoriSporsmalSide",
    UbesvartSporsmal = "UbesvartSporsmal",
}

export enum SporsmalType {
    Radio = "Radio",
    Tekst = "Tekst",
    Dato = "Dato",
    Kontaktinfo = "Kontaktinfo",
    KontaktInfoInvolvert = "KontaktInfoInvolvert",
    SimpleKontaktinfo = "SimpleKontaktinfo",
    SkadelidtInfo = "SkadelidtInfo",
    Filopplasting = "Filopplasting",
    Utlegg = "Utlegg",
    Informasjon = "Informasjon",
    Blindvei = "Blindvei",
    Tall = "Tall",
    Forsikring = "Forsikring",
    SkadedatoAndForsikring = "SkadedatoAndForsikring",
    Forsikringsnummer = "Forsikringsnummer",
    ForsikringObjekterCheckbox = "ForsikringObjekterCheckbox",
    Checkbox = "Checkbox",
    Verksted = "Verksted",
    UtsattForgreining = "UtsattForgreining",
    SporsmalSide = "SporsmalSide",
    SporsmalList = "SporsmalList",
    Skadenummer = "Skadenummer",
    AttentionMessage = "AttentionMessage",
    Card = "Card",
    Postnummer = "Postnummer",
    Select = "Select",
    Kredittkortnummer = "Kredittkortnummer",
    Modal = "Modal",
}

export enum SvarId {
    BilA01_01 = "BilA01_01",
    BilA01_02 = "BilA01_02",
    MeldtSkadeMistetNokkelFlereGanger_Nei = "MeldtSkadeMistetNokkelFlereGanger_Nei",
    MeldtSkadeMistetNokkelFlereGanger_Ja = "MeldtSkadeMistetNokkelFlereGanger_Ja",
    Veihjelp_Alternativ_TrengerVeihjelp = "Veihjelp_Alternativ_TrengerVeihjelp",
    Veihjelp_Alternativ_HarHattVeihjelp = "Veihjelp_Alternativ_HarHattVeihjelp",
    Veihjelp_Alternativ_HarBetaltEllerMottattRegning = "Veihjelp_Alternativ_HarBetaltEllerMottattRegning",
    Veihjelp_Alternativ_HarIkkeBetalt = "Veihjelp_Alternativ_HarIkkeBetalt",
    Veihjelp_Alternativ_Aarsak_Utforkjoring = "Veihjelp_Alternativ_Aarsak_Utforkjoring",
    Veihjelp_Alternativ_Aarsak_Kollijson_Sammenstot_eller_Pakjorsel = "Veihjelp_Alternativ_Aarsak_Kollijson_Sammenstot_eller_Pakjorsel",
    Veihjelp_Alternativ_Aarsak_Teknisk_Feil_Pa_Bil = "Veihjelp_Alternativ_Aarsak_Teknisk_Feil_Pa_Bil",
    Veihjelp_Alternativ_Aarsak_Utelast_Fra_Bil = "Veihjelp_Alternativ_Aarsak_Utelast_Fra_Bil",
    Veihjelp_Alternativ_Aarsak_Bil_Tom_For_Drivstoff = "Veihjelp_Alternativ_Aarsak_Bil_Tom_For_Drivstoff",
    Veihjelp_Alternativ_Aarsak_Brann = "Veihjelp_Alternativ_Aarsak_Brann",
    Veihjelp_Alternativ_Aarsak_Tyveri = "Veihjelp_Alternativ_Aarsak_Tyveri",
    Veihjelp_Alternativ_Aarsak_Annen_Arsak = "Veihjelp_Alternativ_Aarsak_Annen_Arsak",
    BedriftEllerPrivat_Alternativ_Privat = "BedriftEllerPrivat_Alternativ_Privat",
    BedriftEllerPrivat_Alternativ_Bedrift = "BedriftEllerPrivat_Alternativ_Bedrift",
    JaEllerNei_Alternativ_Ja = "JaEllerNei_Alternativ_Ja",
    JaEllerNei_Alternativ_Nei = "JaEllerNei_Alternativ_Nei",
    JaEllerNeiEllerVetIkke_Alternativ_Ja = "JaEllerNeiEllerVetIkke_Alternativ_Ja",
    JaEllerNeiEllerVetIkke_Alternativ_Nei = "JaEllerNeiEllerVetIkke_Alternativ_Nei",
    JaEllerNeiEllerVetIkke_Alternativ_VetIkke = "JaEllerNeiEllerVetIkke_Alternativ_VetIkke",
    RettshjelpA01_Bil = "RettshjelpA01_Bil",
    RettshjelpA01_Bat = "RettshjelpA01_Bat",
    RettshjelpA01_Hus = "RettshjelpA01_Hus",
    RettshjelpA01_Innbo = "RettshjelpA01_Innbo",
    RettshjelpA01_Bedrift = "RettshjelpA01_Bedrift",
    RettshjelpA01_Handverker = "RettshjelpA01_Handverker",
    RettshjelpA01_Annet = "RettshjelpA01_Annet",
    KlageA01_01 = "KlageA01_01",
    KlageA01_02 = "KlageA01_02",
    Ansvar_Alternativ_Privat = "Ansvar_Alternativ_Privat",
    Ansvar_Alternativ_Bedrift = "Ansvar_Alternativ_Bedrift",
    Ansvar_Alternativ_Byggherre = "Ansvar_Alternativ_Byggherre",
    Ansvar_Alternativ_Hovedentreprenor = "Ansvar_Alternativ_Hovedentreprenor",
    Ansvar_Alternativ_Totalentreprenor = "Ansvar_Alternativ_Totalentreprenor",
    Ansvar_Alternativ_Underentreprenor = "Ansvar_Alternativ_Underentreprenor",
    Ansvar_Alternativ_Sideentreprenor = "Ansvar_Alternativ_Sideentreprenor",
    Ansvar_Alternativ_Annet = "Ansvar_Alternativ_Annet",
    Reiseavbestilling_Arsak_Sykdom = "Reiseavbestilling_Arsak_Sykdom",
    Reiseavbestilling_Arsak_Ulykke = "Reiseavbestilling_Arsak_Ulykke",
    Reiseavbestilling_Arsak_Dodsfall = "Reiseavbestilling_Arsak_Dodsfall",
    Reiseavbestilling_Arsak_SkadeBolig = "Reiseavbestilling_Arsak_SkadeBolig",
    Reiseavbestilling_Arsak_KrigTerror = "Reiseavbestilling_Arsak_KrigTerror",
    Reiseavbestilling_Arsak_Annen = "Reiseavbestilling_Arsak_Annen",
    Reiseavbestilling_Hvem_Forsikringstaker = "Reiseavbestilling_Hvem_Forsikringstaker",
    Reiseavbestilling_Hvem_EktefelleBarn = "Reiseavbestilling_Hvem_EktefelleBarn",
    Reiseavbestilling_Hvem_AndreIFamilien = "Reiseavbestilling_Hvem_AndreIFamilien",
    Reiseavbestilling_Hvem_NoenIReisefolget = "Reiseavbestilling_Hvem_NoenIReisefolget",
    Reiseavbestilling_Hvem_Andre = "Reiseavbestilling_Hvem_Andre",
    Reiseavbestilling_Jeg_Har_Betalt_Med_Kreditkort = "Reiseavbestilling_Jeg_Har_Betalt_Med_Kreditkort",
    Reiseavbestilling_Jeg_Er_Ogsa_Forsikret_Gjennom_Et_Annet = "Reiseavbestilling_Jeg_Er_Ogsa_Forsikret_Gjennom_Et_Annet",
    Reiseavbestilling_Reise_Hva_Slags_Type_Reise_Fritid = "Reiseavbestilling_Reise_Hva_Slags_Type_Reise_Fritid",
    Reiseavbestilling_Reise_Hva_Slags_Type_Reise_Jobb = "Reiseavbestilling_Reise_Hva_Slags_Type_Reise_Jobb",
    Reiseavbestilling_Reise_Hvem_Eier_Kortet_Jeg = "Reiseavbestilling_Reise_Hvem_Eier_Kortet_Jeg",
    Reiseavbestilling_Reise_Hvem_Eier_Kortet_NoenAndre = "Reiseavbestilling_Reise_Hvem_Eier_Kortet_NoenAndre",
    Reise_HvemGjelderDet_MegSelv = "Reise_HvemGjelderDet_MegSelv",
    Reise_HvemGjelderDet_EktefelleSamboerPartner = "Reise_HvemGjelderDet_EktefelleSamboerPartner",
    Reise_HvemGjelderDet_BarnUnder21 = "Reise_HvemGjelderDet_BarnUnder21",
    Reise_HvemGjelderDet_Andre = "Reise_HvemGjelderDet_Andre",
    Reise_HvemBetaltFor_MegSelv = "Reise_HvemBetaltFor_MegSelv",
    Reise_HvemBetaltFor_MegSelvOgAndre = "Reise_HvemBetaltFor_MegSelvOgAndre",
    Reise_HvemBetaltFor_Andre = "Reise_HvemBetaltFor_Andre",
    DekketGjennom_Familie = "DekketGjennom_Familie",
    DekketGjennom_ArbeidsgiverEllerOrganisasjon = "DekketGjennom_ArbeidsgiverEllerOrganisasjon",
    DekketGjennom_IngenAvDelene = "DekketGjennom_IngenAvDelene",
    Dokumentasjon_Ja = "Dokumentasjon_Ja",
    Dokumentasjon_NeiKanSkaffes = "Dokumentasjon_NeiKanSkaffes",
    Dokumentasjon_Nei = "Dokumentasjon_Nei",
    Reiseavbestilling_Reisefolge_Alternativ_2Personer = "Reiseavbestilling_Reisefolge_Alternativ_2Personer",
    Reiseavbestilling_Reisefolge_Alternativ_3Til6Personer = "Reiseavbestilling_Reisefolge_Alternativ_3Til6Personer",
    Reiseavbestilling_Reisefolge_Alternativ_FlereEnn6Personer = "Reiseavbestilling_Reisefolge_Alternativ_FlereEnn6Personer",
    ReiseAvbestilling_Reiseutgifter_RefundertKostnader_Alternativ_JaHeleBelopet = "ReiseAvbestilling_Reiseutgifter_RefundertKostnader_Alternativ_JaHeleBelopet",
    ReiseAvbestilling_Reiseutgifter_RefundertKostnader_Alternativ_JaDelerAvSummen = "ReiseAvbestilling_Reiseutgifter_RefundertKostnader_Alternativ_JaDelerAvSummen",
    ReiseAvbestilling_Reiseutgifter_RefundertKostnader_Alternativ_Nei = "ReiseAvbestilling_Reiseutgifter_RefundertKostnader_Alternativ_Nei",
    ReiseSkadetReisegods_HvorSkjeddeSkaden_PaReiseOgOppholdUtenforHjemmet = "ReiseSkadetReisegods_HvorSkjeddeSkaden_PaReiseOgOppholdUtenforHjemmet",
    ReiseSkadetReisegods_HvorSkjeddeSkaden_PaArbeidsstedOgUndervisningssted = "ReiseSkadetReisegods_HvorSkjeddeSkaden_PaArbeidsstedOgUndervisningssted",
    ReiseSkadetReisegods_HvorSkjeddeSkaden_Barnehage = "ReiseSkadetReisegods_HvorSkjeddeSkaden_Barnehage",
    ReiseSkadetReisegods_HvorSkjeddeSkaden_Hjemme = "ReiseSkadetReisegods_HvorSkjeddeSkaden_Hjemme",
    ReiseSkadetReisegods_HvordanBleEiendelenSkadet_MistetIBakken = "ReiseSkadetReisegods_HvordanBleEiendelenSkadet_MistetIBakken",
    ReiseSkadetReisegods_HvordanBleEiendelenSkadet_Vannskade = "ReiseSkadetReisegods_HvordanBleEiendelenSkadet_Vannskade",
    ReiseSkadetReisegods_HvordanBleEiendelenSkadet_Trafikkulykke = "ReiseSkadetReisegods_HvordanBleEiendelenSkadet_Trafikkulykke",
    ReiseSkadetReisegods_HvordanBleEiendelenSkadet_UnderTransport = "ReiseSkadetReisegods_HvordanBleEiendelenSkadet_UnderTransport",
    ReiseSkadetReisegods_HvordanBleEiendelenSkadet_Harverk = "ReiseSkadetReisegods_HvordanBleEiendelenSkadet_Harverk",
    ReiseSkadetReisegods_HvordanBleEiendelenSkadet_Annet = "ReiseSkadetReisegods_HvordanBleEiendelenSkadet_Annet",
    ReiseSkadetReisegods_PrisPaReparasjon_Nei = "ReiseSkadetReisegods_PrisPaReparasjon_Nei",
    ReiseSkadetReisegods_PrisPaReparasjon_JaOgReparert = "ReiseSkadetReisegods_PrisPaReparasjon_JaOgReparert",
    ReiseSkadetReisegods_PrisPaReparasjon_JaMenIkkeReparert = "ReiseSkadetReisegods_PrisPaReparasjon_JaMenIkkeReparert",
    ReiseSkadetReisegods_PrisPaReparasjon_JaMenLonnerSegIkke = "ReiseSkadetReisegods_PrisPaReparasjon_JaMenLonnerSegIkke",
    ReiseSkadetReisegods_PrisPaReparasjon_JaMenKanIkkeReapareres = "ReiseSkadetReisegods_PrisPaReparasjon_JaMenKanIkkeReapareres",
    ForsinketBagasje_Yrkesreise = "ForsinketBagasje_Yrkesreise",
    ForsinketBagasje_Fritidsreise = "ForsinketBagasje_Fritidsreise",
    ForsinketBagasje_UnderveisPaReisen = "ForsinketBagasje_UnderveisPaReisen",
    ForsinketBagasje_MittHjemmeStedNarReisenVarSlutt = "ForsinketBagasje_MittHjemmeStedNarReisenVarSlutt",
    Flere_Forsikringer_Som_Dekker_Utgifter_Ja = "Flere_Forsikringer_Som_Dekker_Utgifter_Ja",
    Flere_Forsikringer_Som_Dekker_Utgifter_Nei = "Flere_Forsikringer_Som_Dekker_Utgifter_Nei",
    ForsinketTransport_ForAvreise = "ForsinketTransport_ForAvreise",
    ForsinketTransport_EtterAvreise = "ForsinketTransport_EtterAvreise",
    ForsinketTransport_Hendelse_ForsinketPaVeiTilFlyplass = "ForsinketTransport_Hendelse_ForsinketPaVeiTilFlyplass",
    ForsinketTransport_Hendelse_FlyInnstilt = "ForsinketTransport_Hendelse_FlyInnstilt",
    ForsinketTransport_Hendelse_ForsinketMellomToFlyavgangerAvganger = "ForsinketTransport_Hendelse_ForsinketMellomToFlyavgangerAvganger",
    ForsinketTransport_Hendelse_Annet = "ForsinketTransport_Hendelse_Annet",
    ForsinketTransport_OffentligTransport = "ForsinketTransport_OffentligTransport",
    ForsinketTransport_EgetTransportmiddel = "ForsinketTransport_EgetTransportmiddel",
    ForsinketTransport_Arsak_Varforhold = "ForsinketTransport_Arsak_Varforhold",
    ForsinketTransport_Arsak_SkadeEllerFeilPaTransportmiddel = "ForsinketTransport_Arsak_SkadeEllerFeilPaTransportmiddel",
    ForsinketTransport_Arsak_Trafikkuhell = "ForsinketTransport_Arsak_Trafikkuhell",
    ForsinketTransport_Arsak_AkuttSykdom = "ForsinketTransport_Arsak_AkuttSykdom",
    ForsinketTransport_Arsak_Annet = "ForsinketTransport_Arsak_Annet",
    ForsinketTransport_ForsinkelseVarighet_UnderHalvannenTime = "ForsinketTransport_ForsinkelseVarighet_UnderHalvannenTime",
    ForsinketTransport_ForsinkelseVarighet_MellomHalvannenOgAtteTimer = "ForsinketTransport_ForsinkelseVarighet_MellomHalvannenOgAtteTimer",
    ForsinketTransport_ForsinkelseVarighet_OverAtteTimer = "ForsinketTransport_ForsinkelseVarighet_OverAtteTimer",
    ForsinketTransport_Hvem_Forsikringstaker = "ForsinketTransport_Hvem_Forsikringstaker",
    ForsinketTransport_Hvem_Partner = "ForsinketTransport_Hvem_Partner",
    ForsinketTransport_Hvem_Barn = "ForsinketTransport_Hvem_Barn",
    ForsinketTransport_Hvem_AndreIReisefolget = "ForsinketTransport_Hvem_AndreIReisefolget",
    ReisegodsTyveriHvor_Alternativ_Opphold_Utenfor_Hjemmet = "ReisegodsTyveriHvor_Alternativ_Opphold_Utenfor_Hjemmet",
    ReisegodsTyveriHvor_Alternativ_Arbeidssted_Undervisningssted = "ReisegodsTyveriHvor_Alternativ_Arbeidssted_Undervisningssted",
    ReisegodsTyveriHvor_Alternativ_Barnehage_SFO = "ReisegodsTyveriHvor_Alternativ_Barnehage_SFO",
    ReisegodsTyveriHvor_Alternativ_Hjemme = "ReisegodsTyveriHvor_Alternativ_Hjemme",
    ReisegodsTyveri_Alternativ_Utendors = "ReisegodsTyveri_Alternativ_Utendors",
    ReisegodsTyveri_Alternativ_I_Transportmiddel = "ReisegodsTyveri_Alternativ_I_Transportmiddel",
    ReisegodsTyveri_Alternativ_I_bygning_Som_Ikke_Er_Mitt_Eget_Hjem = "ReisegodsTyveri_Alternativ_I_bygning_Som_Ikke_Er_Mitt_Eget_Hjem",
    ReisegodsTyveri_Alternativ_Innsjekket_Hos_Reiseaktor = "ReisegodsTyveri_Alternativ_Innsjekket_Hos_Reiseaktor",
    ReisegodsTyveri_Alternativ_Ran = "ReisegodsTyveri_Alternativ_Ran",
    ReisegodsTyveri_Alternativ_Annet = "ReisegodsTyveri_Alternativ_Annet",
    ReisegodsTyveri_Alternativ_Personlig_Eiendeler = "ReisegodsTyveri_Alternativ_Personlig_Eiendeler",
    ReisegodsTyveri_Alternativ_Kontanter = "ReisegodsTyveri_Alternativ_Kontanter",
    ReisegodsTyveri_Alternativ_Personlig_Eiendeler_Og_Kontanter = "ReisegodsTyveri_Alternativ_Personlig_Eiendeler_Og_Kontanter",
    ReiseMistetReisegods_Mistet_IVannet = "ReiseMistetReisegods_Mistet_IVannet",
    ReiseMistetReisegods_Mistet_UnderTransport = "ReiseMistetReisegods_Mistet_UnderTransport",
    ReiseMistetReisegods_Mistet_Annet = "ReiseMistetReisegods_Mistet_Annet",
    ReiseSykdomSkadeEllerUlykke_HvordanOppstodSykdomEllerSkade_PlutseligOgUventet = "ReiseSykdomSkadeEllerUlykke_HvordanOppstodSykdomEllerSkade_PlutseligOgUventet",
    ReiseSykdomSkadeEllerUlykke_HvordanOppstodSykdomEllerSkade_ForReisensStartMenForverretSeg = "ReiseSykdomSkadeEllerUlykke_HvordanOppstodSykdomEllerSkade_ForReisensStartMenForverretSeg",
    ReiseSykdomSkadeEllerUlykke_HvordanOppstodSykdomEllerSkade_ForReisensStartOgIngenForverring = "ReiseSykdomSkadeEllerUlykke_HvordanOppstodSykdomEllerSkade_ForReisensStartOgIngenForverring",
    ReiseSykdomSkadeEllerUlykke_BleLegeOppsokt_Ja = "ReiseSykdomSkadeEllerUlykke_BleLegeOppsokt_Ja",
    ReiseSykdomSkadeEllerUlykke_BleLegeOppsokt_BleInnlagtPaSykehus = "ReiseSykdomSkadeEllerUlykke_BleLegeOppsokt_BleInnlagtPaSykehus",
    ReiseSykdomSkadeEllerUlykke_BleLegeOppsokt_AnnenBehandler = "ReiseSykdomSkadeEllerUlykke_BleLegeOppsokt_AnnenBehandler",
    ReiseSykdomSkadeEllerUlykke_BleLegeOppsokt_KunSOSInternational = "ReiseSykdomSkadeEllerUlykke_BleLegeOppsokt_KunSOSInternational",
    ReiseSykdomSkadeEllerUlykke_BleLegeOppsokt_Nei = "ReiseSykdomSkadeEllerUlykke_BleLegeOppsokt_Nei",
    ReiseSykdomSkadeEllerUlykke_NarDroDuHjemFraReisen_ForPlanlagtTid = "ReiseSykdomSkadeEllerUlykke_NarDroDuHjemFraReisen_ForPlanlagtTid",
    ReiseSykdomSkadeEllerUlykke_NarDroDuHjemFraReisen_TilPlanlagtTid = "ReiseSykdomSkadeEllerUlykke_NarDroDuHjemFraReisen_TilPlanlagtTid",
    ReiseSykdomSkadeEllerUlykke_NarDroDuHjemFraReisen_EtterPlanlagtTid = "ReiseSykdomSkadeEllerUlykke_NarDroDuHjemFraReisen_EtterPlanlagtTid",
    PersonUlykke_Alternativ_Sammenheng_Fritid = "PersonUlykke_Alternativ_Sammenheng_Fritid",
    PersonUlykke_Barnehage_Skole_Arbeid = "PersonUlykke_Barnehage_Skole_Arbeid",
    PersonUlykke_Vei_Til_Fra_Skole_Arbeid = "PersonUlykke_Vei_Til_Fra_Skole_Arbeid",
    PersonUlykke_Organisert_Idrett = "PersonUlykke_Organisert_Idrett",
    PersonskadeUforhet_Krav_UforekapitalMedForskutteringEllerUforekapitalEllerUforerente_UforekapitalMedForskuttering = "PersonskadeUforhet_Krav_UforekapitalMedForskutteringEllerUforekapitalEllerUforerente_UforekapitalMedForskuttering",
    PersonskadeUforhet_Krav_UforekapitalMedForskutteringEllerUforekapitalEllerUforerente_Uforekapital = "PersonskadeUforhet_Krav_UforekapitalMedForskutteringEllerUforekapitalEllerUforerente_Uforekapital",
    PersonskadeUforhet_Krav_UforekapitalMedForskutteringEllerUforekapitalEllerUforerente_Uforerente = "PersonskadeUforhet_Krav_UforekapitalMedForskutteringEllerUforekapitalEllerUforerente_Uforerente",
    PersonskadeUforhet_JaArbeidsavklaringspengerEllerJaVarigUforepensjonEllerNei_Alternativ_JaArbeidsavklaringspenger = "PersonskadeUforhet_JaArbeidsavklaringspengerEllerJaVarigUforepensjonEllerNei_Alternativ_JaArbeidsavklaringspenger",
    PersonskadeUforhet_JaArbeidsavklaringspengerEllerJaVarigUforepensjonEllerNei_Alternativ_JaAVarigUforepensjon = "PersonskadeUforhet_JaArbeidsavklaringspengerEllerJaVarigUforepensjonEllerNei_Alternativ_JaAVarigUforepensjon",
    PersonskadeUforhet_JaArbeidsavklaringspengerEllerJaVarigUforepensjonEllerNei_Alternativ_Nei = "PersonskadeUforhet_JaArbeidsavklaringspengerEllerJaVarigUforepensjonEllerNei_Alternativ_Nei",
    PersonskadeUforhet_SoknadStatus_UnderBehandlingEllerAvslattEllerInnvilget_Alternativ_UnderBehandling = "PersonskadeUforhet_SoknadStatus_UnderBehandlingEllerAvslattEllerInnvilget_Alternativ_UnderBehandling",
    PersonskadeUforhet_SoknadStatus_UnderBehandlingEllerAvslattEllerInnvilget_Alternativ_Avslatt = "PersonskadeUforhet_SoknadStatus_UnderBehandlingEllerAvslattEllerInnvilget_Alternativ_Avslatt",
    PersonskadeUforhet_SoknadStatus_UnderBehandlingEllerAvslattEllerInnvilget_Alternativ_Innvilget = "PersonskadeUforhet_SoknadStatus_UnderBehandlingEllerAvslattEllerInnvilget_Alternativ_Innvilget",
    PersonskadeDodsfall_Arsak_NaturligOrUlykkeOrSelvmorEllerDrapOrUkjent_Naturlig = "PersonskadeDodsfall_Arsak_NaturligOrUlykkeOrSelvmorEllerDrapOrUkjent_Naturlig",
    PersonskadeDodsfall_Arsak_NaturligOrUlykkeOrSelvmordEllerDrapEllerUkjent_Ulykke = "PersonskadeDodsfall_Arsak_NaturligOrUlykkeOrSelvmordEllerDrapEllerUkjent_Ulykke",
    PersonskadeDodsfall_Arsak_NaturligOrUlykkeOrSelvmordEllerDrapEllerUkjent_SelvmordEllerDrap = "PersonskadeDodsfall_Arsak_NaturligOrUlykkeOrSelvmordEllerDrapEllerUkjent_SelvmordEllerDrap",
    PersonskadeDodsfall_Arsak_NaturligOrUlykkeOrSelvmordEllerDrapEllerUkjent_Ukjent = "PersonskadeDodsfall_Arsak_NaturligOrUlykkeOrSelvmordEllerDrapEllerUkjent_Ukjent",
    PersonskadeDodsfall_Relasjon_EktefelleOrBegunstigetOrArvingOrAnnet_Ektefelle = "PersonskadeDodsfall_Relasjon_EktefelleOrBegunstigetOrArvingOrAnnet_Ektefelle",
    PersonskadeDodsfall_Relasjon_EktefelleOrBegunstigetOrArvingOrAnnet_Begunstiget = "PersonskadeDodsfall_Relasjon_EktefelleOrBegunstigetOrArvingOrAnnet_Begunstiget",
    PersonskadeDodsfall_Relasjon_BegunstigetOrArvingOrAnnet_Arving = "PersonskadeDodsfall_Relasjon_BegunstigetOrArvingOrAnnet_Arving",
    PersonskadeDodsfall_Relasjon_EktefelleOrBegunstigetOrArvingOrAnnet_Annet = "PersonskadeDodsfall_Relasjon_EktefelleOrBegunstigetOrArvingOrAnnet_Annet",
    PersonskadeDodsfall_SkrevetTestament_JaOrNeiOrVetIkke_Ja = "PersonskadeDodsfall_SkrevetTestament_JaOrNeiOrVetIkke_Ja",
    PersonskadeDodsfall_SkrevetTestament_JaOrNeiOrVetIkke_Nei = "PersonskadeDodsfall_SkrevetTestament_JaOrNeiOrVetIkke_Nei",
    PersonskadeDodsfall_SkrevetTestament_JaOrNeiOrVetIkke_VetIkke = "PersonskadeDodsfall_SkrevetTestament_JaOrNeiOrVetIkke_VetIkke",
    PersonskadeKritiskSykdom_Hvorfor_SykdomOrUlykke_Ulykke = "PersonskadeKritiskSykdom_Hvorfor_SykdomOrUlykke_Ulykke",
    PersonskadeKritiskSykdom_Hvorfor_SykdomOrUlykke_Sykdom = "PersonskadeKritiskSykdom_Hvorfor_SykdomOrUlykke_Sykdom",
    PersonskadeKritiskSykdom_Diagnose_Kreft = "PersonskadeKritiskSykdom_Diagnose_Kreft",
    PersonskadeKritiskSykdom_Diagnose_Hjerteinfarkt = "PersonskadeKritiskSykdom_Diagnose_Hjerteinfarkt",
    PersonskadeKritiskSykdom_Diagnose_Aortaaneurisme = "PersonskadeKritiskSykdom_Diagnose_Aortaaneurisme",
    PersonskadeKritiskSykdom_Diagnose_Hjerneslag = "PersonskadeKritiskSykdom_Diagnose_Hjerneslag",
    PersonskadeKritiskSykdom_Diagnose_MS = "PersonskadeKritiskSykdom_Diagnose_MS",
    PersonskadeKritiskSykdom_Diagnose_Bypass = "PersonskadeKritiskSykdom_Diagnose_Bypass",
    PersonskadeKritiskSykdom_Diagnose_Hjerteklaffkirurgi = "PersonskadeKritiskSykdom_Diagnose_Hjerteklaffkirurgi",
    PersonskadeKritiskSykdom_Diagnose_Nyresvikt = "PersonskadeKritiskSykdom_Diagnose_Nyresvikt",
    PersonskadeKritiskSykdom_Diagnose_GodartetSvulst = "PersonskadeKritiskSykdom_Diagnose_GodartetSvulst",
    PersonskadeKritiskSykdom_Diagnose_TransplantasjonHjerte = "PersonskadeKritiskSykdom_Diagnose_TransplantasjonHjerte",
    PersonskadeKritiskSykdom_Diagnose_Blindhet = "PersonskadeKritiskSykdom_Diagnose_Blindhet",
    PersonskadeKritiskSykdom_Diagnose_Dovhet = "PersonskadeKritiskSykdom_Diagnose_Dovhet",
    PersonskadeKritiskSykdom_Diagnose_TapAvTaleevne = "PersonskadeKritiskSykdom_Diagnose_TapAvTaleevne",
    PersonskadeKritiskSykdom_Diagnose_Brannskade = "PersonskadeKritiskSykdom_Diagnose_Brannskade",
    PersonskadeKritiskSykdom_Diagnose_Tverrsnittlammelse = "PersonskadeKritiskSykdom_Diagnose_Tverrsnittlammelse",
    PersonskadeKritiskSykdom_Diagnose_TapAvBenEllerArm = "PersonskadeKritiskSykdom_Diagnose_TapAvBenEllerArm",
    PersonskadeKritiskSykdom_Diagnose_Parkinson = "PersonskadeKritiskSykdom_Diagnose_Parkinson",
    PersonskadeKritiskSykdom_Diagnose_Alzheimer = "PersonskadeKritiskSykdom_Diagnose_Alzheimer",
    PersonskadeKritiskSykdom_Diagnose_Motornevronsykdom = "PersonskadeKritiskSykdom_Diagnose_Motornevronsykdom",
    PersonskadeKritiskSykdom_Diagnose_IngenAvDisse = "PersonskadeKritiskSykdom_Diagnose_IngenAvDisse",
    PersonskadeKritiskSykdom_SammenhengForUlykke_FritidOrArbeidOrTilFraArbeid_Fritid = "PersonskadeKritiskSykdom_SammenhengForUlykke_FritidOrArbeidOrTilFraArbeid_Fritid",
    PersonskadeKritiskSykdom_SammenhengForUlykke_FritidOrArbeidOrTilFraArbeid_Arbeid = "PersonskadeKritiskSykdom_SammenhengForUlykke_FritidOrArbeidOrTilFraArbeid_Arbeid",
    PersonskadeKritiskSykdom_SammenhengForUlykke_FritidOrArbeidOrTilFraArbeid_TilFraArbeid = "PersonskadeKritiskSykdom_SammenhengForUlykke_FritidOrArbeidOrTilFraArbeid_TilFraArbeid",
    PersonBarneOgUngdomsforsikring_Hendelse_SykdomOrSkade_Sykdom = "PersonBarneOgUngdomsforsikring_Hendelse_SykdomOrSkade_Sykdom",
    PersonBarneOgUngdomsforsikring_Hendelse_SykdomOrSkade_Skade = "PersonBarneOgUngdomsforsikring_Hendelse_SykdomOrSkade_Skade",
    PersonBarneOgUngdomsforsikringUlykke_Sammenheng_FritidOrBarnehageSkoleArbeidOrPaaVeiTilFraSkoleEllerArbeidOrOrganisertIdrett_Fritid = "PersonBarneOgUngdomsforsikringUlykke_Sammenheng_FritidOrBarnehageSkoleArbeidOrPaaVeiTilFraSkoleEllerArbeidOrOrganisertIdrett_Fritid",
    PersonBarneOgUngdomsforsikringUlykke_Sammenheng_FritidOrBarnehageSkoleArbeidOrPaaVeiTilFraSkoleEllerArbeidOrOrganisertIdrett_BarnehageSkoleArbeid = "PersonBarneOgUngdomsforsikringUlykke_Sammenheng_FritidOrBarnehageSkoleArbeidOrPaaVeiTilFraSkoleEllerArbeidOrOrganisertIdrett_BarnehageSkoleArbeid",
    PersonBarneOgUngdomsforsikringUlykke_Sammenheng_FritidOrBarnehageSkoleArbeidOrPaaVeiTilFraSkoleEllerArbeidOrOrganisertIdrett_PaaVeiTilFraSkoleEllerArbeid = "PersonBarneOgUngdomsforsikringUlykke_Sammenheng_FritidOrBarnehageSkoleArbeidOrPaaVeiTilFraSkoleEllerArbeidOrOrganisertIdrett_PaaVeiTilFraSkoleEllerArbeid",
    PersonBarneOgUngdomsforsikringUlykke_Sammenheng_FritidOrBarnehageSkoleArbeidOrPaaVeiTilFraSkoleEllerArbeidOrOrganisertIdrett_Organisert_Idrett = "PersonBarneOgUngdomsforsikringUlykke_Sammenheng_FritidOrBarnehageSkoleArbeidOrPaaVeiTilFraSkoleEllerArbeidOrOrganisertIdrett_Organisert_Idrett",
    Glasskade_Alternativ_HarEnGlasskade = "Glasskade_Alternativ_HarEnGlasskade",
    Glasskade_Alternativ_HarReparertGlasskade = "Glasskade_Alternativ_HarReparertGlasskade",
    Glasskade_Alternativ_BetaltEllerMottattRegning = "Glasskade_Alternativ_BetaltEllerMottattRegning",
    Glasskade_Alternativ_IkkeBetalt = "Glasskade_Alternativ_IkkeBetalt",
    Glasskade_Alternativ_Arsak_Steinsprut = "Glasskade_Alternativ_Arsak_Steinsprut",
    Glasskade_Alternativ_Arsak_Harverk = "Glasskade_Alternativ_Arsak_Harverk",
    Glasskade_Alternativ_Arsak_Gjenstad_I_Bilen = "Glasskade_Alternativ_Arsak_Gjenstad_I_Bilen",
    Glasskade_Alternativ_Arsak_Gjenstad_Fra_Annet_Kjoretoy = "Glasskade_Alternativ_Arsak_Gjenstad_Fra_Annet_Kjoretoy",
    Glasskade_Alternativ_Arsak_Annet = "Glasskade_Alternativ_Arsak_Annet",
    Glassskade_Alternativ_BilRuta_Skift = "Glassskade_Alternativ_BilRuta_Skift",
    Glassskade_Alternativ_Bilruta_Reparasjon = "Glassskade_Alternativ_Bilruta_Reparasjon",
    KollisjonskadePaKjoretoySkadearsak_Alternativ_UtforkjoringEllerKollisjonMedAutovernSkilt = "KollisjonskadePaKjoretoySkadearsak_Alternativ_UtforkjoringEllerKollisjonMedAutovernSkilt",
    KollisjonskadePaKjoretoySkadearsak_Alternativ_KollisjonMedHusGarasjeEl = "KollisjonskadePaKjoretoySkadearsak_Alternativ_KollisjonMedHusGarasjeEl",
    KollisjonskadePaKjoretoy_Alternativ_HvilketDyr_Radyr = "KollisjonskadePaKjoretoy_Alternativ_HvilketDyr_Radyr",
    KollisjonskadePaKjoretoy_Alternativ_HvilketDyr_Elg = "KollisjonskadePaKjoretoy_Alternativ_HvilketDyr_Elg",
    KollisjonskadePaKjoretoy_Alternativ_HvilketDyr_Hjort = "KollisjonskadePaKjoretoy_Alternativ_HvilketDyr_Hjort",
    KollisjonskadePaKjoretoy_Alternativ_HvilketDyr_SauLam = "KollisjonskadePaKjoretoy_Alternativ_HvilketDyr_SauLam",
    KollisjonskadePaKjoretoy_Alternativ_HvilketDyr_Reinsdyr = "KollisjonskadePaKjoretoy_Alternativ_HvilketDyr_Reinsdyr",
    KollisjonskadePaKjoretoy_Alternativ_HvilketDyr_AnnetDyr = "KollisjonskadePaKjoretoy_Alternativ_HvilketDyr_AnnetDyr",
    KollisjonskadePaKjoretoyVar_Alternativ_TortEllerFint = "KollisjonskadePaKjoretoyVar_Alternativ_TortEllerFint",
    KollisjonskadePaKjoretoyVar_Alternativ_Vatt = "KollisjonskadePaKjoretoyVar_Alternativ_Vatt",
    KollisjonskadePaKjoretoyVar_Alterntiv_SnoEllerIs = "KollisjonskadePaKjoretoyVar_Alterntiv_SnoEllerIs",
    KollisjonskadePaKjoretoyVar_Alternativ_Takete = "KollisjonskadePaKjoretoyVar_Alternativ_Takete",
    KollisjonskadePaKjoretoyDekk_Alternativ_Sommerdekk = "KollisjonskadePaKjoretoyDekk_Alternativ_Sommerdekk",
    KollisjonskadePaKjoretoyDekk_Alternativ_Vinterdekk = "KollisjonskadePaKjoretoyDekk_Alternativ_Vinterdekk",
    KollisjonskadePaKjoretoyDekk_Alternativ_PiggfrieVinterdekk = "KollisjonskadePaKjoretoyDekk_Alternativ_PiggfrieVinterdekk",
    KollisjonskadePaKjoretoySjafor_Alternativ_Forsikringstaker = "KollisjonskadePaKjoretoySjafor_Alternativ_Forsikringstaker",
    KollisjonskadePaKjoretoySjafor_Alternativ_En_Annen_Person = "KollisjonskadePaKjoretoySjafor_Alternativ_En_Annen_Person",
    KollisjonskadePaKjoretoySjafor_Alternativ_Ingen_Sjafor = "KollisjonskadePaKjoretoySjafor_Alternativ_Ingen_Sjafor",
    KollisjonskadePaKjoretoyKollidertMed_Alternativ_Syklist = "KollisjonskadePaKjoretoyKollidertMed_Alternativ_Syklist",
    KollisjonskadePaKjoretoyKollidertMed_Alternativ_Fotgjenger = "KollisjonskadePaKjoretoyKollidertMed_Alternativ_Fotgjenger",
    KollisjonskadePaKjoretoyKollidertMed_Alternativ_Annet = "KollisjonskadePaKjoretoyKollidertMed_Alternativ_Annet",
    KollisjonskadePaKjoretoyAnsvar_Alternativ_JegVarAnsvarlig = "KollisjonskadePaKjoretoyAnsvar_Alternativ_JegVarAnsvarlig",
    KollisjonskadePaKjoretoyAnsvar_Alternativ_DenAndrePartenVarAnsvarlig = "KollisjonskadePaKjoretoyAnsvar_Alternativ_DenAndrePartenVarAnsvarlig",
    KollisjonskadePaKjoretoyAnsvar_Alternativ_ViErUenigeOmAnsvar = "KollisjonskadePaKjoretoyAnsvar_Alternativ_ViErUenigeOmAnsvar",
    KollisjonskadePaKjoretoyAnsvar_Alternativ_VetIkkeHvemAnnenPartEr = "KollisjonskadePaKjoretoyAnsvar_Alternativ_VetIkkeHvemAnnenPartEr",
    KollisjonskadePaKjoretoyPersonSkade_Alternativ_Sjafor = "KollisjonskadePaKjoretoyPersonSkade_Alternativ_Sjafor",
    KollisjonskadePaKjoretoyPersonSkade_Alternativ_Passasjer = "KollisjonskadePaKjoretoyPersonSkade_Alternativ_Passasjer",
    KollisjonskadePaKjoretoyPersonSkade_Alternativ_PersonAnnetKjoretoy = "KollisjonskadePaKjoretoyPersonSkade_Alternativ_PersonAnnetKjoretoy",
    KollisjonskadePaKjoretoyPersonSkade_Alternativ_Fotgjenger = "KollisjonskadePaKjoretoyPersonSkade_Alternativ_Fotgjenger",
    KollisjonskadePaKjoretoyPersonSkade_Alternativ_Syklist = "KollisjonskadePaKjoretoyPersonSkade_Alternativ_Syklist",
    KollisjonskaderPaBat_Forer = "KollisjonskaderPaBat_Forer",
    KollisjonskaderPaBat_Passajer = "KollisjonskaderPaBat_Passajer",
    KollisjonskaderPaBat_PersonAnnenBat = "KollisjonskaderPaBat_PersonAnnenBat",
    KollisjonskadePaKjoretoyPersonSkade_Alternativ_SikretUnderUlykkenBilbelte = "KollisjonskadePaKjoretoyPersonSkade_Alternativ_SikretUnderUlykkenBilbelte",
    KollisjonskadePaKjoretoyPersonSkade_Alternativ_SikretUnderUlykkenKollisjonsputer = "KollisjonskadePaKjoretoyPersonSkade_Alternativ_SikretUnderUlykkenKollisjonsputer",
    KollisjonskadePaKjoretoyPersonSkade_Alternativ_SikretUnderUlykkenBarnesete = "KollisjonskadePaKjoretoyPersonSkade_Alternativ_SikretUnderUlykkenBarnesete",
    KollisjonskadePaKjoretoyPersonSkade_HvilkenMedisinskBehandling_Alternativ_Ikke = "KollisjonskadePaKjoretoyPersonSkade_HvilkenMedisinskBehandling_Alternativ_Ikke",
    KollisjonskadePaKjoretoyPersonSkade_HvilkenMedisinskBehandling_Alternativ_Fastlege = "KollisjonskadePaKjoretoyPersonSkade_HvilkenMedisinskBehandling_Alternativ_Fastlege",
    KollisjonskadePaKjoretoyPersonSkade_HvilkenMedisinskBehandling_Alternativ_Sykhus = "KollisjonskadePaKjoretoyPersonSkade_HvilkenMedisinskBehandling_Alternativ_Sykhus",
    KollisjonskadePaKjoretoyPersonSkade_HvilkenMedisinskBehandling_Alternativ_Omkommet = "KollisjonskadePaKjoretoyPersonSkade_HvilkenMedisinskBehandling_Alternativ_Omkommet",
    KollisjonskadePaKjoretoyPersonSkade_HvilkenMedisinskBehandling_Alternativ_VetIkke = "KollisjonskadePaKjoretoyPersonSkade_HvilkenMedisinskBehandling_Alternativ_VetIkke",
    KollisjonBulkingEllerHarverkPaParkertKjoretoy_Alternativ_Rygging = "KollisjonBulkingEllerHarverkPaParkertKjoretoy_Alternativ_Rygging",
    KollisjonBulkingEllerHarverkPaParkertKjoretoy_Alternativ_ApningBildor = "KollisjonBulkingEllerHarverkPaParkertKjoretoy_Alternativ_ApningBildor",
    KollisjonBulkingEllerHarverkPaParkertKjoretoy_Alternativ_Parkeringsskade = "KollisjonBulkingEllerHarverkPaParkertKjoretoy_Alternativ_Parkeringsskade",
    KollisjonBulkingEllerHarverkPaParkertKjoretoy_Alternativ_Annet = "KollisjonBulkingEllerHarverkPaParkertKjoretoy_Alternativ_Annet",
    Kollisjon_Alternativ_OverholdtIkkeVikeplikt = "Kollisjon_Alternativ_OverholdtIkkeVikeplikt",
    Kollisjon_Alternativ_RyggetPaNoen = "Kollisjon_Alternativ_RyggetPaNoen",
    Kollisjon_Alternativ_SkiftetFeltISammeKjoreretning = "Kollisjon_Alternativ_SkiftetFeltISammeKjoreretning",
    Kollisjon_Alternativ_KjortePaNoenBakfra = "Kollisjon_Alternativ_KjortePaNoenBakfra",
    Kollisjon_Alternativ_KjortePaNoenIMotsattKjoreretning = "Kollisjon_Alternativ_KjortePaNoenIMotsattKjoreretning",
    Kollisjon_Alternativ_KjortePaNoenSomStodParkert = "Kollisjon_Alternativ_KjortePaNoenSomStodParkert",
    Kollisjon_Alternativ_ApnetBildorOgSkadetAnnenBil = "Kollisjon_Alternativ_ApnetBildorOgSkadetAnnenBil",
    Kollisjon_Alternativ_Annet = "Kollisjon_Alternativ_Annet",
    BrannskadePaKjoretoy_Hendelse_Alternativ_TekniskFeil = "BrannskadePaKjoretoy_Hendelse_Alternativ_TekniskFeil",
    BrannskadePaKjoretoy_Hendelse_Alternativ_TentPa = "BrannskadePaKjoretoy_Hendelse_Alternativ_TentPa",
    BrannskadePaKjoretoy_Hendelse_Alternativ_BygningBrant = "BrannskadePaKjoretoy_Hendelse_Alternativ_BygningBrant",
    BrannskadePaKjoretoy_Hendelse_Alternativ_Annet = "BrannskadePaKjoretoy_Hendelse_Alternativ_Annet",
    BrannskadePaKjoretoy_Utbrent_Alternativ_Ja = "BrannskadePaKjoretoy_Utbrent_Alternativ_Ja",
    BrannskadePaKjoretoy_Utbrent_Alternativ_Nei = "BrannskadePaKjoretoy_Utbrent_Alternativ_Nei",
    Bat_Alternativ_BatSkrog = "Bat_Alternativ_BatSkrog",
    Bat_Alternativ_Batmotor = "Bat_Alternativ_Batmotor",
    Bat_Alternativ_Annet = "Bat_Alternativ_Annet",
    BatForer_Alternativ_Forsikringstaker = "BatForer_Alternativ_Forsikringstaker",
    BatForer_Alternativ_En_Annen_Person = "BatForer_Alternativ_En_Annen_Person",
    Bat_OverholdtIkkeVikepliktenForKryssendeBat = "Bat_OverholdtIkkeVikepliktenForKryssendeBat",
    Bat_OverholdtIkkeVikepliktenFoAnnenFartoysgruppe = "Bat_OverholdtIkkeVikepliktenFoAnnenFartoysgruppe",
    Bat_KolliderteMedEnAnnenBatBakfra = "Bat_KolliderteMedEnAnnenBatBakfra",
    Bat_KolliderteMedEnAnnenBatForfra = "Bat_KolliderteMedEnAnnenBatForfra",
    Bat_KolliderteMedMotendeBat = "Bat_KolliderteMedMotendeBat",
    Bat_BakketPaEnBat = "Bat_BakketPaEnBat",
    Bat_KolliderteMedAnnet = "Bat_KolliderteMedAnnet",
    Bat_LiteVindTilFriskBris = "Bat_LiteVindTilFriskBris",
    Bat_LitenKulingTilSterkKuling = "Bat_LitenKulingTilSterkKuling",
    Bat_LitenStormTilOrkan = "Bat_LitenStormTilOrkan",
    Bat_DenSisteUken = "Bat_DenSisteUken",
    Bat_DenSisteManeden = "Bat_DenSisteManeden",
    Bat_MerEnnManedSiden = "Bat_MerEnnManedSiden",
    Bat_HarSunketOgLiggerPaBunnenAvHavetInnsjoen = "Bat_HarSunketOgLiggerPaBunnenAvHavetInnsjoen",
    Bat_DenLiggerUnderVannMenErFortoydTilBrygga = "Bat_DenLiggerUnderVannMenErFortoydTilBrygga",
    Bat_DenlaUnderVannMenNaFlyterDenVedBrygga = "Bat_DenlaUnderVannMenNaFlyterDenVedBrygga",
    Bat_DenErHevetOgLiggerPaLand = "Bat_DenErHevetOgLiggerPaLand",
    Bat_DenErHevetOgLiggerPaEtVerksted = "Bat_DenErHevetOgLiggerPaEtVerksted",
    ingenSvar = "ingenSvar",
    PersonskadeUlykke_JegSelvForsikringstaker = "PersonskadeUlykke_JegSelvForsikringstaker",
    Personskade_SkadelidteInfo_BarnetMitt = "Personskade_SkadelidteInfo_BarnetMitt",
    Personskade_SkadelidteInfo_EktefelleEllerPartner = "Personskade_SkadelidteInfo_EktefelleEllerPartner",
    Personskade_SkadelidteInfo_AnnenForsikretPerson = "Personskade_SkadelidteInfo_AnnenForsikretPerson",
    ElsparkesykkelAnsvar_Alternativ_JegVarAnsvarlig = "ElsparkesykkelAnsvar_Alternativ_JegVarAnsvarlig",
    ElsparkesykkelAnsvar_Alternativ_DenAndrePartenVarAnsvarlig = "ElsparkesykkelAnsvar_Alternativ_DenAndrePartenVarAnsvarlig",
    ElsparkesykkelAnsvar_Alternativ_ViErUenigeOmAnsvar = "ElsparkesykkelAnsvar_Alternativ_ViErUenigeOmAnsvar",
    ElsparkesykkelHvemVarForer_Alternativ_Forsikringstaker = "ElsparkesykkelHvemVarForer_Alternativ_Forsikringstaker",
    ElsparkesykkelHvemVarForer_Alternativ_Annen = "ElsparkesykkelHvemVarForer_Alternativ_Annen",
    ElsparkesykkePersonSkade_Alternativ_Forsikringstaker = "ElsparkesykkePersonSkade_Alternativ_Forsikringstaker",
    ElsparkesykkePersonSkade_Alternativ_Annen = "ElsparkesykkePersonSkade_Alternativ_Annen",
    Bygning_Glasskade_HvaHarSkjedd_SprukketKnust = "Bygning_Glasskade_HvaHarSkjedd_SprukketKnust",
    Bygning_Glasskade_HvaHarSkjedd_PunktertEllerDugg = "Bygning_Glasskade_HvaHarSkjedd_PunktertEllerDugg",
    Bygning_Glasskade_HvaHarSkjedd_Annet = "Bygning_Glasskade_HvaHarSkjedd_Annet",
    Bygning_Glasskade_HvordanKnusteGlasset_Harverk = "Bygning_Glasskade_HvordanKnusteGlasset_Harverk",
    Bygning_Glasskade_HvordanKnusteGlasset_Innbrudd = "Bygning_Glasskade_HvordanKnusteGlasset_Innbrudd",
    Bygning_Glasskade_HvordanKnusteGlasset_Uhell = "Bygning_Glasskade_HvordanKnusteGlasset_Uhell",
    Bygning_Glasskade_HvordanKnusteGlasset_Annet = "Bygning_Glasskade_HvordanKnusteGlasset_Annet",
    Bygning_HvaErSkadet_Bolig = "Bygning_HvaErSkadet_Bolig",
    Bygning_HvaErSkadet_EiendommenTilBoligen = "Bygning_HvaErSkadet_EiendommenTilBoligen",
    Bygning_Naturskade_Naturhendelse_Vulkanutbrudd = "Bygning_Naturskade_Naturhendelse_Vulkanutbrudd",
    Bygning_Naturskade_Naturhendelse_Stormflo = "Bygning_Naturskade_Naturhendelse_Stormflo",
    Bygning_Naturskade_Naturhendelse_Meteorittnedslag = "Bygning_Naturskade_Naturhendelse_Meteorittnedslag",
    Bygning_Naturskade_Naturhendelse_Jordskjelv = "Bygning_Naturskade_Naturhendelse_Jordskjelv",
    Bygning_Naturskade_Naturhendelse_Flodbolge = "Bygning_Naturskade_Naturhendelse_Flodbolge",
    Bolig_LekkasjerOgVannskader_HvorOppdagetDuVannlekkasjen_Alternativ_BadVatrom = "Bolig_LekkasjerOgVannskader_HvorOppdagetDuVannlekkasjen_Alternativ_BadVatrom",
    Bolig_LekkasjerOgVannskader_HvorOppdagetDuVannlekkasjen_Alternativ_Kjokken = "Bolig_LekkasjerOgVannskader_HvorOppdagetDuVannlekkasjen_Alternativ_Kjokken",
    Bolig_LekkasjerOgVannskader_HvorOppdagetDuVannlekkasjen_Alternativ_Kjeller = "Bolig_LekkasjerOgVannskader_HvorOppdagetDuVannlekkasjen_Alternativ_Kjeller",
    Bolig_LekkasjerOgVannskader_HvorOppdagetDuVannlekkasjen_Alternativ_AnnetRom = "Bolig_LekkasjerOgVannskader_HvorOppdagetDuVannlekkasjen_Alternativ_AnnetRom",
    Bolig_LekkasjerOgVannskader_HvorKommerVannetFra_Alternativ_LekkasjeFraRor = "Bolig_LekkasjerOgVannskader_HvorKommerVannetFra_Alternativ_LekkasjeFraRor",
    Bolig_LekkasjerOgVannskader_HvorKommerVannetFra_Alternativ_LekkasjeFraVanntilkobletHvitevare = "Bolig_LekkasjerOgVannskader_HvorKommerVannetFra_Alternativ_LekkasjeFraVanntilkobletHvitevare",
    Bolig_LekkasjerOgVannskader_HvorKommerVannetFra_Alternativ_LekkasjeFraVarmtvannsbereder = "Bolig_LekkasjerOgVannskader_HvorKommerVannetFra_Alternativ_LekkasjeFraVarmtvannsbereder",
    Bolig_LekkasjerOgVannskader_HvorKommerVannetFra_Alternativ_Annet = "Bolig_LekkasjerOgVannskader_HvorKommerVannetFra_Alternativ_Annet",
    Bolig_LekkasjerOgVannskader_HvorKommerVannetInn_Alternativ_Hustak = "Bolig_LekkasjerOgVannskader_HvorKommerVannetInn_Alternativ_Hustak",
    Bolig_LekkasjerOgVannskader_HvorKommerVannetInn_Alternativ_Yttervegg = "Bolig_LekkasjerOgVannskader_HvorKommerVannetInn_Alternativ_Yttervegg",
    Bolig_LekkasjerOgVannskader_HvaBeskriverVannskadenBest_Alternativ_SynligVannIKjelleren = "Bolig_LekkasjerOgVannskader_HvaBeskriverVannskadenBest_Alternativ_SynligVannIKjelleren",
    Bolig_LekkasjerOgVannskader_HvaBeskriverVannskadenBest_Alternativ_FuktigGulvOgKjellervegger = "Bolig_LekkasjerOgVannskader_HvaBeskriverVannskadenBest_Alternativ_FuktigGulvOgKjellervegger",
    Bygning_HvaErSkadet_FrittstaendeProdukt = "Bygning_HvaErSkadet_FrittstaendeProdukt",
    Bygning_HvaErSkadet_FastmontertProdukt = "Bygning_HvaErSkadet_FastmontertProdukt",
    Bygning_HvaErSkadet_ElektriskAnlegg = "Bygning_HvaErSkadet_ElektriskAnlegg",
    Bygning_FastmontertProdukt_Varmepumpe = "Bygning_FastmontertProdukt_Varmepumpe",
    Bygning_FastmontertProdukt_Varmekabler = "Bygning_FastmontertProdukt_Varmekabler",
    Bygning_FastmontertProdukt_Hvitevarer = "Bygning_FastmontertProdukt_Hvitevarer",
    Bygning_FastmontertProdukt_Vannpumpe = "Bygning_FastmontertProdukt_Vannpumpe",
    Bygning_FastmontertProdukt_Annet = "Bygning_FastmontertProdukt_Annet",
    Bygning_ElektriskAnlegg_Sikringsskap = "Bygning_ElektriskAnlegg_Sikringsskap",
    Bygning_ElektriskAnlegg_Varmekabler = "Bygning_ElektriskAnlegg_Varmekabler",
    Bygning_ElektriskAnlegg_Stikkontakt = "Bygning_ElektriskAnlegg_Stikkontakt",
    Bygning_ElektriskAnlegg_Downlights = "Bygning_ElektriskAnlegg_Downlights",
    Bygning_ElektriskAnlegg_Annet = "Bygning_ElektriskAnlegg_Annet",
    Bygning_BrannskaderOgSot_Hendelse_Brannskader = "Bygning_BrannskaderOgSot_Hendelse_Brannskader",
    Bygning_BrannskaderOgSot_Hendelse_Sotskader = "Bygning_BrannskaderOgSot_Hendelse_Sotskader",
    Bygning_BrannskaderOgSot_Hendelse_Pipebrann = "Bygning_BrannskaderOgSot_Hendelse_Pipebrann",
    Bygning_BrannskaderOgSot_Hendelse_Annet = "Bygning_BrannskaderOgSot_Hendelse_Annet",
    Bygning_BrannskaderOgSot_HvorIBolig_HeleBolig = "Bygning_BrannskaderOgSot_HvorIBolig_HeleBolig",
    Bygning_BrannskaderOgSot_HvorIBolig_DelerAvBolig = "Bygning_BrannskaderOgSot_HvorIBolig_DelerAvBolig",
    Bygning_Innbrudd_SkadetDorEllerGarasjeport = "Bygning_Innbrudd_SkadetDorEllerGarasjeport",
    Bygning_Innbrudd_SkadetEllerKnustVindu = "Bygning_Innbrudd_SkadetEllerKnustVindu",
    Bygning_Innbrudd_IngenBygningsskader = "Bygning_Innbrudd_IngenBygningsskader",
    Bygning_Innbrudd_Annet = "Bygning_Innbrudd_Annet",
    Bygning_Vannskade_Lekkasje_Vannledning = "Bygning_Vannskade_Lekkasje_Vannledning",
    Bygning_Vannskade_Lekkasje_Avlopsledning = "Bygning_Vannskade_Lekkasje_Avlopsledning",
    Bygning_Vannskade_Lekkasje_VetIkke = "Bygning_Vannskade_Lekkasje_VetIkke",
    InnboEiendeler_Fryser = "InnboEiendeler_Fryser",
    InnboEiendeler_FryserOgMatvarer = "InnboEiendeler_FryserOgMatvarer",
    InnboEiendeler_Matvarer = "InnboEiendeler_Matvarer",
    InnboEiendeler_HvaSkjeddeMedFryser_FryserSluttetAFungere = "InnboEiendeler_HvaSkjeddeMedFryser_FryserSluttetAFungere",
    InnboEiendeler_HvaSkjeddeMedFryser_Strombrudd = "InnboEiendeler_HvaSkjeddeMedFryser_Strombrudd",
    InnboEiendeler_HvaSkjeddeMedFryser_LynnedslagOdelaFryseren = "InnboEiendeler_HvaSkjeddeMedFryser_LynnedslagOdelaFryseren",
    InnboEiendeler_HvaSkjeddeMedFryser_MenneskeligFeil = "InnboEiendeler_HvaSkjeddeMedFryser_MenneskeligFeil",
    InnboEiendeler_HvaSkjeddeMedFryser_Annet = "InnboEiendeler_HvaSkjeddeMedFryser_Annet",
    InnboEiendeler_TypeSkadePaFryser_FryserenErOdelagt = "InnboEiendeler_TypeSkadePaFryser_FryserenErOdelagt",
    InnboEiendeler_TypeSkadePaFryser_FryserenHarLuktskader = "InnboEiendeler_TypeSkadePaFryser_FryserenHarLuktskader",
    InnboEiendeler_TypeSkadePaFryser_FryseskapEllerFryseboks = "InnboEiendeler_TypeSkadePaFryser_FryseskapEllerFryseboks",
    InnboEiendeler_TypeSkadePaFryser_Kombiskap = "InnboEiendeler_TypeSkadePaFryser_Kombiskap",
    InnboEiendeler_FryserAlder_Under7Ar = "InnboEiendeler_FryserAlder_Under7Ar",
    InnboEiendeler_FryserAlder_Over7Ar = "InnboEiendeler_FryserAlder_Over7Ar",
    InnboEiendeler_OmMatvarer_ListeOppSelv = "InnboEiendeler_OmMatvarer_ListeOppSelv",
    InnboEiendeler_OmMatvarer_BrukeEikaSineBeregninger = "InnboEiendeler_OmMatvarer_BrukeEikaSineBeregninger",
    InnboEiendeler_OmMatvarer_LiterFryser_100 = "InnboEiendeler_OmMatvarer_LiterFryser_100",
    InnboEiendeler_OmMatvarer_LiterFryser_200 = "InnboEiendeler_OmMatvarer_LiterFryser_200",
    InnboEiendeler_OmMatvarer_LiterFryser_300 = "InnboEiendeler_OmMatvarer_LiterFryser_300",
    InnboEiendeler_OmMatvarer_LiterFryser_400 = "InnboEiendeler_OmMatvarer_LiterFryser_400",
    InnboEiendeler_OmMatvarer_LiterFryser_500 = "InnboEiendeler_OmMatvarer_LiterFryser_500",
    InnboEiendeler_OmMatvarer_LiterFryser_Over500 = "InnboEiendeler_OmMatvarer_LiterFryser_Over500",
    InnboEiendeler_OmMatvarer_LiterMatvarer_MindreEnnHalvfull = "InnboEiendeler_OmMatvarer_LiterMatvarer_MindreEnnHalvfull",
    InnboEiendeler_OmMatvarer_LiterMatvarer_Halvfull = "InnboEiendeler_OmMatvarer_LiterMatvarer_Halvfull",
    InnboEiendeler_OmMatvarer_LiterMatvarer_MerEnnHalvfull = "InnboEiendeler_OmMatvarer_LiterMatvarer_MerEnnHalvfull",
    InnboEiendeler_OmMatvarer_LiterMatvarer_Full = "InnboEiendeler_OmMatvarer_LiterMatvarer_Full",
    InnboEiendeler_OmMatvarer_Dokumentasjon_Ja = "InnboEiendeler_OmMatvarer_Dokumentasjon_Ja",
    InnboEiendeler_OmMatvarer_Dokumentasjon_NeiKanSkaffes = "InnboEiendeler_OmMatvarer_Dokumentasjon_NeiKanSkaffes",
    InnboEiendeler_OmMatvarer_Dokumentasjon_Nei = "InnboEiendeler_OmMatvarer_Dokumentasjon_Nei",
    InnboEiendeler_Dokumentasjon_JaPaNoen = "InnboEiendeler_Dokumentasjon_JaPaNoen",
    InnboEiendeler_HvorSkjeddeSkaden_Hjemme = "InnboEiendeler_HvorSkjeddeSkaden_Hjemme",
    InnboEiendeler_HvorSkjeddeSkaden_PaReise = "InnboEiendeler_HvorSkjeddeSkaden_PaReise",
    InnboEiendeler_HvorSkjeddeSkaden_PaArbeidUndervisningsstedBarnehage = "InnboEiendeler_HvorSkjeddeSkaden_PaArbeidUndervisningsstedBarnehage",
    InnboEiendeler_HvorSkjeddeSkaden_AnnetSted = "InnboEiendeler_HvorSkjeddeSkaden_AnnetSted",
    InnboEiendeler_HvordanSkadet_MistetBakkenEllerGulvet = "InnboEiendeler_HvordanSkadet_MistetBakkenEllerGulvet",
    InnboEiendeler_HvordanSkadet_VannEllerAnnenVaske = "InnboEiendeler_HvordanSkadet_VannEllerAnnenVaske",
    InnboEiendeler_HvordanSkadet_SluttetAVirke = "InnboEiendeler_HvordanSkadet_SluttetAVirke",
    InnboEiendeler_HvordanSkadet_Lynnedslag = "InnboEiendeler_HvordanSkadet_Lynnedslag",
    InnboEiendeler_HvordanSkadet_Strombrudd = "InnboEiendeler_HvordanSkadet_Strombrudd",
    InnboEiendeler_HvordanSkadet_Annet = "InnboEiendeler_HvordanSkadet_Annet",
    InnboEiendeler_TvElektriskeProdukter_SjekketGaranti_Dekker = "InnboEiendeler_TvElektriskeProdukter_SjekketGaranti_Dekker",
    InnboEiendeler_TvElektriskeProdukter_SjekketGaranti_DekkerIkke = "InnboEiendeler_TvElektriskeProdukter_SjekketGaranti_DekkerIkke",
    InnboEiendeler_TvElektriskeProdukter_SjekketGaranti_HarIkkeSjekket = "InnboEiendeler_TvElektriskeProdukter_SjekketGaranti_HarIkkeSjekket",
    InnboEiendeler_Sted_Hjemme = "InnboEiendeler_Sted_Hjemme",
    InnboEiendeler_Sted_PaReise = "InnboEiendeler_Sted_PaReise",
    InnboEiendeler_Sted_PaArbeid = "InnboEiendeler_Sted_PaArbeid",
    InnboEiendeler_Sted_AnnetSted = "InnboEiendeler_Sted_AnnetSted",
    InnboEiendeler_Produkt_Mobil = "InnboEiendeler_Produkt_Mobil",
    InnboEiendeler_Produkt_Nettbrett = "InnboEiendeler_Produkt_Nettbrett",
    InnboEiendeler_Produkt_Pc = "InnboEiendeler_Produkt_Pc",
    InnboEiendeler_PrisPaReparasjon_Nei = "InnboEiendeler_PrisPaReparasjon_Nei",
    InnboEiendeler_PrisPaReparasjon_JaOgReparert = "InnboEiendeler_PrisPaReparasjon_JaOgReparert",
    InnboEiendeler_PrisPaReparasjon_JaMenIkkeReparert = "InnboEiendeler_PrisPaReparasjon_JaMenIkkeReparert",
    InnboEiendeler_PrisPaReparasjon_JaMenLonnerSegIkke = "InnboEiendeler_PrisPaReparasjon_JaMenLonnerSegIkke",
    InnboEiendeler_PrisPaReparasjon_JaMenKanIkkeReapareres = "InnboEiendeler_PrisPaReparasjon_JaMenKanIkkeReapareres",
    InnboEiendeler_HarDuKvitteringerJa = "InnboEiendeler_HarDuKvitteringerJa",
    InnboEiendeler_HarDuKvitteringerNei = "InnboEiendeler_HarDuKvitteringerNei",
    InnboEiendeler_HarDuKvitteringerNeiMenKanEttersende = "InnboEiendeler_HarDuKvitteringerNeiMenKanEttersende",
    InnboEiendeler_MistetBakkenEllerGulvet = "InnboEiendeler_MistetBakkenEllerGulvet",
    InnboEiendeler_VannEllerAnnenVaskeskade = "InnboEiendeler_VannEllerAnnenVaskeskade",
    InnboEiendeler_HvorSkjeddeTyveriet_HjemmeAdressePrivat = "InnboEiendeler_HvorSkjeddeTyveriet_HjemmeAdressePrivat",
    InnboEiendeler_HvorSkjeddeTyveriet_UtePaMinHjemmeadresse = "InnboEiendeler_HvorSkjeddeTyveriet_UtePaMinHjemmeadresse",
    InnboEiendeler_HvorSkjeddeTyveriet_FellesarealInne = "InnboEiendeler_HvorSkjeddeTyveriet_FellesarealInne",
    InnboEiendeler_HvorSkjeddeTyveriet_FellesarealUte = "InnboEiendeler_HvorSkjeddeTyveriet_FellesarealUte",
    InnboEiendeler_HvorSkjeddeTyveriet_PaArbeidsstedEllerUndervisningssted = "InnboEiendeler_HvorSkjeddeTyveriet_PaArbeidsstedEllerUndervisningssted",
    InnboEiendeler_HvorSkjeddeTyveriet_AnnetSted = "InnboEiendeler_HvorSkjeddeTyveriet_AnnetSted",
    InnboEiendeler_Tyveri_1til5Eiendeler = "InnboEiendeler_Tyveri_1til5Eiendeler",
    InnboEiendeler_Tyveri_MerEnn5Eiendeler = "InnboEiendeler_Tyveri_MerEnn5Eiendeler",
    InnboEiendeler_Annet = "InnboEiendeler_Annet",
    InnboEiendeler_JaMedSykkellas = "InnboEiendeler_JaMedSykkellas",
    InnboEiendeler_JaBakLastDor = "InnboEiendeler_JaBakLastDor",
    InnboEiendeler_JaLastMedSykkellasBakLastDor = "InnboEiendeler_JaLastMedSykkellasBakLastDor",
    InnboEiendeler_NeiSykkelenVarUlast = "InnboEiendeler_NeiSykkelenVarUlast",
    InnboEiendeler_BygningPaHjemmeadresse = "InnboEiendeler_BygningPaHjemmeadresse",
    InnboEiendeler_UtePaHjemmeadresse = "InnboEiendeler_UtePaHjemmeadresse",
    InnboEiendeler_FellesarealInne = "InnboEiendeler_FellesarealInne",
    InnboEiendeler_FellesarealUte = "InnboEiendeler_FellesarealUte",
    InnboEiendeler_PaArbeidsstedEllerUndervisningsted = "InnboEiendeler_PaArbeidsstedEllerUndervisningsted",
    InnboEiendeler_AnnetSted = "InnboEiendeler_AnnetSted",
    InnboEiendeler_NeiBareEnSykkel = "InnboEiendeler_NeiBareEnSykkel",
    InnboEiendeler_JaToEllerFlereSykkler = "InnboEiendeler_JaToEllerFlereSykkler",
    Bygning_Glasskade_Ja_JegHarUtbedret = "Bygning_Glasskade_Ja_JegHarUtbedret",
    Bygning_Glasskade_Ja_JegHarFattTilbudPaReparasjon = "Bygning_Glasskade_Ja_JegHarFattTilbudPaReparasjon",
    Bygning_Glasskade_Nei_JegHarIkkeTattKontakt = "Bygning_Glasskade_Nei_JegHarIkkeTattKontakt",
    Bygning_Glasskade_HeleVinduetEllerDorenMaByttes = "Bygning_Glasskade_HeleVinduetEllerDorenMaByttes",
    Bygning_Glasskade_BareGlasset = "Bygning_Glasskade_BareGlasset",
    Bygning_Glasskade_VetIkkeFagpersonMaUttaleSeg = "Bygning_Glasskade_VetIkkeFagpersonMaUttaleSeg",
    Rettshjelp_MelderSom_Forsikringstaker = "Rettshjelp_MelderSom_Forsikringstaker",
    Rettshjelp_MelderSom_Advokat = "Rettshjelp_MelderSom_Advokat",
    Landbruk_HvilketDyr_Okse = "Landbruk_HvilketDyr_Okse",
    Landbruk_HvilketDyr_Kalv = "Landbruk_HvilketDyr_Kalv",
    Landbruk_HvilketDyr_Kvige = "Landbruk_HvilketDyr_Kvige",
    Landbruk_HvilketDyr_Melkeku = "Landbruk_HvilketDyr_Melkeku",
    Landbruk_HvilketDyr_Ammeku = "Landbruk_HvilketDyr_Ammeku",
    NaringTyveri_Innbrudd = "NaringTyveri_Innbrudd",
    NaringTyveri_LastSegInn = "NaringTyveri_LastSegInn",
    NaringTyveri_UtenInnbrudd = "NaringTyveri_UtenInnbrudd",
    NaringTyveri_Annet = "NaringTyveri_Annet",
    NaringTyveri_Bedrageri = "NaringTyveri_Bedrageri",
    NaringTyveri_Dokumentforfalskning = "NaringTyveri_Dokumentforfalskning",
    NaringTyveri_Tyveri = "NaringTyveri_Tyveri",
    NaringTyveri_JaAnnet = "NaringTyveri_JaAnnet",
    NaringBygningsglass_Harverk = "NaringBygningsglass_Harverk",
    NaringBygningsglass_Innbrudd = "NaringBygningsglass_Innbrudd",
    NaringBygningsglass_Punktering = "NaringBygningsglass_Punktering",
    NaringBygningsglass_Uaktsomhet = "NaringBygningsglass_Uaktsomhet",
    NaringBygningsglass_Annet = "NaringBygningsglass_Annet",
    NaringBygningsglass_Under4kvm = "NaringBygningsglass_Under4kvm",
    NaringBygningsglass_Over4kvm = "NaringBygningsglass_Over4kvm",
    InitiellVerdiForSelect = "InitiellVerdiForSelect",
}

export enum SvgCardType {
    BaatSkade = "BaatSkade",
    BilSkadet = "BilSkadet",
    Lyspare = "Lyspare",
    HjerteHender = "HjerteHender",
    DyrHund = "DyrHund",
    DyrKatt = "DyrKatt",
    DyrHest = "DyrHest",
    Ingen = "Ingen",
}

export enum TallValidationType {
    Halv = "Halv",
    Hel = "Hel",
    Udefinert = "Udefinert",
}

export enum TextInputSize {
    ExtraSmall = "ExtraSmall",
    Smaller = "Smaller",
    Small = "Small",
    Large = "Large",
}

export enum TriggeredByType {
    Radio = "Radio",
    Checkbox = "Checkbox",
    Select = "Select",
    Tall = "Tall",
    Dato = "Dato",
    Forsikring = "Forsikring",
    UtsattForgreining = "UtsattForgreining",
}

export enum UtleggType {
    WithRefusjon = "WithRefusjon",
    WithDagensPris = "WithDagensPris",
}

export enum Valideringstype {
    Kontonummer = "Kontonummer",
    Epost = "Epost",
    Fodselsnummer = "Fodselsnummer",
    Mobilnummer = "Mobilnummer",
    ValgfrittMobilnummer = "ValgfrittMobilnummer",
    ValgfrittTelefonnummer = "ValgfrittTelefonnummer",
    Pakrevd = "Pakrevd",
    Valgfritt = "Valgfritt",
    Postnummer = "Postnummer",
    Skadenummer = "Skadenummer",
}

export enum VedleggStatus {
    Ok = "Ok",
    Error = "Error",
    ErrorTotalFileSize = "ErrorTotalFileSize",
}
